{
  "ai": {
    "actions": {
      "addAttachments": "Aggiungi foto o file"
    },
    "attachments": {
      "imageAlt": "Immagine",
      "remove": "Rimuovi"
    },
    "conversation": {
      "emptyDescription": "Avvia una conversazione per vedere qui i messaggi",
      "emptyTitle": "Ancora nessun messaggio"
    },
    "core": {
      "placeholder": "Cosa vuoi sapere?",
      "stop": "Interrompi",
      "submit": "Invia",
      "uploadFiles": "Carica file"
    },
    "sources": {
      "usedCount": "{count, plural, one {{count} fonte usata} other {{count} fonti usate}}"
    },
    "tool": {
      "errorHeading": "Errore",
      "parameters": "Parametri",
      "statusAwaitingApproval": "In attesa di approvazione",
      "statusCompleted": "Completato",
      "statusDenied": "Rifiutato",
      "statusError": "Errore",
      "statusPending": "In attesa",
      "statusResponded": "Risposto",
      "statusRunning": "In esecuzione"
    }
  },

  "auth": {
    "appleNativeSheet": {
      "appleFailed": "Accesso con Apple non riuscito. Riprova tra poco.",
      "appleInvalidResponse": "Apple ha inviato una risposta che non riusciamo a leggere. Riprova.",
      "appleNotHandled": "Apple non è riuscita a gestire la richiesta di accesso. Riprova.",
      "appleNotInteractive": "Apple non è riuscita a mostrare la schermata di accesso. Riprova.",
      "appleUnavailable": "Apple non è riuscita ad avviare l’accesso. Verifica di aver effettuato l’accesso al tuo Account Apple nelle Impostazioni di iOS, poi riprova."
    },
    "appleSignInButton": {
      "continue": "Continua con Apple",
      "errorFallback": "Si è verificato un errore durante l’accesso con Apple",
      "signingIn": "Accesso in corso…"
    },
    "authScreen": {
      "confirmPasswordLabel": "Conferma password",
      "confirmPasswordPlaceholder": "Inserisci di nuovo la password",
      "errorPasswordTooShort": "La password deve avere almeno 8 caratteri",
      "errorPasswordsMismatch": "Le password non coincidono",
      "newPasswordLabel": "Nuova password",
      "newPasswordPlaceholder": "Almeno 8 caratteri",
      "passwordResetDescription": "La password è stata reimpostata.",
      "passwordResetTitle": "Password reimpostata",
      "signIn": "Accedi"
    },
    "errors": {
      "accountNotFound": "Account non trovato",
      "changeEmailDisabled": "La modifica dell’email è disattivata",
      "credentialAccountNotFound": "Account con credenziali non trovato",
      "emailAlreadyVerified": "Email già verificata",
      "emailCanNotBeUpdated": "Impossibile aggiornare l’email",
      "emailMismatch": "L’email non corrisponde",
      "emailNotVerified": "Email non verificata",
      "failedToUnlinkLastAccount": "Non puoi scollegare il tuo ultimo account",
      "invalidEmail": "Email non valida",
      "invalidEmailOrPassword": "Email o password non validi",
      "invalidOtp": "Codice OTP non valido",
      "invalidPassword": "Password non valida",
      "invalidToken": "Token non valido",
      "linkedAccountAlreadyExists": "Account collegato già esistente",
      "otpExpired": "Codice OTP scaduto",
      "passwordAlreadySet": "L’utente ha già impostato una password",
      "passwordTooLong": "Password troppo lunga",
      "passwordTooShort": "Password troppo corta",
      "sessionExpired": "Sessione scaduta. Accedi di nuovo per eseguire questa azione.",
      "sessionNotFresh": "Sessione non recente",
      "socialAccountAlreadyLinked": "Account social già collegato",
      "tokenExpired": "Token scaduto",
      "tooManyAttempts": "Troppi tentativi",
      "tooManyRequests": "Troppi tentativi. Attendi un momento e riprova.",
      "userAlreadyExists": "Utente già esistente.",
      "userAlreadyExistsUseAnotherEmail": "Utente già esistente. Usa un’altra email.",
      "userAlreadyHasPassword": "L’utente ha già una password. Inseriscila per eliminare l’account.",
      "userNotFound": "Utente non trovato"
    },
    "filingExceptionNotice": {
      "worksFromDayOne": "Messaggi degli ospiti, calendario, attività e assistente IA funzionano dal primo giorno."
    },
    "forgotPassword": {
      "backToSignIn": "Torna all’accesso",
      "codeLabel": "Codice di reimpostazione",
      "descriptionCode": "Abbiamo inviato un codice a {email}. Inseriscilo qui sotto insieme alla nuova password.",
      "descriptionEmail": "Inserisci la tua email e ti invieremo un codice di reimpostazione a 6 cifre",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.it",
      "errorCodeIncomplete": "Inserisci il codice a 6 cifre ricevuto via email",
      "errorEmailRequired": "L’email è obbligatoria",
      "resend": "Non hai ricevuto il codice? Invialo di nuovo",
      "resetting": "Reimpostazione…",
      "sendCode": "Invia codice",
      "submit": "Reimposta password",
      "titleCode": "Inserisci il codice",
      "titleEmail": "Password dimenticata"
    },
    "googleSignInButton": {
      "continue": "Continua con Google",
      "signingIn": "Accesso in corso…"
    },
    "legalConsent": {
      "agreement": "Creando un account accetti i nostri <terms>Termini di servizio</terms> e l’<privacy>Informativa sulla privacy</privacy>."
    },
    "oauthConsent": {
      "allow": "Consenti l’accesso",
      "allowing": "Autorizzazione…",
      "deny": "Rifiuta",
      "denying": "Rifiuto in corso…",
      "errorRequestInvalid": "Questa richiesta di connessione non è più valida. Chiudi questa scheda e ricollegati dalla tua app di IA.",
      "errorSessionEnded": "La tua sessione Vidimo è terminata. Accedi di nuovo, poi ricollegati dalla tua app di IA.",
      "errorUnreachable": "Impossibile raggiungere Vidimo. Controlla la connessione e riprova.",
      "expiredDescription": "Questa richiesta di connessione non è valida o è scaduta. Chiudi questa scheda e ricollegati dalla tua app di IA.",
      "expiredTitle": "Richiesta di connessione scaduta",
      "goToSignIn": "Vai all’accesso",
      "guestsDetail": "dati di contatto, stato delle comunicazioni",
      "guestsLabel": "Ospiti e registrazione",
      "loading": "Caricamento…",
      "occupancyDetail": "metriche, camere, team",
      "occupancyLabel": "Occupazione e dati della struttura",
      "importHeading": "Importazione delle tue prenotazioni esistenti",
      "importScope": "Titolari e manager possono consentire all’app di IA di copiare le prenotazioni dal tuo sistema attuale in una struttura ancora in preparazione su Vidimo. Può modificare o cancellare solo le prenotazioni importate dal tuo sistema attuale, e nulla di ciò che viene importato arriva a ospiti, canali o autorità.",
      "readOnlyHeading": "Accesso in sola lettura a",
      "readOnlyScope": "Solo ciò che il tuo ruolo vede già nell’app. Non può creare, modificare, inviare o eliminare nulla.",
      "readOnlyScopeExceptImport": "Solo ciò che il tuo ruolo vede già nell’app. A parte l’importazione delle prenotazioni descritta qui sotto, non può creare, modificare, inviare o eliminare nulla.",
      "readableItem": "<strong>{label}</strong><muted>: {detail}</muted>",
      "reservationsDetail": "prenotazioni, date, camere libere",
      "reservationsLabel": "Prenotazioni e disponibilità",
      "signInRequiredDescription": "La tua sessione Vidimo è terminata. Accedi, poi riavvia la connessione dalla tua app di IA.",
      "signInRequiredTitle": "Accesso richiesto",
      "signedInAs": "Accesso effettuato come {email}. Puoi scollegarti in qualsiasi momento da {name}.",
      "signedInAsUnnamed": "Accesso effettuato come {email}. Puoi scollegarti in qualsiasi momento dalla tua app di IA.",
      "tasksDetail": "pulizie e manutenzione",
      "tasksLabel": "Attività",
      "title": "Consentire l’accesso ai tuoi dati Vidimo?",
      "touristTaxDetail": "importi dovuti e versati",
      "touristTaxLabel": "Imposta di soggiorno e saldi",
      "wantsToConnect": "<app>{name}</app> vuole collegarsi al tuo account Vidimo.",
      "wantsToConnectUnnamed": "Un’app di IA vuole collegarsi al tuo account Vidimo."
    },
    "resetPassword": {
      "backToSignIn": "Torna all’accesso",
      "description": "Inserisci qui sotto la nuova password",
      "errorTokenMissing": "Token di reimpostazione non valido o mancante",
      "resetting": "Reimpostazione…",
      "submit": "Reimposta password",
      "title": "Reimposta password"
    },
    "signIn": {
      "description": "Inserisci la tua email per accedere al tuo account",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.it",
      "errorCredentialsRequired": "Email e password sono obbligatorie",
      "forgotPassword": "Password dimenticata?",
      "noAccount": "Non hai un account?",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci la password",
      "signUp": "Registrati",
      "signingIn": "Accesso in corso…",
      "submit": "Accedi",
      "title": "Accedi"
    },
    "signUp": {
      "creatingAccount": "Creazione dell’account…",
      "description": "Registrati per iniziare con Vidimo",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.it",
      "errorCredentialsRequired": "Email e password sono obbligatorie",
      "errorNameRequired": "Il nome visualizzato è obbligatorio",
      "errorPasswordTooShort": "La password deve avere almeno 8 caratteri",
      "haveAccount": "Hai già un account?",
      "nameLabel": "Nome visualizzato",
      "namePlaceholder": "Mario Rossi",
      "passwordHint": "Almeno 8 caratteri",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Almeno 8 caratteri",
      "signIn": "Accedi",
      "submit": "Crea account",
      "title": "Crea un account"
    },
    "socialSignIn": {
      "divider": "Oppure continua con"
    },
    "verifyEmail": {
      "backToSignIn": "Torna all’accesso",
      "continue": "Continua",
      "errorLinkExpired": "Il link di verifica è scaduto. Richiedine uno nuovo.",
      "errorLinkFailed": "Il link di verifica non ha funzionato.",
      "errorLinkInvalid": "Il link di verifica non è più valido.",
      "errorLinkNotVerified": "Il link di verifica non ha funzionato. Richiedine uno nuovo.",
      "errorNoSessionEmail": "Nessuna email utente trovata nella sessione",
      "errorNotConfirmed": "Non siamo riusciti a confermare che la tua email sia stata verificata.",
      "errorTokenMissing": "Token di verifica non valido o mancante",
      "failedTitle": "Verifica non riuscita",
      "goToSignIn": "Vai all’accesso",
      "resend": "Invia di nuovo l’email di verifica",
      "resent": "Inviata: controlla la tua casella per il nuovo link.",
      "sendAnother": "Invia un altro link",
      "successDescription": "La tua email è stata verificata. Accederai automaticamente.",
      "successTitle": "Email verificata",
      "unconfirmedDescription": "Non hai effettuato l’accesso, quindi non possiamo confermare il risultato qui. Accedi: se il link ha funzionato, la tua email è già verificata.",
      "unconfirmedTitle": "Controlla il link di verifica"
    }
  },

  "calendar": {
    "agendaData": {
      "arrival": "Arrivo",
      "balanceDue": "{amount} da saldare",
      "departure": "Partenza",
      "due": "Scadenza {date}",
      "eta": "Arrivo previsto {time}",
      "guest": "Ospite",
      "inHouse": "In casa",
      "paid": "Pagato",
      "until": "Fino al {date}"
    },
    "calendarAgendaView": {
      "arrivals": "Arrivi",
      "departures": "Partenze",
      "emptyDescription": "Nessun arrivo, partenza o ospite in casa per {date}.",
      "emptyDescriptionToday": "Nessun arrivo, partenza o ospite in casa per oggi.",
      "emptyTitle": "Niente in programma",
      "inHouse": "In casa",
      "syncing": "Sincronizzazione dell’agenda…",
      "tasksFor": "Attività per {guestName}",
      "unassigned": "Non assegnata",
      "unconfirmed": "Non confermata"
    },
    "calendarAvailabilityBand": {
      "free": "Libere",
      "freeRoomsPerNight": "Camere libere per notte",
      "roomsFree": "{count, plural, one {camera libera} other {camere libere}}",
      "spokenDatePrefix": "{date}: "
    },
    "calendarLegend": {
      "markBase": "Prezzo base",
      "markChanged": "Appena modificato",
      "markChosen": "Scelto da modificare",
      "markChosenClosed": "Scelto, non in vendita",
      "markClosed": "Non in vendita",
      "markMinStay": "Soggiorno minimo",
      "markSeason": "Da una stagione",
      "markSet": "Impostato per quella notte",
      "rates": "Tariffe",
      "reservations": "Prenotazioni",
      "tapActivity": "Chi ha modificato cosa lo trovi nelle Impostazioni della struttura, in Team, alla voce Cronologia.",
      "tapDate": "Tocca una data per modificare quella notte per ogni tipologia di unità della struttura.",
      "tapNight": "Tocca una notte per modificarla.",
      "tapOtherRow": "Tocca una notte in un’altra riga per aggiungere quella tipologia di unità.",
      "tapSpan": "Tocca una seconda notte nella stessa riga per selezionare un intervallo di notti.",
      "tasks": "Attività",
      "title": "Legenda"
    },
    "calendarPage": {
      "createFirstUnit": "Crea la tua prima unità",
      "emptyDescription": "Aggiungi un’unità alla struttura per iniziare a seguire le prenotazioni sul calendario.",
      "emptyTitle": "Ancora nessuna unità",
      "legend": "Legenda del calendario",
      "newReservation": "Nuova prenotazione",
      "newTask": "Nuova attività",
      "tasksMissingTitle": "Nel calendario mancano le attività",
      "title": "Calendario",
      "unavailableDescription": "Vidimo non riesce a caricare le unità su questo dispositivo. Tocca Riprova per ricaricare l’app.",
      "unavailableTitle": "Al momento non è possibile mostrare il calendario"
    },
    "calendarView": {
      "blockDates": "Blocca date",
      "blockingHint": "Trascina lungo la riga di una camera per bloccare le notti che vuoi chiudere. Per spostarti nel calendario, scorri sulle date o sui nomi delle camere. Per aprire un soggiorno, tocca prima «{done}».",
      "doneBlocking": "Fine blocco",
      "errorBlockFailed": "Impossibile bloccare quelle notti. Riprova.",
      "jumpToDate": "Vai a una data",
      "next": "Avanti",
      "noUnits": "Nessuna unità da mostrare",
      "previous": "Indietro",
      "staffEmptyDescription": "La vista Personale mostra le attività assegnate e le assenze di ogni membro del team.",
      "staffEmptyTitle": "Nessun membro del team da mostrare",
      "syncing": "Sincronizzazione del calendario…",
      "today": "Oggi",
      "unassignedLane": "Da assegnare",
      "unknownProperty": "Struttura sconosciuta"
    },
    "calendarViewMenu": {
      "title": "Vista",
      "triggerLabel": "Vista: {view}"
    },
    "propertyEmptyState": {
      "acceptInvitation": "Accetta invito",
      "back": "Indietro",
      "createDescription": "Configura una nuova struttura per gestire ospiti e personale.",
      "createInstead": "Crea invece una struttura",
      "createTitle": "Crea una struttura",
      "errorCreateFailed": "Impossibile creare la struttura. Riprova.",
      "getStartedDescription": "Crea una nuova struttura o unisciti a una esistente con un codice di invito.",
      "getStartedTitle": "Inizia",
      "invitedAs": "Ruolo: {role}",
      "invitedDescription": "{count, plural, one {Hai ricevuto un invito a una struttura. Accettalo per iniziare.} other {Hai ricevuto un invito a queste strutture. Accettane uno per iniziare.}}",
      "invitedTitle": "Hai un invito",
      "joinDescription": "Inserisci il codice di invito ricevuto per unirti al tuo team.",
      "joinTitle": "Unisciti a una struttura",
      "syncing": "Configurazione della struttura…",
      "syncingSlow": "Ci vuole più del solito. La struttura è configurata e comparirà appena la connessione si allinea.",
      "toastCreated": "Struttura creata"
    },
    "timelineData": {
      "away": "Assente"
    },
    "todayPage": {
      "nextDay": "Giorno successivo",
      "pickDay": "Scegli un giorno",
      "previousDay": "Giorno precedente"
    },
    "transportSelector": {
      "changeTransport": "Cambia canale",
      "menuLabel": "Seleziona canale"
    },
    "unitReadinessControl": {
      "errorUpdateFailed": "Impossibile aggiornare lo stato della camera. Riprova.",
      "hint": "Si salva mentre lo modifichi. Completare un’attività di pulizia lo imposta su Pulita e un check-out su Da pulire, tranne Fuori servizio, che puoi togliere solo tu.",
      "label": "Stato della camera",
      "outOfOrderHint": "Fuori servizio impedisce anche di assegnare nuove prenotazioni alla camera e sospende il codice della porta per chi vi soggiorna già."
    }
  },

  "checkIn": {
    "guestRegistration": {
      "anotherGuest": "un altro ospite",
      "heldByOther": "Il documento {documentNumber} risulta già associato a {holderName}."
    },
    "useRegistrationOutbox": {
      "deferred": "{count, plural, one {La registrazione di {guests} appartiene a un altro utente che ha usato questo dispositivo. Verrà inviata al suo prossimo accesso qui.} other {Le registrazioni di {guests} appartengono ad altri utenti che hanno usato questo dispositivo. Verranno inviate al loro prossimo accesso qui.}}",
      "dropped": "{count, plural, one {Impossibile inviare la registrazione di {guests}. Apri la prenotazione per correggerla.} other {Impossibile inviare le registrazioni di {guests}. Apri le prenotazioni per correggerle.}}",
      "filed": "{count, plural, one {Una registrazione ospite in sospeso è stata inviata.} other {# registrazioni ospiti in sospeso sono state inviate.}}",
      "guestsOneNameAndOthers": "{first} e {count, plural, one {un altro} other {altri #}}",
      "guestsTwoNames": "{first} e {second}",
      "guestsTwoNamesAndOthers": "{first}, {second} e {count, plural, one {un altro} other {altri #}}",
      "guestsUnnamed": "{count, plural, one {un ospite} other {# ospiti}}"
    }
  },

  "common": {
    "countryPicker": {
      "emptyLabel": "Nessun Paese trovato",
      "placeholder": "Seleziona Paese",
      "searchLabel": "Cerca Paesi"
    },
    "dateRangePicker": {
      "nights": "{nights, plural, one {# notte} other {# notti}}",
      "placeholder": "Seleziona le date"
    },
    "detailsDrawer": {
      "close": "Chiudi",
      "copyLinkLabel": "Copia il link a questa scheda",
      "edit": "Modifica"
    },
    "dialog": {
      "close": "Chiudi"
    },
    "errors": {
      "generic": "Qualcosa è andato storto. Riprova.",
      "networkUnreachable": "Nessuna connessione. Controlla la rete e riprova.",
      "subscriptionRequired": "Questa struttura non ha un abbonamento attivo: per questa operazione ne serve uno.",
      "unreadableNumber": "Inserisci un numero come {example, number}."
    },
    "insetForm": {
      "cancel": "Annulla",
      "save": "Salva",
      "saving": "Salvataggio…"
    },
    "loading": "Caricamento",
    "personCard": {
      "call": "Chiama",
      "callLabel": "Chiama {name}",
      "idOnFile": "Documento acquisito",
      "message": "Scrivi",
      "openLabel": "Apri {name}"
    },
    "phoneNumberInput": {
      "country": "Prefisso internazionale",
      "international": "Altro prefisso",
      "invalid": "Controlla il numero e scegli il paese dalla bandierina."
    },
    "picker": {
      "done": "Fine",
      "noMatches": "Nessun risultato",
      "search": "Cerca"
    }
  },

  "communications": {
    "connectRefusalDrafts": {
      "account_claimed": "Ciao, sto cercando di collegare un account che risulta già associato a un’altra struttura. Potete aiutarmi?",
      "number_claimed": "Ciao, sto cercando di collegare un numero che risulta già associato a un’altra struttura. Potete aiutarmi?",
      "property_preparing": "Ciao, vorrei collegare un canale mentre la mia struttura è ancora in preparazione. Potete aiutarmi?",
      "setup_broken": "Ciao, il collegamento di un canale si è bloccato durante la configurazione e dall’app non riesco a completarlo. Potete aiutarmi?",
      "subscription_required": "Ciao, per collegare un canale mi viene chiesto un abbonamento attivo. Potete aiutarmi?"
    },
    "activeCallView": {
      "activeCall": "Chiamata in corso",
      "hangUp": "Riaggancia",
      "minimiseCall": "Riduci chiamata",
      "mute": "Disattiva microfono",
      "roomStatus": "Camera {unitCode} · {status}",
      "speakerOff": "Vivavoce disattivato",
      "speakerOn": "Vivavoce attivo",
      "transfer": "Trasferisci",
      "unmute": "Riattiva microfono"
    },
    "aiChatListView": {
      "emptyDescription": "Avvia una nuova conversazione con il tuo assistente IA",
      "emptyTitle": "Nessuna conversazione con l’IA",
      "newChat": "Nuova chat"
    },
    "aiChatView": {
      "aiAssistant": "Assistente IA",
      "chooseProperty": "Scegli una struttura",
      "choosePropertyDescription": "L’assistente risponde per una struttura alla volta: scegli quella su cui vuoi fare domande.",
      "choosePropertyTitle": "Quale struttura?",
      "emptyDescription": "Chiedimi informazioni sugli ospiti, aggiornamenti sulle prenotazioni o attività operative",
      "emptyTitle": "Come posso aiutarti oggi?",
      "errorAmbiguousScopeDetail": "L’assistente risponde per una struttura alla volta. Scegline una dall’intestazione e chiedi di nuovo.",
      "errorAmbiguousScopeTitle": "Scegli una struttura",
      "errorEmptyScopeDetail": "Il tuo ambito non include una struttura accessibile. Allargalo dall’intestazione e riprova.",
      "errorEmptyScopeTitle": "Niente nell’ambito",
      "errorPausedDetailNative": "L’IA è inclusa con un abbonamento attivo per questa struttura.",
      "errorPausedTitle": "IA in pausa",
      "errorSend": "Impossibile inviare il messaggio. Riprova.",
      "errorTranscribe": "Impossibile trascrivere la registrazione",
      "errorUnreachableDetail": "Controlla la connessione e riprova.",
      "errorUnreachableTitle": "L’assistente non è riuscito a rispondere",
      "newChat": "Nuova chat",
      "retry": "Riprova",
      "retryTooltip": "Riprova l’ultimo messaggio",
      "suggestionCheckIns": "Mostra i check-in di oggi",
      "suggestionMaintenance": "Ci sono problemi di manutenzione?",
      "suggestionOccupancy": "Qual è stata l’occupazione del mese scorso?"
    },
    "aiMessageParts": {
      "copied": "Copiato negli appunti",
      "copyTooltip": "Copia messaggio",
      "errorCopy": "Impossibile copiare il messaggio",
      "moreActions": "Altre azioni",
      "regenerate": "Rigenera",
      "sourceFallbackTitle": "Riferimento prenotazione"
    },
    "aiPromptComposer": {
      "placeholder": "Chiedi qualsiasi cosa",
      "placeholderTranscribing": "Trascrizione…"
    },
    "callEventBubble": {
      "callEnded": "Chiamata terminata",
      "callWithDuration": "Chiamata · {duration}",
      "calling": "Chiamata in corso…",
      "incomingCall": "Chiamata in arrivo",
      "incomingCallRinging": "Chiamata in arrivo…",
      "missedCall": "Chiamata persa",
      "ongoingCall": "Chiamata in corso · {duration}",
      "outgoingCall": "Chiamata in uscita",
      "outgoingMissedCall": "Chiamata in uscita senza risposta"
    },
    "chatHeader": {
      "back": "Indietro",
      "badgeGuest": "Ospite",
      "badgeInternal": "Interna",
      "badgeSupport": "Assistenza",
      "call": "Chiama {name}",
      "linkReservation": "Collega prenotazione",
      "openReservation": "Apri prenotazione",
      "unknownName": "Sconosciuto"
    },
    "chatInputBar": {
      "placeholder": "Scrivi un messaggio…",
      "recordVoice": "Registra un messaggio vocale",
      "sendDocument": "Invia un documento",
      "sendPhotoOrVideo": "Invia una foto o un video",
      "transcribing": "Trascrizione…"
    },
    "chatItem": {
      "chatWith": "Chat con {name}",
      "noMessages": "Ancora nessun messaggio",
      "unknownName": "Sconosciuto"
    },
    "chatMessageBubble": {
      "copied": "Copiato negli appunti",
      "copyMessage": "Copia messaggio",
      "dismissReactionPicker": "Chiudi selettore reazioni",
      "errorCopy": "Impossibile copiare il messaggio",
      "messagePlaceholder": "Messaggio",
      "senderAndTime": "{sender} · {time}"
    },
    "chatView": {
      "emptyDescription": "Invia un messaggio per iniziare la conversazione",
      "emptyTitle": "Inizia una conversazione",
      "scrollToNewest": "Vai al messaggio più recente"
    },
    "chatsTabBar": {
      "ai": "IA",
      "guests": "Ospiti",
      "openDialer": "Apri tastierino",
      "staff": "Team",
      "unread": "{count, plural, one {{count} non letto} other {{count} non letti}}"
    },
    "chatsView": {
      "emptyDescription": "Scegli dall’elenco una chat con un ospite, con il team o con l’IA",
      "emptyTitle": "Seleziona una conversazione",
      "hideConversationList": "Nascondi elenco conversazioni",
      "showConversationList": "Mostra elenco conversazioni"
    },
    "deliveryErrorCopy": {
      "genericFailure": "Impossibile consegnare questo messaggio.",
      "instagramGeneric": "Impossibile inviare questa risposta su Instagram.",
      "instagramLateReplyRefused": "Non inviato: Instagram non ha ancora autorizzato Vidimo a rispondere oltre le 24 ore dall’ultimo messaggio dell’ospite.",
      "instagramNoIdentity": "Non inviato: questo ospite non è raggiungibile su Instagram.",
      "instagramNotConnected": "Non inviato: Instagram non è collegato per questa struttura. Ricollegalo in Impostazioni > Messaggistica.",
      "instagramUndeliverable": "Instagram non ha consegnato questo messaggio. L’ospite potrebbe aver bloccato l’account o eliminato la chat.",
      "instagramWindowClosed": "Non inviato: la finestra di risposta di Instagram è chiusa. L’ospite deve scrivere di nuovo.",
      "invalidNumber": "Il numero di telefono dell’ospite non sembra valido. Controlla i suoi contatti.",
      "optedOut": "L’ospite ha scelto di non ricevere messaggi da questo numero. L’invio resta bloccato finché non dà di nuovo il consenso.",
      "phoneUnreachable": "Il telefono dell’ospite non è raggiungibile: potrebbe essere spento o senza copertura. Riprova più tardi.",
      "whatsappWindowClosed": "La finestra di risposta di 24 ore di WhatsApp è chiusa. Ricontatta l’ospite con un messaggio modello approvato."
    },
    "dialerDrawer": {
      "call": "Chiama",
      "calling": "Chiamata in corso…",
      "cancel": "Annulla",
      "description": "Componi un numero o cerca un ospite esistente.",
      "errorAlreadyInCall": "Sei già in una chiamata",
      "errorCallingUnsupported": "Le chiamate sono disponibili solo nell’app mobile",
      "errorPermissionRequest": "Impossibile inviare la richiesta di autorizzazione. Riprova.",
      "errorStartCall": "Impossibile avviare la chiamata",
      "guest": "Ospite",
      "noMatches": "Nessun risultato",
      "permissionRequestSent": "Richiesta di autorizzazione inviata via WhatsApp",
      "phoneNumber": "Numero di telefono",
      "phoneNumberPlaceholder": "Inserisci il numero di telefono",
      "refusal": {
        "invalid_phone_number": "Questo numero di telefono non è valido. Inseriscilo con il prefisso internazionale, ad esempio +39.",
        "whatsapp_not_connected": "Questa struttura non ha un numero WhatsApp collegato. Collegane uno nelle Impostazioni, poi riprova."
      },
      "requestCallPermission": "Chiedi l’autorizzazione a chiamare (WhatsApp)",
      "search": "Cerca",
      "searchPlaceholder": "Cerca nome o numero",
      "sending": "Invio in corso…",
      "staff": "Team",
      "title": "Effettua una chiamata"
    },
    "entityShareCard": {
      "guestFallbackName": "Ospite",
      "kindBooking": "Prenotazione",
      "kindGuest": "Ospite",
      "kindTask": "Attività",
      "noUpcomingStay": "Nessun soggiorno in programma",
      "sharedBooking": "Ha condiviso una prenotazione",
      "sharedGuest": "Ha condiviso un ospite",
      "sharedTask": "Ha condiviso un’attività",
      "stayDates": "{checkIn} - {checkOut}",
      "unassigned": "Non assegnata",
      "unscheduled": "Senza data"
    },
    "guestChatDetails": {
      "erasedStaffSender": "Ex membro del team",
      "errorAccountLoading": "Il tuo account è ancora in caricamento: riprova tra un momento",
      "errorNoMembership": "Impossibile verificare la tua appartenenza a questa struttura",
      "errorNoProperty": "Seleziona prima una struttura",
      "errorNotSent": "Impossibile inviare il messaggio. Riprova.",
      "errorNotStarted": "Impossibile avviare questa chat. Riprova.",
      "guestFallback": "Ospite",
      "linkOnlyStaffDescription": "Gli ospiti non possono aprirlo, quindi non c’è nulla da inviare.",
      "linkOnlyStaffTitle": "Quel link funziona solo nelle chat del team",
      "linkRemovedDescription": "Funziona solo nelle chat del team, quindi l’ospite non lo vedrà.",
      "linkRemovedTitle": "Link alla scheda rimosso"
    },
    "guestChatInputBar": {
      "waitingForGuest": "In attesa di un messaggio dell’ospite"
    },
    "guestChatListView": {
      "emptyDescription": "In attesa di nuovi messaggi dagli ospiti",
      "emptyTitle": "Nessuna chat con gli ospiti",
      "fallbackName": "Ospite"
    },
    "guestChatMessageBubble": {
      "attachment": "Allegato",
      "copyErrorForSupport": "Copia l’errore per l’assistenza",
      "draftReply": "Bozza di risposta",
      "drafting": "Scrittura bozza…",
      "errorCopied": "Errore copiato per l’assistenza",
      "errorCopyFailed": "Impossibile copiare l’errore",
      "retry": "Riprova",
      "retrySendFailed": "Impossibile ritentare l’invio: riprova",
      "retryTranscriptionFailed": "Impossibile ritentare la trascrizione: riprova",
      "showOriginal": "Mostra originale",
      "showTranslation": "Mostra traduzione",
      "statusDelivered": "Consegnato",
      "statusFailed": "Non riuscito",
      "statusPending": "In attesa",
      "statusRead": "Letto",
      "statusSent": "Inviato",
      "translate": "Traduci",
      "translateMessage": "Traduci messaggio",
      "translating": "Traduzione…"
    },
    "guestChatView": {
      "draftFailed": "Impossibile preparare una bozza di risposta. Riprova.",
      "placeholderCheckingAccess": "Verifica dell’accesso…",
      "placeholderDiverted": "Rispondi via {transport}: dal canale {divertedFrom} non si può inviare",
      "placeholderLoadingChannels": "Caricamento canali…",
      "placeholderNoChannel": "Nessun canale qui può ancora inviare",
      "placeholderReply": "Rispondi all’ospite…",
      "placeholderUnreachable": "L’ospite non è raggiungibile su nessun canale",
      "voiceNoteFailed": "Impossibile inviare il messaggio vocale"
    },
    "guestChats": {
      "linkFailed": "Impossibile collegare questa conversazione alla prenotazione.",
      "refusal": {
        "chat_not_found": "Questa conversazione non esiste più.",
        "no_room": "Questa prenotazione non ha una camera a cui aggiungere un ospite.",
        "party_full": "Questa prenotazione ha già tutti gli ospiti previsti. Per aggiungere questo ospite, aumenta prima il numero di Adulti, Bambini o Neonati.",
        "reservation_not_active": "Non è più possibile aggiungere ospiti a questa prenotazione.",
        "reservation_not_found": "Questa prenotazione non esiste più."
      }
    },
    "guestDetails": {
      "age": "{age, plural, one {{age} anno} other {{age} anni}}",
      "call": "Chiama",
      "documentTypeIdCard": "Carta d’identità",
      "documentTypeOther": "Altro",
      "documentTypePassport": "Passaporto",
      "expires": "Scade il {date}",
      "guestInformation": "Informazioni sull’ospite",
      "identityDocuments": "Documenti d’identità",
      "issuedBy": "Rilasciato da {country}",
      "loadError": "Impossibile caricare il profilo di questo ospite.",
      "merge": "Unisci",
      "message": "Scrivi",
      "notFoundDescription": "Questo ospite potrebbe appartenere a una struttura non selezionata. Cambia struttura e riprova.",
      "notFoundTitle": "Ospite non trovato",
      "relatedBookings": "Prenotazioni dell’ospite"
    },
    "guestDirectoryView": {
      "allStatuses": "Tutti gli stati",
      "allUnits": "Tutte le unità",
      "arrivalDates": "Date di arrivo",
      "callGuest": "Chiama {name}",
      "clear": "Cancella",
      "emptyDescription": "Gli ospiti compaiono qui quando prenotano o fanno il check-in.",
      "emptyTitle": "Ancora nessun ospite",
      "filteredCount": "{count, plural, one {{filtered} su {count}} other {{filtered} su {count}}}",
      "guestCount": "{count, plural, one {{count} ospite} other {{count} ospiti}}",
      "noMatchesDescription": "Nessun ospite corrisponde a questi filtri.",
      "noMatchesTitle": "Nessun risultato",
      "openGuest": "Apri {name}",
      "searchPlaceholder": "Cerca nome, telefono o email…",
      "statusFilterLabel": "Filtra per stato della prenotazione",
      "syncing": "Sincronizzazione degli ospiti…",
      "title": "Ospiti",
      "unitFilterLabel": "Filtra per unità"
    },
    "guestReplyDeniedBar": {
      "cannotReply": "Con il tuo ruolo in questa struttura non puoi rispondere agli ospiti",
      "preparing": "Questa struttura è in preparazione, quindi agli ospiti risponde ancora il tuo sistema attuale"
    },
    "guestTransports": {
      "emailNotConfigured": "Il canale email non è ancora configurato.",
      "inboundOnly": "I messaggi {platform} arrivano qui, ma non è ancora possibile rispondere.",
      "instagramNotSetUp": "Instagram non è ancora configurato.",
      "smsNotConnected": "Nessun numero SMS è ancora collegato a questa struttura.",
      "smsUnavailable": "Gli SMS non sono ancora disponibili.",
      "whatsAppNotConnected": "WhatsApp non è ancora collegato a questa struttura.",
      "whatsAppSettingUp": "WhatsApp è ancora in configurazione. Di solito servono pochi minuti."
    },
    "inCallOverlay": {
      "activeCall": "Chiamata in corso",
      "expandActiveCall": "Espandi chiamata in corso",
      "hangUp": "Riaggancia",
      "mute": "Disattiva microfono",
      "speakerOff": "Vivavoce disattivato",
      "speakerOn": "Vivavoce attivo",
      "unmute": "Riattiva microfono"
    },
    "incomingCallView": {
      "accept": "Rispondi",
      "decline": "Rifiuta",
      "headerPhone": "In arrivo · Telefono",
      "headerWhatsApp": "In arrivo · WhatsApp",
      "hintCheckingInToday": "Check-in oggi",
      "hintCheckingInTomorrow": "Check-in domani",
      "hintCheckingOutToday": "Check-out oggi",
      "hintCheckingOutTomorrow": "Check-out domani",
      "hintInDays": "{count, plural, one {Tra # giorno} other {Tra # giorni}}",
      "roomStatus": "Camera {unit} · {status}",
      "roomStatusWithHint": "Camera {unit} · {status} · {hint}",
      "unknownCaller": "Chiamante sconosciuto"
    },
    "incomingStaffCallView": {
      "accept": "Rispondi",
      "decline": "Rifiuta",
      "header": "In arrivo · Interna",
      "internal": "Interna",
      "internalAtProperty": "Interna · {property}",
      "internalCall": "Chiamata interna"
    },
    "instagramWindowNotice": {
      "closed": "La finestra di risposta di Instagram è chiusa. L’ospite deve scriverti di nuovo prima che tu possa rispondere.",
      "closesOn": "Instagram chiude questa chat il {date}.",
      "neverMessaged": "Instagram consente solo risposte. L’ospite deve scriverti per primo."
    },
    "linkReservationPicker": {
      "description": "Scegli la prenotazione a cui si riferisce questa conversazione. Aggiungeremo {name} agli ospiti della prenotazione.",
      "noReservations": "Nessuna prenotazione in corso o in arrivo da collegare",
      "noSearchMatches": "Nessuna prenotazione corrisponde alla ricerca",
      "searchPlaceholder": "Cerca per ospite, riferimento o unità…",
      "title": "Collega prenotazione",
      "unnamedBooker": "Ospite senza nome"
    },
    "loadEarlierMessages": {
      "label": "Carica messaggi precedenti"
    },
    "media": {
      "tooLarge": "Il file è troppo grande. Deve essere inferiore a {max}."
    },
    "mergeGuestPickerModal": {
      "descriptionNamed": "Unisci questo ospite a un altro profilo. Seleziona il profilo di destinazione. I dati di {name} verranno aggiunti a quel profilo.",
      "descriptionUnnamed": "Unisci questo ospite a un altro profilo. Seleziona il profilo di destinazione. I dati di questo ospite verranno aggiunti a quel profilo.",
      "noOtherGuests": "Nessun altro ospite da unire",
      "noSearchMatches": "Nessun ospite corrisponde alla ricerca",
      "searchPlaceholder": "Cerca per nome dell’ospite…",
      "suggestedByAi": "Suggerito dall’IA",
      "title": "Unisci ospiti"
    },
    "messageAttachment": {
      "document": "Documento",
      "photo": "Foto",
      "photoUnavailable": "Foto non disponibile",
      "videoUnavailable": "Video non disponibile"
    },
    "messageContextMenu": {
      "dismissMenu": "Chiudi menu",
      "moreActions": "Altre azioni",
      "react": "Reagisci"
    },
    "messageReactionPicker": {
      "moreReactions": "Altre reazioni",
      "reactWith": "Reagisci con {emoji}"
    },
    "microphone": {
      "permissionMessage": "Per fare e ricevere chiamate, Vidimo deve accedere al microfono. Tocca Impostazioni e attiva Microfono.",
      "permissionTitle": "Serve l’accesso al microfono",
      "settingsGuidance": "Apri Impostazioni > App > Vidimo e attiva Microfono."
    },
    "nativeListeners": {
      "errorCallFailed": "Chiamata non riuscita. Riprova."
    },
    "reactionPills": {
      "reaction": "{count, plural, one {Reazione {emoji}, {count}} other {Reazione {emoji}, {count}}}"
    },
    "recordingErrorBar": {
      "dismiss": "Chiudi",
      "error": "Errore",
      "retry": "Riprova"
    },
    "sendAttachment": {
      "errorConnection": "Controlla la connessione e riprova.",
      "errorNotSent": "Impossibile inviare l’allegato",
      "refusal": {
        "outside_service_window": "WhatsApp consente allegati solo entro 24 ore dall’ultimo messaggio dell’ospite. Invialo via email, oppure invia un modello per riaprire la conversazione.",
        "outside_service_window_voice": "WhatsApp consente messaggi vocali solo entro 24 ore dall’ultimo messaggio dell’ospite. Invialo invece via email.",
        "oversize": "{kind, select, image {Questa foto} video {Questo video} voice {Questo messaggio vocale} other {Questo file}} pesa {size}. {transport, select, email {L’email accetta fino a {max}.} sms {Gli MMS accettano fino a {max}. Invialo invece via email.} staff {Questa chat accetta fino a {max}.} whatsapp {WhatsApp accetta fino a {max}. Invialo invece via email.} other {Questa chat accetta fino a {max}. Invialo invece via email.}}",
        "sms_no_media": "Gli SMS non possono contenere allegati. Passa questa conversazione su WhatsApp o email.",
        "unsupported_channel": "Questo canale non supporta gli allegati."
      },
      "rejectedTitle": "Impossibile inviarlo qui",
      "rejectedType": "{type} non si può inviare in una chat.",
      "rejectedUnknownType": "Questo tipo di file non si può inviare in una chat."
    },
    "staffChatDetails": {
      "groupChatFallbackName": "Chat di gruppo",
      "internal": "Interna",
      "manageMembers": "Gestisci i membri nelle impostazioni della struttura",
      "memberCount": "{count, plural, one {{count} membro} other {{count} membri}}",
      "noMembers": "Nessun membro in questa chat."
    },
    "staffChatDetailsPage": {
      "directMessageFallback": "Messaggio diretto",
      "errorNoMembership": "Impossibile verificare la tua appartenenza a questa struttura",
      "errorNoSharedProperty": "Non avete una struttura in comune",
      "errorNotSent": "Impossibile inviare il messaggio. Riprova.",
      "errorNotStarted": "Impossibile avviare questa chat. Riprova.",
      "errorSignedOut": "Accedi per inviare messaggi",
      "errorStillLoading": "Caricamento ancora in corso: riprova tra un momento",
      "staffChatFallback": "Chat del team"
    },
    "staffChatListView": {
      "emptyDescription": "Avvia una conversazione con il tuo team",
      "emptyTitle": "Nessuna chat del team"
    },
    "staffChatMessageBubble": {
      "attachmentPlaceholder": "Allegato",
      "deleteMessage": "Elimina messaggio",
      "deletedByOther": "Questo messaggio è stato eliminato",
      "deletedByYou": "Hai eliminato questo messaggio",
      "retryTranscriptionFailed": "Impossibile ritentare la trascrizione: riprova"
    },
    "staffChatView": {
      "cancel": "Annulla",
      "delete": "Elimina",
      "deleteDialogDescription": "Verrà rimosso per tutti in questa chat. La conversazione mantiene il suo posto e mostra che un messaggio è stato eliminato.",
      "deleteDialogTitle": "Eliminare questo messaggio?",
      "deleteFailed": "Impossibile eliminare il messaggio",
      "replyPlaceholder": "Rispondi a {name}…",
      "sendPlaceholder": "Invia un messaggio…",
      "voiceNoteSendFailed": "Impossibile inviare il messaggio vocale"
    },
    "staffDetails": {
      "activeTasks": "{count, plural, one {Attività in corso ({count})} other {Attività in corso ({count})}}",
      "call": "Chiama",
      "completedOn": "Completata il {date}",
      "message": "Scrivi",
      "noTasksAssigned": "Nessuna attività assegnata",
      "recentlyCompleted": "Completate di recente",
      "staffInformation": "Informazioni sul membro del team"
    },
    "suggestionActions": {
      "arrivalUpdated": "Arrivo previsto aggiornato alle {time}",
      "checkOutUpdated": "Check-out aggiornato alle {time}",
      "guestAdded": "{guestName} aggiunto alla prenotazione",
      "guestAlreadyOnBooking": "{guestName} era già nella prenotazione; ora la sua conversazione è collegata",
      "missingLink": "In questo suggerimento manca la conversazione o la prenotazione da collegare.",
      "missingTimeChange": "In questo suggerimento manca ciò che serve per applicarlo.",
      "noStayDate": "Quella prenotazione non ha una data a cui associare l’orario.",
      "noTask": "Questo suggerimento non ha un’attività da creare.",
      "rateChangeMissing": "Questo avviso non indica più la modifica a cui si riferiva.",
      "taskCreated": "Attività creata: {title}"
    },
    "suggestionCard": {
      "accept": "Accetta",
      "dismiss": "Ignora",
      "dismissLabel": "Ignora: {title}"
    },
    "supportChatDetails": {
      "errorNotSent": "Impossibile inviare il messaggio. Riprova."
    },
    "supportChatView": {
      "addPhoto": "Aggiungi una foto",
      "dictate": "Detta un messaggio",
      "dictationFailed": "Non abbiamo sentito bene. Riprova.",
      "dictationNeedsSubscription": "La dettatura richiede un abbonamento attivo. Puoi comunque scrivere.",
      "emptyDescription": "Dicci di cosa hai bisogno, nella tua lingua: scrivendo, parlando o inviando una foto. Vediamo da quale struttura e schermata ci scrivi, quindi non serve spiegarlo.",
      "emptyTitle": "Scrivi al team Vidimo",
      "photo": "Foto",
      "photoUnavailable": "Foto non disponibile",
      "placeholder": "Scrivi al team Vidimo…",
      "removePhoto": "Rimuovi foto",
      "send": "Invia",
      "showOriginal": "Mostra originale",
      "showTranslation": "Mostra traduzione",
      "stopDictating": "Interrompi dettatura",
      "supportSession": "Durante una sessione di assistenza, rispondi dal CRM.",
      "teamNameWithProperty": "Team Vidimo · {propertyName}",
      "transcribing": "Trascrizione…"
    },
    "supportReplyBanner": {
      "open": "Apri"
    },
    "transcribe": {
      "failed": "Impossibile trascrivere la registrazione. Riprova."
    },
    "transferPicker": {
      "empty": "In questa struttura non ci sono altri membri del team a cui trasferire la chiamata.",
      "title": "Trasferisci la chiamata a"
    },
    "useGuestCall": {
      "errorAlreadyInCall": "Sei già in una chiamata",
      "errorNotStarted": "Impossibile avviare la chiamata"
    },
    "useOpenChat": {
      "errorNoProperty": "Seleziona prima una struttura",
      "errorNoSharedProperty": "Non avete una struttura in comune",
      "errorNotSwitched": "Impossibile passare a quella struttura",
      "errorSelf": "Non puoi scrivere a te stesso",
      "errorStillLoading": "Caricamento ancora in corso: riprova tra un momento",
      "switched": "Struttura cambiata",
      "switchedTo": "Ora sei su {name}"
    },
    "useShareAudienceGap": {
      "one": "{name} non può aprirlo",
      "people": "{count, plural, one {{count} persona non può aprirlo} other {{count} persone non possono aprirlo}}",
      "two": "{first} e {second} non possono aprirlo"
    },
    "useVoiceRecording": {
      "micBlockedInBrowser": "L’accesso al microfono è bloccato. Consentilo nelle impostazioni del browser e riprova.",
      "micPermissionMessage": "Per registrare un messaggio vocale, Vidimo deve accedere al microfono. Tocca Impostazioni e attiva Microfono.",
      "micUnavailable": "Impossibile accedere al microfono. Controlla i permessi.",
      "transcriptionFailed": "Trascrizione non riuscita",
      "transcriptionTimedOut": "Tempo scaduto per la trascrizione. Controlla la connessione e riprova."
    },
    "voiceContext": {
      "errorNoActiveCall": "Nessuna chiamata in corso da trasferire",
      "errorNotTransferred": "Impossibile trasferire la chiamata. Riprova.",
      "errorUnsupported": "Le chiamate sono disponibili solo da mobile"
    },
    "voiceNoteAttachment": {
      "noSpeech": "Nessun parlato rilevato",
      "pause": "Metti in pausa il messaggio vocale",
      "play": "Riproduci il messaggio vocale",
      "seek": "Scorri il messaggio vocale",
      "transcribing": "Trascrizione…",
      "transcript": "Trascrizione",
      "transcriptUnavailable": "Trascrizione non disponibile",
      "tryAgain": "Riprova"
    }
  },

  "connect": {
    "connectScreen": {
      "contactSupport": "Contatta l’assistenza",
      "returnToVidimo": "Torna a Vidimo"
    },
    "instagramConnectResult": {
      "cancelled": {
        "detail": "Il collegamento è stato annullato. Puoi ricominciare da Vidimo quando vuoi.",
        "title": "Instagram non collegato"
      },
      "connected": {
        "detail": "Il tuo feed e i messaggi diretti sono pronti. Torna su Vidimo per continuare da qui.",
        "title": "Instagram collegato"
      },
      "connectedElsewhere": {
        "detail": "Questo account Instagram è già collegato a un’altra struttura. Scollegalo prima da lì, oppure collega un altro account.",
        "title": "Già collegato altrove"
      },
      "expired": {
        "detail": "Questo link di collegamento non è più valido. Ricomincia dall’app Vidimo.",
        "title": "Link scaduto"
      },
      "failed": {
        "detail": "Qualcosa è andato storto durante il collegamento. Riprova dall’app Vidimo.",
        "title": "Instagram non collegato"
      },
      "invalidLink": {
        "detail": "In questo link di collegamento mancano alcune informazioni. Ricomincia dall’app Vidimo.",
        "title": "Link non valido"
      },
      "subscriptionRequired": {
        "detail": "Per collegare un canale serve un abbonamento attivo.",
        "title": "Abbonamento richiesto"
      }
    },
    "whatsappConnect": {
      "expiredBody": "Per sicurezza questi link di collegamento sono validi solo per poco tempo, e questo è scaduto. Torna su Vidimo e ricomincia dalla scheda WhatsApp in Messaggistica. Nella tua struttura non è cambiato nulla.",
      "expiredTitle": "Link scaduto",
      "failedBody": "Non siamo riusciti a caricare la configurazione di WhatsApp. Riprova, oppure ricomincia dall’app Vidimo.",
      "failedTitle": "Qualcosa è andato storto",
      "loading": "Caricamento…",
      "noNumberBody": "Torna su Vidimo, inserisci il tuo numero WhatsApp nella scheda WhatsApp in Messaggistica, poi collega di nuovo WhatsApp. Se la scheda non te lo chiede, prima chiudi e riapri Vidimo per aggiornare l’app. Nella tua struttura non è cambiato nulla.",
      "noNumberTitle": "Inserisci il numero in Vidimo",
      "openFromApp": "Questa pagina si può aprire solo dall’app Vidimo.",
      "title": "Collega WhatsApp",
      "tryAgain": "Riprova",
      "unavailableBody": "Il collegamento WhatsApp non è configurato in questo ambiente.",
      "unavailableTitle": "Non disponibile qui"
    },
    "whatsappEmbeddedSignup": {
      "buttonContinue": "Continua con Facebook",
      "buttonFinishing": "Completamento della configurazione…",
      "buttonInPopup": "Continua nella finestra popup…",
      "buttonLoading": "Caricamento…",
      "buttonTryAgain": "Riprova",
      "cancelled": "La registrazione è stata annullata. Puoi ricominciare quando vuoi.",
      "closeAnytime": "Puoi chiudere questa finestra in qualsiasi momento. Nella tua struttura non cambia nulla finché la configurazione di WhatsApp non è completata.",
      "errorConnectFailed": "Non siamo riusciti a completare il collegamento di WhatsApp. Nella tua struttura non è cambiato nulla. Riprova.",
      "errorNoAccount": "Impossibile leggere il tuo account WhatsApp da Meta. Riprova.",
      "errorUnconfirmed": "Non siamo riusciti a confermare che WhatsApp sia collegato. Prima di riprovare, controlla in Vidimo Impostazioni > Messaggistica.",
      "expiredBody": "Questo link di collegamento è scaduto prima della fine della registrazione. Torna su Vidimo e ricomincia dalla scheda WhatsApp in Messaggistica. Nella tua struttura non è cambiato nulla.",
      "introConnect": "Stai per configurare la messaggistica WhatsApp Business sul numero <number>{phone}</number> per <name>{property}</name>. La procedura guidata di Meta richiede qualche minuto e si apre in una finestra popup.",
      "introReconnect": "Il collegamento WhatsApp di <name>{property}</name> sul numero <number>{phone}</number> va confermato di nuovo. La procedura guidata di Meta richiede qualche minuto e si apre in una finestra popup.",
      "nextStepCheck": "WhatsApp verifica il tuo numero. Di solito servono pochi minuti.",
      "nextStepCode": "Se WhatsApp ti invia un codice via SMS o chiamata, inseriscilo nella scheda WhatsApp in Messaggistica.",
      "nextStepsHeading": "Cosa succede ora",
      "pendingBody": "WhatsApp sta configurando il numero per {property}.",
      "pendingTitle": "Tutto pronto, al resto pensiamo noi",
      "reload": "Ricarica",
      "sdkUnavailableBody": "Se usi un blocco contenuti, disattivalo per questa pagina e ricaricala. Nella tua struttura non è cambiato nulla.",
      "sdkUnavailableTitle": "La registrazione di Meta non si è caricata",
      "stepConfirmCode": "Conferma il codice di verifica che Meta invia a quel numero. Se arriva dopo che hai chiuso questa pagina, inseriscilo nell’app Vidimo.",
      "stepPickAccount": "Scegli o crea il tuo account WhatsApp Business e aggiungi questo stesso numero. Il numero resta tuo, senza bisogno di portabilità.",
      "stepSignIn": "Accedi con l’account Facebook che gestisce (o gestirà) la tua attività.",
      "successBody": "Il tuo numero WhatsApp Business ora è collegato a {property}.",
      "successTitle": "WhatsApp collegato",
      "thisProperty": "questa struttura",
      "titleReconnect": "Ricollega WhatsApp"
    }
  },

  "labels": {
    "balanceDue": "{amount} da saldare",
    "blockReason": {
      "maintenance": "Manutenzione",
      "manual": "Chiusa manualmente",
      "owner": "Soggiorno del proprietario"
    },
    "blockReasonUnknown": "Chiusa",
    "callStatus": {
      "connected": "Connesso",
      "connecting": "Connessione…",
      "reconnecting": "Riconnessione…",
      "ringing": "Squilla…"
    },
    "cancellationPolicyDescription": {
      "flexible": "Cancellazione gratuita fino a 1 giorno prima del check-in.",
      "moderate": "Cancellazione gratuita fino a 5 giorni prima del check-in.",
      "non_refundable": "Questa prenotazione non è rimborsabile.",
      "strict": "Cancellazione gratuita fino a 14 giorni prima del check-in."
    },
    "cleaningKind": {
      "post-checkout": "Dopo il check-out",
      "pre-checkin-refresh": "Ripasso pre-arrivo",
      "turnover": "Cambio ospite"
    },
    "drawerTitle": {
      "breakfast-service": "Colazione",
      "guest": "Ospite",
      "reservation-unit": "Prenotazione",
      "staff": "Membro del team",
      "staff-chat": "Partecipanti alla chat",
      "task": "Attività"
    },
    "guestIdentity": {
      "detail": {
        "authorityRejected": "L’autorità ha respinto i dati",
        "filedOtherYourself": "Hai inviato tu l’altra comunicazione",
        "noAutomaticFiling": "Vidimo non invia questa comunicazione",
        "otherFacility": "Inviato con un altro numero RNO",
        "reconnectCredentials": "Le credenziali per l’invio vanno ricollegate",
        "savedNeverFiled": "Salvato nei dati dell’ospite, mai inviato",
        "typedNeverScanned": "Inserito a mano, mai scansionato"
      },
      "status": {
        "actionNeeded": "Intervento richiesto",
        "fileManually": "Da inviare a mano",
        "filedByYou": "Inviato da te",
        "filing": "Invio in corso",
        "idNotScanned": "Documento non scansionato",
        "idOnFile": "Documento acquisito",
        "noIdOnFile": "Nessun documento acquisito",
        "notFiledYet": "Non ancora inviato",
        "registered": "Registrato",
        "rejected": "Respinto",
        "reportCancelled": "Comunicazione annullata",
        "submitted": "Inviato"
      }
    },
    "mealInclusion": {
      "complimentary": "Omaggio",
      "included": "Inclusa nella tariffa"
    },
    "mealPlace": {
      "breakfast_area": "Sala colazione",
      "in_room": "In camera",
      "takeaway_box": "Box da asporto"
    },
    "regimeException": {
      "alloggiati-web": "Vidimo raccoglie al check-in i dati di ogni ospite per Alloggiati Web, ma non può ancora compilare né inviare la comunicazione ISTAT; l’invio automatico ad Alloggiati Web è in sviluppo.",
      "declaration-meuble-de-tourisme": "Vidimo non presenta per te la dichiarazione del tuo meublé de tourisme.",
      "eturizem": "Vidimo predispone le tue comunicazioni eTurizem. L’invio automatico ad AJPES è ancora in sviluppo.",
      "evisitor": "Vidimo non può ancora registrare per te gli ospiti in eVisitor.",
      "imposta-di-soggiorno": "Vidimo non calcola ancora l’imposta di soggiorno del tuo Comune.",
      "istat-ross-1000": "Vidimo non può ancora compilare né inviare alla tua Regione la comunicazione ISTAT.",
      "ses-hospedajes": "Vidimo non può ancora inviare al posto tuo le comunicazioni a SES.Hospedajes.",
      "siba": "Vidimo non può ancora inviare al posto tuo le schede a SIBA."
    },
    "registrationCredentialField": {
      "alloggiati_web": {
        "idAppartamento": "ID appartamento",
        "password": "Password",
        "username": "Nome utente",
        "wskey": "Chiave web service (WS Key)"
      },
      "eturizem": {
        "certificate": "Certificato digitale (.p12 / KDP)",
        "certificatePassword": "Passphrase del certificato",
        "password": "Password del portale AJPES",
        "rno": "Numero RNO",
        "username": "Nome utente del portale AJPES"
      },
      "evisitor": {
        "password": "Password",
        "username": "Nome utente"
      },
      "istat": {
        "password": "Password",
        "structureCode": "Codice struttura",
        "username": "Nome utente"
      },
      "ses_hospedajes": {
        "clientCertificate": "Certificato client SSL",
        "clientCertificatePassword": "Passphrase del certificato",
        "password": "Password",
        "username": "Nome utente web service"
      },
      "siba": {
        "accessKey": "Chiave di accesso (Chave de Acesso)",
        "establishment": "Numero dello stabilimento",
        "nipc": "Codice fiscale (NIPC)"
      }
    },
    "registrationCredentialHelp": {
      "alloggiati_web": {
        "idAppartamento": "Solo se gestisci più unità con un unico account.",
        "username": "Rilasciato dalla Questura competente.",
        "wskey": "Si genera dentro Alloggiati Web. A ogni cambio password ne serve una nuova, e se ne può generare solo una al giorno."
      },
      "eturizem": {
        "certificate": "Certificato digitale qualificato sloveno rilasciato alla tua attività.",
        "certificatePassword": "Lascia vuoto se il certificato non ha una passphrase.",
        "rno": "Il numero identificativo che AJPES ha assegnato a questa struttura nel registro delle strutture ricettive (RNO). Solo cifre.",
        "username": "Il nome utente (uporabniško ime) con cui accedi al portale AJPES, non il tuo indirizzo email. AJPES non accetta un’email in questo campo. Lo trovi in alto a destra nel portale dopo l’accesso."
      },
      "evisitor": {
        "username": "Rilasciato dall’ente turistico locale."
      },
      "istat": {
        "structureCode": "Il codice che la Regione ha assegnato a questa struttura (ad esempio B01205). Identifica la struttura in ogni comunicazione.",
        "username": "Rilasciato dall’ufficio turismo della Regione, non dall’ISTAT."
      },
      "ses_hospedajes": {
        "clientCertificate": "Solo se la tua configurazione presso il Ministero richiede un certificato client.",
        "clientCertificatePassword": "Lascia vuoto se il certificato non ha una passphrase.",
        "username": "Il nome utente web service della Sede Electrónica. Termina con WS."
      },
      "siba": {
        "accessKey": "Ti viene inviata per lettera o email.",
        "establishment": "Assegnato dall’UCFE quando hai registrato l’unità.",
        "nipc": "Codice fiscale della struttura ricettiva."
      }
    },
    "registrationCredentialPlaceholder": {
      "ses_hospedajes": {
        "username": "es. 1234567WS"
      }
    },
    "registrationField": {
      "arrivalDate": "Data di arrivo",
      "birthCountry": "Stato di nascita",
      "birthPlace": "Comune di nascita",
      "dateOfBirth": "Data di nascita",
      "departureDate": "Data di partenza",
      "documentNumber": "Numero documento",
      "documentType": "Tipo di documento",
      "expiryDate": "Scadenza documento",
      "firstName": "Nome",
      "issuingCountry": "Stato di rilascio del documento",
      "lastName": "Cognome",
      "nationality": "Cittadinanza",
      "personalNumber": "Numero di identificazione nazionale",
      "residenceAddress": "Indirizzo di residenza",
      "residenceCountry": "Stato di residenza",
      "sex": "Sesso",
      "stayPurpose": "Motivo del soggiorno"
    },
    "registrationOption": {
      "documentType": {
        "id_card": "Carta d’identità",
        "other": "Altro",
        "passport": "Passaporto"
      },
      "sex": {
        "F": "Femmina",
        "M": "Maschio"
      },
      "stayPurpose": {
        "business": "Lavoro",
        "education": "Studio",
        "family": "Famiglia",
        "medical": "Salute",
        "other": "Altro",
        "tourism": "Turismo"
      }
    },
    "registrationSystem": {
      "alloggiati_web": {
        "authority": "Polizia di Stato (Questura competente)",
        "enrollmentSteps": {
          "enterCredentials": "Inserisci qui sotto nome utente, password e WS Key.",
          "generateWsKey": "Accedi e genera una chiave web service (WS Key). A ogni cambio password ne serve una nuova, e se ne può generare solo una al giorno.",
          "requestAccount": "Richiedi un account Alloggiati Web alla Questura competente. Riceverai nome utente e password."
        }
      },
      "eturizem": {
        "authority": "AJPES",
        "enrollmentSteps": {
          "checkAccess": "Verifica che questo account abbia accesso a eTurizem. AJPES lo concede a parte, quindi un account del portale senza questo accesso non può inviare comunicazioni.",
          "enterCredentials": "Inserisci qui sotto quel nome utente e la relativa password, carica il certificato e aggiungi il numero RNO. Vidimo assegna alle registrazioni che invia a eTurizem un numero progressivo (zaporedna številka prijave gosta) a partire da {guestbookBase, number}, così il gestionale che usi oggi può chiudere i soggiorni che ha già comunicato senza che una registrazione sovrascriva l’altra. Vidimo comunica gli ospiti che arrivano dal giorno in cui lo colleghi: da quel giorno disattiva nel tuo gestionale l’invio dei nuovi arrivi, altrimenti AJPES li riceve due volte.",
          "findUsername": "Trova il tuo nome utente del portale AJPES (uporabniško ime). È il nome che hai scelto quando hai creato l’account, non il tuo indirizzo email: AJPES non accetta un’email. Accedi al portale AJPES e lo trovi in alto a destra.",
          "obtainCertificate": "Ottieni un certificato digitale qualificato sloveno (.p12 / KDP) rilasciato alla tua attività.",
          "registerAccommodation": "Registra la struttura nel registro sloveno delle strutture ricettive (Register nastanitvenih obratov, RNO) presso AJPES. Il registro le assegna un numero identificativo: è il tuo numero RNO."
        }
      },
      "evisitor": {
        "authority": "Ente nazionale croato per il turismo (ente turistico locale)",
        "enrollmentSteps": {
          "enterCredentials": "Inseriscili qui sotto.",
          "receiveCredentials": "L’ente turistico locale ti rilascia nome utente e password eVisitor."
        }
      },
      "istat": {
        "authority": "Regione (rilevazione ISTAT sul movimento dei clienti)",
        "enrollmentSteps": {
          "enterCredentials": "Inserisci codice struttura, nome utente e password.",
          "requestAccess": "Chiedi all’ufficio turismo della tua Regione l’accesso al web service. Ti rilascia nome utente e password e ti comunica il codice della struttura."
        }
      },
      "ses_hospedajes": {
        "authority": "Ministerio del Interior (Sede Electrónica)",
        "enrollmentSteps": {
          "enroll": "Registra la struttura nella Sede Electrónica e attiva l’invio tramite web service.",
          "obtainCertificate": "Se la tua configurazione lo richiede, ottieni dal Ministero il certificato client SSL.",
          "receiveCredentials": "Riceverai un nome utente web service (termina con WS) e una password."
        }
      },
      "siba": {
        "authority": "UCFE (Sistema de Segurança Interna)",
        "enrollmentSteps": {
          "enterCredentials": "Inserisci qui sotto codice fiscale, numero dello stabilimento e chiave di accesso.",
          "receiveAccessKey": "L’UCFE rilascia la chiave di accesso (Chave de Acesso) per quello stabilimento; per sostituirla scrivi a siba@ssi.gov.pt.",
          "register": "Registra la tua struttura presso l’UCFE come utente SIBA per ottenere un numero di stabilimento."
        }
      }
    },
    "reservationSource": {
      "direct": "Diretta",
      "other": "Altro"
    },
    "reservationStatus": {
      "cancelled": "Cancellata",
      "checked_in": "Check-in effettuato",
      "checked_out": "Check-out effettuato",
      "confirmed": "Confermata",
      "declined": "Rifiutata",
      "no_show": "No show",
      "requested": "Richiesta"
    },
    "role": {
      "manager": "Manager",
      "operator": "Operatore",
      "owner": "Titolare",
      "receptionist": "Receptionist"
    },
    "roleDescription": {
      "manager": "Gestisce l’operatività quotidiana. Può gestire il personale, tranne i titolari.",
      "operator": "Personale operativo: vede solo le proprie attività e le prenotazioni collegate.",
      "owner": "Controllo completo: fatturazione, impostazioni, eliminazione.",
      "receptionist": "Gestisce ospiti, prenotazioni e attività. Nessun permesso di amministrazione."
    },
    "roomAmenity": {
      "10": "Accappatoio",
      "105": "Piano cottura",
      "107": "Telefono",
      "11": "Set di cortesia",
      "13": "Vasca da bagno",
      "142": "Doccia",
      "144": "Insonorizzazione",
      "146": "Tavolo e sedie",
      "15": "Vasca o doccia",
      "162": "Armadio",
      "166": "Climatizzazione",
      "167": "Tostapane",
      "18": "TV via cavo",
      "19": "Macchina per caffè/tè",
      "193": "Bagno in comune",
      "2": "Aria condizionata",
      "210": "TV satellitare",
      "223": "Vista montagna",
      "224": "Vista mare",
      "228": "Ciabattine",
      "245": "Piscina privata",
      "246": "TV a schermo piatto",
      "251": "TV",
      "259": "Film",
      "28": "Scrivania",
      "3": "Sveglia",
      "32": "Lavastoviglie",
      "41": "Camino",
      "5": "Radio",
      "50": "Asciugacapelli",
      "5017": "Balcone",
      "55": "Ferro da stiro",
      "59": "Cucina",
      "61": "Angolo cottura",
      "68": "Microonde",
      "69": "Minibar",
      "7": "Terrazza",
      "77": "Forno",
      "85": "Bagno privato",
      "88": "Frigorifero",
      "92": "Cassaforte"
    },
    "supportTeamName": "Team Vidimo",
    "taskAssignmentPreset": {
      "first_available": "Primo disponibile",
      "specific_staff": "Una persona specifica",
      "unassigned": "Non assegnare"
    },
    "taskFunction": {
      "check_in": "Check-in",
      "check_out": "Check-out",
      "cleaning": "Pulizie",
      "concierge": "Concierge",
      "maintenance": "Manutenzione"
    },
    "taskRuleTrigger": {
      "any": "Qualsiasi pulizia"
    },
    "taskStatus": {
      "cancelled": "Annullata",
      "completed": "Completata",
      "in_progress": "In corso",
      "missed": "Non svolta",
      "paused": "In pausa",
      "pending": "Da fare"
    },
    "transport": {
      "email": "Email",
      "phone": "Telefono",
      "sms": "SMS"
    },
    "unitReadiness": {
      "clean": "Pulita",
      "dirty": "Da pulire",
      "inspected": "Controllata",
      "out_of_order": "Fuori servizio"
    },
    "unitType": {
      "apartment": "Appartamento",
      "double": "Doppia",
      "family": "Familiare",
      "quadruple": "Quadrupla",
      "single": "Singola",
      "studio": "Monolocale",
      "suite": "Suite",
      "triple": "Tripla",
      "twin": "Doppia con letti separati",
      "villa": "Villa"
    }
  },

  "meals": {
    "breakfastService": {
      "roomNotAssigned": "Camera non assegnata"
    },
    "breakfastServiceBody": {
      "breakfastArea": "Sala colazione",
      "cancel": "Annulla",
      "complimentaryTag": "omaggio",
      "coverCount": "{count, plural, one {# coperto} other {# coperti}}",
      "done": "Fine",
      "emptyBody": "Nessuno di chi soggiorna stanotte ha la colazione il {date}.",
      "emptyTitle": "Niente colazioni stamattina",
      "errorRoomNotUpdated": "Impossibile aggiornare quella camera. Riprova.",
      "errorRoomsNotMoved": "Impossibile spostare quelle camere. Riprova.",
      "groupCount": "{count, plural, one {# camera} other {# camere}} · {covers}",
      "loading": "Caricamento colazioni",
      "movedTo": "{count, plural, one {# camera} other {# camere}} · {place, select, breakfast_area {sala colazione} in_room {in camera} takeaway_box {box da asporto} other {{place}}}",
      "roomsOnDate": "{count, plural, one {# camera} other {# camere}} · {date}",
      "rowLabel": "{room}, {covers}",
      "rowLabelServed": "{room}, {covers}, servita",
      "select": "Seleziona",
      "selectedCount": "{count, plural, one {# selezionata} other {# selezionate}}",
      "serveInRoom": "Servi in camera",
      "served": "Servita"
    },
    "breakfastSummaryRow": {
      "ariaLabel": "Colazione, {covers, plural, one {# coperto} other {# coperti}} in {rooms, plural, one {# camera} other {# camere}}",
      "inRoomCount": "{count, plural, one {# in camera} other {# in camera}}",
      "servedCount": "{count, plural, one {# servita} other {# servite}}",
      "title": "Colazione · {count, plural, one {# camera} other {# camere}}"
    },
    "reservationBreakfastCard": {
      "chargeForMorning": "Addebita per questa mattina",
      "coversAt": "{count, plural, one {# coperto} other {# coperti}} · {place, select, breakfast_area {sala colazione} in_room {in camera} takeaway_box {box da asporto} other {{place}}}",
      "errorMorningNotUpdated": "Impossibile aggiornare quella mattina. Riprova.",
      "givenBy": "Omaggio di {name}",
      "makeComplimentary": "Offri",
      "makeComplimentaryHint": "In omaggio: viene tolta dal conto",
      "markNotTaken": "Segna come non consumata",
      "markServed": "Segna come servita",
      "morningCount": "{count, plural, one {# mattina} other {# mattine}}",
      "notCharged": "Non addebitata",
      "statusExpected": "Prevista",
      "statusNotTaken": "Non consumata",
      "statusServed": "Servita",
      "title": "Colazione",
      "unconfirmedCount": "{count, plural, one {# mattina non confermata} other {# mattine non confermate}}"
    }
  },

  "notifications": {
    "attention": {
      "activityFailed": "Nuovo tentativo automatico",
      "activityPending": "In coda per l’invio",
      "activitySubmitting": "Invio in corso",
      "severityAtRisk": "Scadenza vicina",
      "severityNeedsAction": "Intervento richiesto"
    },
    "filingAttentionSection": {
      "activityNotConfirmed": "Registrazione non ancora confermata",
      "activitySubmitted": "Inviata, in attesa di conferma dall’autorità",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "deadlinePassed": "Scadenza superata",
      "detailNoDeadline": "{activity}, e la scadenza di legge per la comunicazione si avvicina.",
      "detailWithDeadline": "{activity} · {relative}",
      "title": "Registrazione ospiti"
    },
    "notificationMenu": {
      "activity": "Attività recenti",
      "close": "Chiudi notifiche",
      "emptyDescription": "Qui compariranno azioni suggerite e attività recenti",
      "emptySearchDescription": "Prova con un altro termine",
      "errorApplyFailed": "Impossibile applicare questo suggerimento. Potrebbe non essere più attuale.",
      "errorDismissFailed": "Impossibile ignorare questo suggerimento. Riprova.",
      "errorMissingMergeProfiles": "In questo suggerimento mancano i profili da unire.",
      "errorNotCleared": "Impossibile rimuovere questa scheda. Riprova.",
      "errorNotClearedAfter": "{message}, ma non è stato possibile rimuovere questa scheda. Riprova.",
      "noActivity": "Ancora nessuna attività",
      "noPendingSuggestions": "Nessun suggerimento in sospeso",
      "noResults": "Nessun risultato",
      "searchPlaceholder": "Cerca suggerimenti e attività…",
      "suggestedActions": "Azioni suggerite",
      "title": "Notifiche"
    },
    "notificationPrimer": {
      "decline": "Non ora",
      "description": "Attiva le notifiche e Vidimo ti avviserà di nuovi messaggi da ospiti e team, arrivi e cancellazioni e scadenze delle registrazioni. Senza notifiche lo scoprirai solo alla prossima apertura dell’app.",
      "enable": "Attiva le notifiche",
      "title": "Sappi subito quando un ospite scrive"
    },
    "pushRegistration": {
      "androidChannelName": "Notifiche"
    },
    "relativeDeadline": {
      "dueInDays": "{count, plural, one {scade tra {count} giorno} other {scade tra {count} giorni}}",
      "dueInHours": "{count, plural, one {scade tra {count} ora} other {scade tra {count} ore}}",
      "dueInMinutes": "{count, plural, one {scade tra {count} min} other {scade tra {count} min}}",
      "overdueByDays": "{count, plural, one {in ritardo di {count} giorno} other {in ritardo di {count} giorni}}",
      "overdueByHours": "{count, plural, one {in ritardo di {count} ora} other {in ritardo di {count} ore}}",
      "overdueByMinutes": "{count, plural, one {in ritardo di {count} min} other {in ritardo di {count} min}}"
    },
    "statisticsAttentionSection": {
      "activityNotConfirmed": "Non ancora confermata",
      "activitySubmitted": "Inviata, in attesa di conferma dalla Regione",
      "title": "Comunicazioni statistiche"
    },
    "taxReturnAttentionSection": {
      "detail": "{amount} da pagare entro il {date}",
      "dueSoon": "In scadenza",
      "overdue": "Scaduto",
      "title": "Versamenti al Comune",
      "uncomputed": "{count, plural, one {# soggiorno non calcolato} other {# soggiorni non calcolati}}"
    },
    "timeOffProposalCard": {
      "confirm": "Conferma",
      "dismiss": "Ignora",
      "errorMarkAway": "Impossibile segnare l’assenza. Riprova.",
      "markedAway": "{who}: assenza registrata",
      "markedAwayReleased": "{who}: assenza registrata · {count, plural, one {# attività non più assegnata} other {# attività non più assegnate}}",
      "markedAwayReleasedDescription": "Riassegnale dalla colonna Non assegnate in Attività.",
      "review": "Rivedi",
      "staffMemberFallback": "Membro del team",
      "viewSourceMessage": "Vedi messaggio di origine"
    }
  },

  "rates": {
    "controls": {
      "fewerLabel": "{label}, meno",
      "moreLabel": "{label}, più"
    },
    "copy": {
      "board": {
        "noPrice": "Nessun prezzo",
        "notKept": "Le notti così lontane non sono salvate su questo telefono.",
        "pastMonth": "Le notti così indietro non sono salvate su questo telefono.",
        "tapHint": "Tocca una notte per modificarla, o una data per modificare tutte le tipologie di unità.",
        "tapHintProperty": "Tocca una notte per modificarla, o una data per modificare tutte le tipologie di unità di {propertyName}."
      },
      "changeNights": {
        "bookedWhenClosing": "{count, plural, one {{count} di queste notti ha già prenotazioni. La chiusura blocca solo le nuove prenotazioni.} other {{count} di queste notti hanno già prenotazioni. La chiusura blocca solo le nuove prenotazioni.}}",
        "cancel": "Annulla",
        "chooseUnitType": "Scegli almeno una tipologia di unità.",
        "close": "Chiudi",
        "fields": {
          "checkIn": "Check-in",
          "checkOut": "Check-out",
          "maximumStay": "Soggiorno massimo",
          "minimumStay": "Soggiorno minimo",
          "price": "Prezzo",
          "sale": "Vendita"
        },
        "firstNight": "Prima notte",
        "firstThenLast": "Tocca la prima notte, poi l’ultima",
        "lastNight": "Ultima notte",
        "leaveAsIs": "Lascia invariato",
        "minFromSeason": "Dalla stagione",
        "nothingToSend": "Scegli cosa modificare.",
        "priceFor": "Prezzo da impostare per {unitTypeName}",
        "priceToSet": "Prezzo da impostare",
        "priceUseSeasonOrBase": "Usa stagione o base",
        "saveLabel": "Salva",
        "setAPrice": "Imposta invece un prezzo",
        "tapForSpan": "Tocca una seconda notte per un intervallo.",
        "tapToWiden": "Tocca una seconda notte per un intervallo, o un’altra riga per aggiungerla.",
        "title": "Modifica notti",
        "toWord": "a",
        "useSeasonOrBaseInstead": "Usa invece il prezzo della stagione o quello base",
        "was": "Prima: {reads}."
      },
      "changes": {
        "sendAgain": "Invia di nuovo",
        "showTheseNights": "Mostra queste notti",
        "status": "Stato",
        "taskId": "Riferimento del canale",
        "title": "Modifiche tariffarie",
        "undo": "Annulla questa modifica",
        "whatChanged": "Cosa è cambiato",
        "whatWasSent": "Cosa è stato inviato",
        "who": {
          "automatic": "Automatica",
          "automaticAt": "Automatica, {time}",
          "bySupport": "Assistenza Vidimo per conto di {actor}",
          "inTheApp": "{name}, {time}, nell’app",
          "onBehalf": "{agent} (assistenza Vidimo) per conto di {actor}",
          "unknown": "Sconosciuto"
        }
      },
      "delivery": {
        "awaitingFullSync": "Verrà inviata con la prossima sincronizzazione completa",
        "notConnected": "Nessun portale di prenotazione è collegato, quindi è rimasta in Vidimo",
        "notMapped": "Non inviata: questa tipologia di unità non è collegata ai tuoi canali",
        "notSent": "Non inviata ai tuoi canali",
        "passedUnanswered": "Non confermata dai tuoi canali: le notti interessate sono ormai passate",
        "sending": "Invio ai tuoi canali",
        "sent": "Inviata ai tuoi canali",
        "sentAt": "Inviata ai tuoi canali alle {time}",
        "unmapped": "{count, plural, one {{unitTypes} non è collegata ai tuoi canali, quindi non è stata inviata.} other {{unitTypes} non sono collegate ai tuoi canali, quindi non sono state inviate.}}"
      },
      "discard": {
        "body": "Hai scelto delle notti o inserito un valore. Vuoi scartare questa modifica?",
        "discard": "Scarta",
        "forTapOn": "Avviare una modifica su {propertyName}? Ciò che hai inserito qui verrà scartato.",
        "keep": "Continua a modificare"
      },
      "editor": {
        "closedOn": "{of, plural, one {{on} notte su {of} chiusa} other {{on} notti su {of} chiuse}}",
        "detailsKept": "I dettagli di una modifica vengono conservati per 90 giorni.",
        "lastChanged": "Ultima modifica di {who}, {when}.",
        "notAllowedOn": "{of, plural, one {Non consentito in {on} notte su {of}} other {Non consentito in {on} notti su {of}}}",
        "varies": "Variabile"
      },
      "errors": {
        "belowLowest": "Il prezzo minimo per {unitTypeName} è {price}.",
        "conflict": "Queste notti sono state modificate su un altro dispositivo dall’ultima volta che le hai viste. Ricontrollale, poi invia di nuovo.",
        "lowestNotAbove0": "Inserisci un prezzo minimo superiore a 0.",
        "lowestOverBase": "Il prezzo minimo non può superare la tariffa base.",
        "offline": "Sei offline, quindi non è stato salvato. Salva di nuovo quando torni online.",
        "priceAbove0": "Inserisci un prezzo superiore a 0.",
        "priceToType": "Inserisci il prezzo da impostare.",
        "priceUnreadable": "Inserisci un prezzo come {example, number}.",
        "pricedUnder": "{which, select, nights {{nights, plural, one {{nights} notte di {unitTypeName} ha un prezzo inferiore a {amount}. Alza prima il prezzo, poi imposta il prezzo minimo.} other {{nights} notti di {unitTypeName} hanno un prezzo inferiore a {amount}. Alza prima il prezzo, poi imposta il prezzo minimo.}}} seasons {{seasons, plural, one {{seasons} stagione di {unitTypeName} ha un prezzo inferiore a {amount}. Alza prima il prezzo, poi imposta il prezzo minimo.} other {{seasons} stagioni di {unitTypeName} hanno un prezzo inferiore a {amount}. Alza prima il prezzo, poi imposta il prezzo minimo.}}} other {{nights, plural, one {{nights} notte} other {{nights} notti}} e {seasons, plural, one {{seasons} stagione} other {{seasons} stagioni}} di {unitTypeName} hanno un prezzo inferiore a {amount}. Alza prima il prezzo, poi imposta il prezzo minimo.}}",
        "staysContradict": "Il soggiorno minimo è più lungo del massimo, quindi nessun soggiorno può iniziare in questa notte."
      },
      "heldBack": {
        "basePrice": "Il prezzo base è già {price}, quindi per {unitTypeName} non cambia nulla.",
        "seasonMinimum": "Il minimo della stagione è già {nights}, quindi non cambia nulla.",
        "seasonPrice": "La stagione {seasonName} dà già {price}, quindi per {unitTypeName} non cambia nulla.",
        "seasonPriceUnnamed": "Il prezzo della stagione è già {price}, quindi per {unitTypeName} non cambia nulla."
      },
      "hold": {
        "sendNow": "Invia ora",
        "waiting": "{changes, plural, one {{changes} modifica viene inviata} other {{changes} modifiche vengono inviate}} ai tuoi canali tra {seconds, plural, one {{seconds} s} other {{seconds} s}}"
      },
      "night": {
        "allowed": "Consentito",
        "checkIn": "Check-in",
        "checkOut": "Check-out",
        "closed": "Chiusa",
        "fallBackToBase": "Usa il prezzo base ({price})",
        "fallBackToSeason": "Usa la stagione {name} ({price})",
        "maximumStay": "Soggiorno massimo",
        "minFromSeason": "{count, plural, one {{count} dalla stagione} other {{count} dalla stagione}}",
        "minimumStay": "Soggiorno minimo",
        "noLimit": "Nessun limite",
        "noMinimum": "Nessun minimo",
        "notAllowed": "Non consentito",
        "notForSale": "Nessun prezzo, quindi non in vendita",
        "open": "Aperta",
        "price": "Prezzo",
        "priceFromBase": "Prezzo base",
        "priceFromBaseAt": "Prezzo base ({price})",
        "priceFromSeason": "Dalla stagione {name}",
        "priceFromSeasonAt": "Dalla stagione {name} ({price})",
        "priceRange": "{low}–{high}",
        "priceSetForNight": "Impostato per questa notte",
        "priceSetForNights": "Impostato per queste notti",
        "sale": "Vendita",
        "seeTheChange": "Vedi la modifica.",
        "unitsFree": "{free, plural, one {{free} unità libera su {total}} other {{free} unità libere su {total}}}"
      },
      "nights": "{count, plural, one {{count} notte} other {{count} notti}}",
      "planned": {
        "checkInAllowed": "{position, select, first {Check-in consentito} other {check-in consentito}}",
        "checkInNotAllowed": "{position, select, first {Check-in non consentito} other {check-in non consentito}}",
        "checkOutAllowed": "{position, select, first {Check-out consentito} other {check-out consentito}}",
        "checkOutNotAllowed": "{position, select, first {Check-out non consentito} other {check-out non consentito}}",
        "chooseNights": "Scegli le notti da modificare",
        "chooseSomething": "Scegli cosa modificare",
        "chooseUnitType": "Scegli almeno una tipologia di unità",
        "close": "{position, select, first {Chiudi} other {chiudi}}",
        "maxStay": "{position, select, first {{nights, plural, one {Imposta il soggiorno massimo a {nights} notte} other {Imposta il soggiorno massimo a {nights} notti}}} verb {{nights, plural, one {imposta il soggiorno massimo a {nights} notte} other {imposta il soggiorno massimo a {nights} notti}}} other {{nights, plural, one {soggiorno massimo a {nights} notte} other {soggiorno massimo a {nights} notti}}}}",
        "maxStayCleared": "{position, select, first {Nessun soggiorno massimo} other {nessun soggiorno massimo}}",
        "minStay": "{position, select, first {{nights, plural, one {Imposta il soggiorno minimo a {nights} notte} other {Imposta il soggiorno minimo a {nights} notti}}} verb {{nights, plural, one {imposta il soggiorno minimo a {nights} notte} other {imposta il soggiorno minimo a {nights} notti}}} other {{nights, plural, one {soggiorno minimo a {nights} notte} other {soggiorno minimo a {nights} notti}}}}",
        "minStayCleared": "{position, select, first {Usa il soggiorno minimo della stagione} other {usa il soggiorno minimo della stagione}}",
        "price": "{position, select, first {Imposta il prezzo a {price}} verb {imposta il prezzo a {price}} other {prezzo a {price}}}",
        "priceCleared": "{position, select, first {Usa il prezzo della stagione o base} other {usa il prezzo della stagione o base}}",
        "reopen": "{position, select, first {Riapri} other {riapri}}",
        "sentence": "{changes} per {unitTypes}, {span} ({count, plural, one {{count} notte} other {{count} notti}})."
      },
      "sent": {
        "checkInAllowed": "check-in consentito",
        "checkInNotAllowed": "check-in non consentito",
        "checkOutAllowed": "check-out consentito",
        "checkOutNotAllowed": "check-out non consentito",
        "closed": "chiusa",
        "maxStay": "{nights, plural, one {soggiorno max {nights}} other {soggiorno max {nights}}}",
        "maxStayCleared": "nessun soggiorno massimo",
        "minStay": "{nights, plural, one {soggiorno min {nights}} other {soggiorno min {nights}}}",
        "minStayCleared": "soggiorno min della stagione",
        "priceCleared": "prezzo riportato a stagione o base",
        "reopened": "riaperta"
      },
      "summary": {
        "closedFor": "Chiuso {span} per {unitTypes}",
        "line": "{unitTypes}: {fields}, {span}",
        "lineNights": "{unitTypes}: {fields}, {span} ({count, plural, one {{count} notte} other {{count} notti}})",
        "reopenedFor": "Riaperto {span} per {unitTypes}",
        "undone": "Annullata: {body}",
        "unitTypesHeadline": "{types, plural, one {{types} tipologia di unità, {span}} other {{types} tipologie di unità, {span}}}",
        "unitsFreeHeadline": "Unità libere inviate",
        "unitsFreeLine": "{free, plural, one {{unitType} {free}, {span}} other {{unitType} {free}, {span}}}",
        "unitsFreeSent": "Unità libere inviate: {lines}. {trigger, select, nightly_refresh {Aggiornamento notturno.} other {Dopo una prenotazione o un blocco.}}"
      },
      "toast": {
        "nothingConnected": "Nessun portale di prenotazione è collegato, quindi le tariffe cambiano solo in Vidimo.",
        "saved": "Salvato",
        "undo": "Annulla",
        "undone": "Annullato",
        "waiting": "L’ultima modifica è ancora in fase di salvataggio. Salva di nuovo tra un momento."
      },
      "viewMenu": {
        "rates": "Tariffe",
        "staff": "Personale",
        "units": "Unità"
      },
      "words": {
        "and": "{head} e {last}",
        "sentences": "{head}. {next}",
        "series": "{head}, {next}"
      }
    },
    "rateChangeDetailPage": {
      "awaitingFullSync": "{what}: i tuoi canali non le hanno ancora confermate, quindi verranno inviate con la prossima sincronizzazione completa.",
      "changedLine": "{unitType}, {span} ({count}): {changes}",
      "copied": "Copiato",
      "copy": "Copia",
      "copyFailed": "Impossibile copiare",
      "fieldCheckIn": "check-in",
      "fieldCheckOut": "check-out",
      "fieldMaxStay": "soggiorno massimo",
      "fieldMinStayArrival": "soggiorno minimo all’arrivo",
      "fieldMinStayThrough": "soggiorno minimo che include la notte",
      "fieldPrice": "prezzo",
      "fieldSale": "vendita",
      "fieldUnitsFree": "unità libere",
      "loading": "Caricamento…",
      "noValueChanged": "Nessun valore modificato",
      "notFound": "Modifica non trovata.",
      "notSent": "{what}: i tuoi canali non le hanno accettate.",
      "notSentBecauseConnection": "Vidimo non aveva più accesso a questa struttura sui tuoi canali.",
      "notSentBecauseValues": "Controlla questi valori, poi inviali di nuovo.",
      "passedUnanswered": "{what}: i tuoi canali non le hanno confermate e queste notti sono ormai passate.",
      "pushedLine": "{unitType} {span}: {fields}",
      "saved": "Salvata {time}.",
      "sending": "{what}: invio in corso.",
      "sent": "{what}, inviate ai tuoi canali",
      "sentAt": "{what}, inviate ai tuoi canali alle {time}",
      "taskIdAwaiting": "{taskId}: disponibile dopo l’invio",
      "wasNow": "{field}: prima {before}, ora {after}",
      "whatRates": "Tariffe e regole",
      "whatUnitsFree": "Unità libere"
    },
    "ratesBoard": {
      "cellLabel": "{rowName}, {day}: {price}",
      "cellLabelClosed": "{rowName}, {day}: {price}, chiusa",
      "dateTapLabel": "Tutte le tipologie di unità il {day}",
      "dateTapPropertyLabel": "Tutte le tipologie di unità di {propertyName} il {day}",
      "units": "{count, plural, one {# unità} other {# unità}}"
    },
    "ratesView": {
      "emptyDescription": "Aggiungi unità a questa struttura prima di impostare i prezzi.",
      "emptyTitle": "Ancora nessuna unità",
      "nextMonth": "Mese successivo",
      "previousMonth": "Mese precedente",
      "thisMonth": "Questo mese"
    }
  },

  "reservations": {
    "assignUnitSelect": {
      "checking": "Verifica delle unità libere…",
      "errorNotAssigned": "Impossibile assegnare questa unità. Riprova.",
      "errorUnitTaken": "Un altro soggiorno occupa già questa unità in alcune di queste notti. Scegli un’altra unità.",
      "noneFree": "Nessuna unità è libera per tutte le notti",
      "placeholder": "Assegna un’unità"
    },
    "cancelReservationAction": {
      "cancelAction": "Cancella prenotazione",
      "cancelBody": "La prenotazione di {guestName} viene cancellata e l’unità torna libera per quelle notti.",
      "cancelTitle": "Cancellare questa prenotazione?",
      "cancelToast": "Prenotazione cancellata",
      "declineAction": "Rifiuta richiesta",
      "declineBody": "La richiesta di {guestName} viene rifiutata e l’unità resta libera per quelle notti.",
      "declineTitle": "Rifiutare questa richiesta?",
      "declineToast": "Richiesta rifiutata",
      "errorCancel": "Impossibile cancellare la prenotazione. Riprova.",
      "errorDecline": "Impossibile rifiutare la richiesta. Riprova.",
      "errorUndoCancel": "Impossibile annullare. La prenotazione risulta ancora cancellata.",
      "errorUndoDecline": "Impossibile annullare. La richiesta risulta ancora rifiutata.",
      "keepIt": "Mantieni",
      "undo": "Annulla"
    },
    "checkInInviteCard": {
      "deliveryBounced": "Respinta: l’indirizzo non l’ha accettata",
      "deliveryComplained": "Segnalata come spam dal destinatario",
      "deliveryDelivered": "Consegnata",
      "deliverySent": "Inviata, in attesa di conferma",
      "deliverySuppressed": "Non tentata: l’indirizzo è in una lista di esclusione",
      "errorNotSent": "Impossibile inviare l’invito",
      "errorPreview": "Impossibile caricare l’anteprima",
      "noInvitation": "Nessun invito per questa prenotazione",
      "notSentYet": "Non è ancora stato inviato alcun invito per questa prenotazione.",
      "previewEmail": "Anteprima email",
      "sendAgain": "Invia di nuovo",
      "sendInvitation": "Invia invito",
      "sentTo": "Inviato a {email} il {date}{count, plural, =0 {} =1 {} one {} other { ({count} volte)}}.",
      "sentToast": "Invito al check-in inviato a {email}",
      "title": "Invito al check-in",
      "unavailableNoDates": "Aggiungi prima le date di check-in e check-out.",
      "unavailableNoEmail": "Questa prenotazione è arrivata senza indirizzo email.",
      "unavailableNotActive": "Questa prenotazione è cancellata, quindi non c’è nulla da inviare.",
      "unavailableNotFound": "Non abbiamo trovato questa prenotazione."
    },
    "checkInLinkCard": {
      "copied": "Copiato",
      "copy": "Copia",
      "description": "Invialo all’ospite: il check-in si apre senza bisogno di accedere. L’anteprima ti mostra cosa vede.",
      "errorCreate": "Impossibile creare il link per il check-in",
      "errorNotCopied": "Impossibile copiare il link",
      "noLink": "Nessun link per questa prenotazione",
      "preview": "Anteprima",
      "title": "Link per il check-in online",
      "toastCopied": "Link copiato",
      "unavailableNoDates": "Aggiungi prima le date di check-in e check-out.",
      "unavailableNotActive": "Questa prenotazione è cancellata, quindi non c’è nessun check-in da fare.",
      "unavailableNotFound": "Non abbiamo trovato questa prenotazione."
    },
    "collectPaymentSheet": {
      "amountLabel": "Importo ({currency})",
      "channelWarning": "Questa prenotazione arriva da un canale che di solito incassa il costo della camera. Addebitarlo di nuovo significherebbe far pagare due volte l’ospite: incassa solo gli extra.",
      "copied": "Copiato",
      "copy": "Copia",
      "createLink": "Crea link di pagamento",
      "creating": "Creazione…",
      "errorCopy": "Impossibile copiare: seleziona il link e copialo a mano.",
      "errorCreateLink": "Impossibile creare il link. Riprova.",
      "errorNoAmount": "Inserisci un importo da incassare.",
      "holdLapsesWarning": "Questo soggiorno dura più dei 7 giorni della preautorizzazione. L’importo verrà sbloccato intorno al {date}, prima del check-out dell’ospite, e dopo non potrai più incassare. Scegli <strong>Addebita</strong> nelle impostazioni di pagamento se ti serve una copertura fino alla partenza.",
      "holdNotice": "La carta dell’ospite blocca l’importo: il denaro resta suo e non viene addebitato nulla finché non incassi. La preautorizzazione dura circa 7 giorni; poi l’importo viene sbloccato automaticamente e non puoi più incassare.",
      "linkCopied": "Link di pagamento copiato",
      "pendingUntilPaid": "La voce risulta in sospeso nel conto finché l’ospite non completa il pagamento.",
      "presetBalance": "Saldo completo",
      "presetDeposit": "Acconto del 30%",
      "presetTouristTax": "Imposta di soggiorno",
      "sendHoldLink": "Invialo all’ospite. Blocca l’importo sulla sua carta: il denaro resta suo finché non incassi.",
      "sendLink": "Invialo all’ospite. Il conto si aggiorna appena paga.",
      "title": "Incassa pagamento"
    },
    "confirmMoneyAction": {
      "cancel": "Annulla",
      "working": "Elaborazione…"
    },
    "editGuestForm": {
      "avatarAlt": "Ospite",
      "backToGuests": "Torna agli ospiti",
      "emailLabel": "Email",
      "emailPlaceholder": "ospite@esempio.it (obbligatoria senza nome/telefono)",
      "errorNotSaved": "Impossibile salvare l’ospite. Riprova.",
      "firstNameLabel": "Nome",
      "firstNamePlaceholder": "Inserisci il nome (facoltativo con telefono/email)",
      "lastNameLabel": "Cognome",
      "lastNamePlaceholder": "Inserisci il cognome (facoltativo con telefono/email)",
      "nationalityLabel": "Cittadinanza",
      "nationalityPlaceholder": "Seleziona la cittadinanza",
      "notFound": "Ospite non trovato",
      "phoneLabel": "Telefono",
      "phonePlaceholder": "(obbligatorio senza nome)",
      "saved": "Dati dell’ospite salvati.",
      "title": "Modifica ospite"
    },
    "editReservationForm": {
      "accessibilityLabel": "Accessibilità",
      "accessibilityPlaceholder": "es. preferibile piano terra, accesso in sedia a rotelle",
      "adultsLabel": "Adulti",
      "arrivalTimeLabel": "Orario di arrivo previsto",
      "backToCalendar": "Torna al calendario",
      "beforeCreating": "Prima di creare",
      "beforeSaving": "Prima di salvare",
      "channelCancelledNote": "Cancellata su {source}: solo il canale può ripristinarla",
      "channelDatesNote": "Le date sono gestite da {source}: modificale lì e si sincronizzeranno qui",
      "channelManagedNote": "Sincronizzata da {source}. Date del soggiorno e cancellazioni si gestiscono sul canale e si sincronizzano automaticamente; dati dell’ospite, note e unità restano modificabili qui.",
      "checkInTimeLabel": "Orario di check-in",
      "checkOutTimeLabel": "Orario di check-out",
      "checkingAvailability": "Verifica disponibilità…",
      "childrenLabel": "Bambini",
      "create": "Crea",
      "datesLabel": "Check-in – Check-out",
      "dietaryLabel": "Esigenze alimentari",
      "dietaryPlaceholder": "es. cesto di benvenuto vegetariano, allergia alla frutta secca",
      "emailLabel": "Email",
      "emailPlaceholder": "giulia@esempio.it",
      "errorAdultsRequired": "Indica il numero di adulti per fare il check-in di un ospite",
      "errorCheckInDateRequired": "La data di check-in è obbligatoria",
      "errorCheckInTimeInvalid": "L’orario di check-in deve essere nel formato 13:00",
      "errorCheckOutBeforeCheckIn": "Il check-out deve essere successivo al check-in",
      "errorCheckOutDateRequired": "La data di check-out è obbligatoria",
      "errorCheckOutTimeRequired": "L’orario di check-out è obbligatorio",
      "errorFirstNameRequired": "Il nome dell’ospite è obbligatorio",
      "errorNotCreated": "Impossibile creare questa prenotazione. I tuoi dati sono ancora qui: riprova.",
      "errorNotSaved": "Impossibile salvare questa prenotazione. Le tue modifiche sono ancora qui: riprova.",
      "errorPropertyRequired": "La struttura è obbligatoria",
      "errorRoomRequired": "Scegli una camera per questa prenotazione",
      "firstNameLabel": "Nome",
      "firstNamePlaceholder": "Giulia",
      "groupBookingNote": "Questa prenotazione comprende più unità; qui non è ancora possibile cambiare unità",
      "guestHeading": "Ospite",
      "hasPetsLabel": "Viaggia con un animale",
      "infantsLabel": "Neonati",
      "lastNameLabel": "Cognome",
      "lastNamePlaceholder": "Bianchi",
      "notFound": "Prenotazione non trovata",
      "petNotesLabel": "Note sull’animale",
      "petNotesPlaceholder": "es. 1 cane piccolo (Fido)",
      "phoneLabel": "Telefono",
      "propertyLabel": "Struttura",
      "propertyLocked": "La struttura non si può cambiare dopo la creazione della prenotazione",
      "propertyPlaceholder": "Seleziona una struttura",
      "save": "Salva",
      "statusLabel": "Stato",
      "stayDetailsHeading": "Dettagli del soggiorno",
      "titleEdit": "Modifica prenotazione",
      "titleNew": "Nuova prenotazione",
      "toastCreated": "Prenotazione creata.",
      "toastSaved": "Prenotazione salvata.",
      "unitConflict": "Questa unità è già prenotata dal {checkIn} al {checkOut}. Cambia le date o scegli un’altra unità.",
      "unitConflictBy": "Questa unità è già prenotata da {name} dal {checkIn} al {checkOut}. Cambia le date o scegli un’altra unità.",
      "unitConflictByWithRef": "Questa unità è già prenotata da {name} dal {checkIn} al {checkOut} (rif. {reference}). Cambia le date o scegli un’altra unità.",
      "unitConflictWithRef": "Questa unità è già prenotata dal {checkIn} al {checkOut} (rif. {reference}). Cambia le date o scegli un’altra unità.",
      "unitLabel": "Unità",
      "unitPlaceholder": "Seleziona una camera",
      "unitsFree": "{free, plural, one {{free} libera su {total}} other {{free} libere su {total}}}"
    },
    "guestRegistrationStatus": {
      "authorityQuote": "«{reason}»",
      "authorityQuoteAt": "· {when}",
      "cancelAction": "Annulla questa comunicazione",
      "cancelConfirm": "Annulla comunicazione",
      "cancelHint": "Solo se questo ospite non alloggia qui: un no show o una comunicazione inviata per la struttura sbagliata. L’operazione è irreversibile.",
      "cancelKeep": "Mantieni la comunicazione",
      "cancelTitle": "Annullare questa comunicazione a {authority}?",
      "cancelledToast": "Comunicazione a {authority} annullata.",
      "cancelledWith": "Comunicazione a {authority} annullata",
      "cancelledWithOn": "Comunicazione a {authority} annullata il {when}",
      "downloadReceipt": "Scarica la ricevuta",
      "errorCancel": "Impossibile annullare la comunicazione. Riprova.",
      "errorCancelRefused": "La comunicazione non è stata annullata.",
      "errorDownloadReceipt": "Impossibile scaricare la ricevuta. Riprova.",
      "errorMarkFiled": "Impossibile segnare l’invio. Riprova.",
      "errorRetry": "Impossibile ritentare l’invio. Riprova.",
      "errorRetryFailedAgain": "L’invio non è riuscito di nuovo.",
      "fixAndRefile": "Correggi e reinvia",
      "headlineAuthRefused": "{authority} ha rifiutato le credenziali di questa struttura",
      "headlineAuthUnused": "Non è stato possibile usare le credenziali {authority} di questa struttura",
      "headlineFiledByHost": "Hai inviato tu l’altra comunicazione di questo ospite a {authority}",
      "headlineIncomplete": "{authority} non ha potuto completare questa registrazione",
      "headlineMissingData": "{authority} richiede dati che questa registrazione non ha",
      "headlineNoConnector": "Vidimo non invia questa comunicazione a {authority}",
      "headlineNotReached": "Questa registrazione non è arrivata a {authority}",
      "headlineOtherFacility": "Per {authority} questo ospite risulta registrato con un altro numero RNO",
      "headlineUnattributed": "{authority} potrebbe aver già ricevuto questa comunicazione",
      "headlineValidation": "{authority} ha respinto questa registrazione",
      "lastTried": "Ultimo tentativo {when}",
      "legalDeadline": "Scadenza di legge · {deadline}",
      "markFiledAction": "Segna come già inviata",
      "markFiledConfirm": "Segna come inviata",
      "markFiledDescription": "Solo se questo ospite risulta già registrato su {authority}: hai inviato tu la comunicazione, o l’hai trovata sul portale. Vidimo smetterà di ricordartelo e non invierà più questa registrazione.",
      "markFiledNotYet": "Non ancora",
      "markFiledTitle": "Segnare questa registrazione come inviata?",
      "markedFiledToast": "Segnata come inviata.",
      "nextStepAuth": "Ricollega le credenziali della struttura, poi riprova.",
      "nextStepFiledByHost": "Invia anche questa tu stesso prima della scadenza, poi segnala qui che l’hai inviata.",
      "nextStepMissingData": "Completa i dati mancanti, poi salva per reinviare.",
      "nextStepNoConnector": "Comunica tu stesso questo ospite all’autorità prima della scadenza, poi segnala qui che l’hai comunicato.",
      "nextStepOtherFacility": "Se l’ospite ha soggiornato davvero nell’alloggio a cui AJPES ha assegnato quel numero RNO, completa la comunicazione sul portale dell’autorità con quel numero. Altrimenti annullala e comunica l’ospite con il numero attuale. Poi segnala qui la registrazione come inviata. Se il numero RNO di questa struttura è stato cambiato per errore, ripristinalo e riprova.",
      "nextStepTransient": "Nuovo tentativo automatico.",
      "nextStepUnattributed": "Abbiamo inviato la comunicazione di questo ospite, ma non abbiamo ricevuto conferma che sia stata registrata. Controlla sul portale dell’autorità: se l’ospite risulta, tocca «Segna come già inviata»; altrimenti tocca «Riprova».",
      "nextStepValidation": "Correggi i dati qui sotto e salva. Verrà reinviata per te.",
      "openPortal": "Apri {authority}",
      "reconnectCredentials": "Ricollega le credenziali",
      "retry": "Riprova",
      "retrySubmittedToast": "Comunicazione inviata.",
      "withdrawDescription": "{authority} segnerà la comunicazione come annullata, quindi questo ospite non risulterà più alloggiato qui. Usalo quando non lo è: un no show, o un soggiorno comunicato per la struttura sbagliata. Non si può annullare da Vidimo, e Vidimo non comunicherà più questo ospite.",
      "withdrawnBody": "La comunicazione resta nei suoi archivi, segnata come annullata. Questo ospite non risulta alloggiato qui."
    },
    "mergeConfirmView": {
      "cancel": "Annulla",
      "confirm": "Conferma unione",
      "description": "I dati di {source} verranno aggiunti al profilo di {target}.",
      "source": "Origine",
      "target": "Destinazione",
      "title": "Conferma unione"
    },
    "registrationDetailsForm": {
      "checkOutAtDeparture": "Il check-out viene comunicato alla partenza.",
      "correctDetails": "Correggi i dati",
      "correctingNote": "Al salvataggio, i dati corretti vengono inviati con ogni comunicazione ancora dovuta o respinta; quelle già accettate dall’autorità non vengono reinviate.",
      "errorNotSaved": "Impossibile salvare i dati. Riprova.",
      "idDocument": "Documento d’identità",
      "noIdOnFile": "Ancora nessun documento acquisito.",
      "optional": "Facoltativo",
      "placeholderBirthCountry": "Seleziona lo Stato di nascita",
      "placeholderDocumentType": "Seleziona il tipo di documento",
      "placeholderIssuingCountry": "Seleziona lo Stato di rilascio del documento",
      "placeholderNationality": "Seleziona la cittadinanza",
      "placeholderResidenceCountry": "Seleziona lo Stato di residenza",
      "placeholderSex": "Seleziona il sesso",
      "placeholderStayPurpose": "Seleziona il motivo del soggiorno",
      "saved": "Dati di registrazione salvati.",
      "savedBlockedAuth": "Salvato. Per l’invio bisogna ancora ricollegare le credenziali istituzionali della struttura.",
      "savedBlockedFiledByHost": "Salvato. Hai inviato tu l’altra comunicazione di questo ospite, quindi invia tu all’autorità anche questa.",
      "savedBlockedMissingData": "Salvato, ma per l’invio servono ancora dati che questa registrazione non ha.",
      "savedBlockedNoConnector": "Salvato. Vidimo non comunica questo ospite: comunicalo tu all’autorità prima della scadenza.",
      "savedBlockedOtherFacility": "Salvato. La comunicazione di questo ospite risulta inviata con un altro numero RNO. Se l’ospite non ha soggiornato nell’alloggio a cui è assegnato quel numero, annullala sul portale dell’autorità e comunica l’ospite con il numero attuale. Altrimenti completala con quel numero.",
      "savedBlockedUnknown": "Salvato, ma l’invio richiede ancora un intervento.",
      "savedBlockedValidation": "Salvato, ma l’autorità l’ha respinta di nuovo.",
      "savedFiled": "Salvato e inviato. L’autorità ha confermato.",
      "savedSubmitted": "Salvato e inviato. In attesa di conferma.",
      "scanAgain": "Scansiona di nuovo il documento",
      "scanId": "Scansiona documento",
      "title": "Registrazione",
      "typeId": "Inserisci a mano"
    },
    "reservationFolioCard": {
      "add": "Aggiungi",
      "addCharge": "Aggiungi addebito",
      "addChargeTitle": "Aggiungi addebito",
      "amountPlaceholder": "Importo ({currency})",
      "balanceDue": "Saldo da pagare",
      "breakfastControlLabel": "La colazione si imposta sulle mattine del soggiorno: vai a Colazione",
      "breakfastControlTitle": "Si imposta sulle mattine del soggiorno, in Colazione",
      "cancel": "Annulla",
      "capture": "Incassa",
      "captureConfirm": "Incassa {amount}",
      "captureDescription": "{amount} passa dalla carta dell’ospite al tuo account Stripe. È l’intera preautorizzazione: potrai rimborsarla in seguito, ma non potrai incassare il resto più tardi.",
      "captureTitle": "Incassare questa preautorizzazione?",
      "chargeKind": "Tipo di addebito",
      "chipFailed": "non riuscito",
      "chipHoldExpired": "preautorizzazione scaduta",
      "chipOnHold": "preautorizzato",
      "chipPending": "in sospeso",
      "chipRefunded": "rimborsato",
      "chipReleased": "sbloccato",
      "collectPayment": "Incassa pagamento",
      "collectedByChannelName": "Incassato da {channel}",
      "complimentary": "Omaggio",
      "descriptionPlaceholder": "Descrizione",
      "errorChargeNotAdded": "Impossibile aggiungere l’addebito. Riprova.",
      "errorChargeRemoveRolledBack": "Impossibile rimuovere l’addebito. È tornato nel conto.",
      "errorEnterAmount": "Inserisci un importo",
      "errorMoneyActionFailed": "L’operazione non è andata a buon fine. Riprova.",
      "errorPaymentNotRecorded": "Impossibile registrare il pagamento. Riprova.",
      "errorPaymentRemoveRolledBack": "Impossibile rimuovere il pagamento. È tornato nel conto.",
      "fromChannel": "Dal canale",
      "fromChannelName": "Da {channel}",
      "holdCaptured": "Preautorizzazione incassata",
      "holdReleased": "Preautorizzazione sbloccata",
      "inTheRate": "Nella tariffa",
      "kindAccommodation": "Costo della camera",
      "kindAdjustment": "Rettifica",
      "kindDiscount": "Sconto",
      "kindFee": "Supplemento",
      "kindTax": "Imposta",
      "methodBankTransfer": "Bonifico",
      "methodCard": "Carta",
      "methodCash": "Contanti",
      "methodChannelCollected": "Incassato dal canale",
      "methodDeposit": "Acconto",
      "methodGiftVoucher": "Buono regalo",
      "methodOther": "Altro",
      "noCharges": "Ancora nessun addebito.",
      "notTaken": "Non consumata",
      "partyAdults": "{count, plural, one {# adulto} other {# adulti}}",
      "partyAdultsAndChildren": "{adults, plural, one {# adulto} other {# adulti}} · {children, plural, one {# bambino} other {# bambini}}",
      "partyChildren": "{count, plural, one {# bambino} other {# bambini}}",
      "partyCovers": "{count, plural, one {# coperto} other {# coperti}}",
      "paymentMethod": "Metodo di pagamento",
      "quantityPlaceholder": "Qtà",
      "rateAdultsAndChildren": "Adulti {adult} · Bambini {child}",
      "ratePerPerson": "{amount} a persona",
      "record": "Registra",
      "recordPayment": "Registra pagamento",
      "recordPaymentTitle": "Registra pagamento",
      "referencePlaceholder": "Riferimento (facoltativo)",
      "refund": "Rimborsa",
      "refundConfirm": "Rimborsa {amount}",
      "refundDescription": "{amount} torna all’ospite dal tuo account Stripe. Stripe non restituisce la sua commissione in caso di rimborso.",
      "refundIssued": "Rimborso effettuato",
      "refundTitle": "Rimborsare questo pagamento?",
      "release": "Sblocca",
      "releaseConfirm": "Sblocca {amount}",
      "releaseDescription": "La preautorizzazione di {amount} sulla carta dell’ospite viene sbloccata e non potrai più incassarla. Per farne una nuova dovrai chiedere all’ospite di pagare di nuovo.",
      "releaseTitle": "Sbloccare questa preautorizzazione?",
      "removeCharge": "Rimuovi addebito",
      "removePayment": "Rimuovi pagamento",
      "title": "Conto",
      "total": "Totale",
      "touristTax": "Imposta di soggiorno",
      "voucherCodePlaceholder": "Codice buono (facoltativo)"
    },
    "reservationTaxCard": {
      "filedThrough": "Comunicazione tramite {system}",
      "guestNumber": "Ospite {number}",
      "guestShare": "{band} · {nights, plural, one {# notte} other {# notti}}",
      "needsBirthDates": "{count, plural, =0 {Aggiungi le date di nascita degli ospiti} one {Aggiungi la data di nascita di # ospite} other {Aggiungi le date di nascita di # ospiti}}",
      "needsCategory": "Scegli la categoria della struttura",
      "needsGuests": "Indica il numero di ospiti per vedere questa imposta",
      "needsIntegration": "Configura {system} per vedere questa imposta",
      "needsMunicipality": "Scegli il Comune della struttura per vedere questa imposta",
      "needsPrice": "Aggiungi il costo della camera per vedere questa imposta",
      "needsRegistration": "Configura la registrazione degli ospiti per vedere questa imposta",
      "noLines": "Nessuna imposta di soggiorno ancora calcolata per questa permanenza.",
      "notCovered": "Calcolo non ancora disponibile",
      "paysFree": "Esente",
      "paysFull": "Tariffa piena",
      "paysHalf": "Metà tariffa",
      "paysPercent": "{percent} della tariffa",
      "ratePercent": "{percent} del prezzo, al massimo {cap}",
      "ratePerNight": "{rate} a notte",
      "ratePerNightFrom": "Dal giorno {date}: {rate} a notte",
      "rateWithSurcharge": "{rate} + {surcharge} {label}",
      "title": "Imposta di soggiorno",
      "zone": "Tariffa per {zone}"
    },
    "reservationTaxNote": {
      "add": "Aggiungi una nota fiscale",
      "cancel": "Annulla",
      "edit": "Modifica",
      "help": "Ciò che il personale sa sull’imposta di soggiorno di questa permanenza e che la prenotazione non riporta, ad esempio che l’ospite ha mostrato una prescrizione per cure termali. Solo il personale vede questa nota.",
      "label": "Nota fiscale",
      "placeholder": "es. L’ospite ha mostrato una prescrizione del medico per cure termali",
      "save": "Salva nota",
      "saveFailed": "Impossibile salvare la nota fiscale. Riprova."
    },
    "reservationUnitDetails": {
      "adults": "{count, plural, one {{count} adulto} other {{count} adulti}}",
      "blockedChannelCancelled": "Cancellata sul canale: solo il canale può ripristinarla.",
      "blockedPermission": "Non hai il permesso di cambiare lo stato di questa prenotazione.",
      "blockedPreparing": "Questa struttura è in preparazione, quindi questo soggiorno è ancora gestito dal tuo sistema attuale. Qui non è ancora possibile modificarlo, cancellarlo o inviare il link per il check-in.",
      "bookedVia": "Prenotata tramite",
      "bookerTitle": "Chi ha prenotato",
      "bookingReference": "Riferimento prenotazione",
      "call": "Chiama",
      "callAriaLabel": "Chiama {name}",
      "checkInLabel": "Check-in",
      "checkOutLabel": "Check-out",
      "children": "{count, plural, one {{count} bambino} other {{count} bambini}}",
      "copyRoomLinkLabel": "Copia un link alla camera {room}",
      "duration": "{count, plural, one {{count} notte} other {{count} notti}}",
      "durationLabel": "Durata",
      "expectedArrivalLabel": "Arrivo previsto",
      "guestSummary": "{occupancy} · {idsOnFile} su {count, plural, one {{count} documento acquisito} other {{count} documenti acquisiti}}",
      "guestsTitle": "Ospiti",
      "houseRulesAccepted": "Accettate il {date}",
      "houseRulesLabel": "Regole della struttura",
      "infants": "{count, plural, one {{count} neonato} other {{count} neonati}}",
      "moreGuestsExpected": "{count, plural, one {Atteso ancora {count} ospite} other {Attesi ancora {count} ospiti}}",
      "notGiven": "Non indicato",
      "notOnBookingYet": "Non ancora nella prenotazione · scansiona il documento per aggiungerlo",
      "notSpecified": "Non specificato",
      "occupancyLabel": "Occupazione",
      "openGuestLabel": "Apri {name}",
      "registrationAriaLabel": "Stato della registrazione di {name}: {status}",
      "reservationInformation": "Informazioni sulla prenotazione",
      "room": "Camera {room}",
      "scanBooker": "Scansiona documento",
      "scanBookerAriaLabel": "Scansiona il documento di {name}",
      "scanId": "Scansiona documento",
      "specialRequest": "Richiesta speciale",
      "taskWithUnit": "{task} · Unità {unit}",
      "tasksTitle": "Attività",
      "typeId": "Inserisci a mano",
      "unassigned": "{count, plural, one {Da assegnare} other {# da assegnare}}",
      "unitLabel": "Unità",
      "unitsLabel": "Unità",
      "unknownUnit": "Unità sconosciuta",
      "unscheduled": "Senza data"
    },
    "stayAction": {
      "checkIn": "Effettua check-in",
      "checkInGuest": "Effettua check-in di {guestName}",
      "checkOut": "Effettua check-out",
      "checkOutGuest": "Effettua check-out di {guestName}"
    },
    "unitOptions": {
      "booked": "Occupata"
    },
    "useStayAction": {
      "errorNotUpdated": "Impossibile aggiornare il soggiorno. Riprova."
    }
  },

  "settings": {
    "accessSection": {
      "doorCode": "Codice della porta",
      "doorCodeDescription": "Gli ospiti ricevono un codice per il tastierino il giorno dell’arrivo",
      "label": "Modalità di accesso",
      "lockbox": "Cassetta portachiavi",
      "lockboxDescription": "Gli ospiti prendono la chiave da una cassetta con codice",
      "placeholder": "Seleziona la modalità di accesso",
      "receptionCloses": "Chiusura reception",
      "receptionOpens": "Apertura reception",
      "smartLock": "Serratura smart",
      "smartLockDescription": "Gli ospiti aprono con un codice o con un’app",
      "staffedReception": "Reception con personale",
      "staffedReceptionDescription": "Gli ospiti ritirano le chiavi alla reception"
    },
    "account": {
      "interfaceLanguage": {
        "automatic": "Automatica ({language})",
        "description": "Menu, pulsanti e schermate vengono mostrati in questa lingua.",
        "title": "Lingua dell’interfaccia"
      }
    },
    "accountDeletion": {
      "genericFailure": "Impossibile eliminare il tuo account. Riprova.",
      "protectedAccount": "Questo account è protetto e non può essere eliminato.",
      "soleOwner": "{properties} non {count, plural, one {ha} other {hanno}} altri titolari oltre a te. Prima di eliminare il tuo account, nomina un altro titolare o elimina {count, plural, one {la struttura} other {le strutture}}."
    },
    "accountPassword": {
      "genericFailure": "Impossibile impostare la password. Riprova.",
      "sessionStale": "Per sicurezza, esci e accedi di nuovo prima di impostare una password."
    },
    "accountView": {
      "appearanceDescription": "Le modifiche si applicano subito su questo dispositivo.",
      "appearanceTitle": "Aspetto",
      "errorNameRequired": "Il nome è obbligatorio",
      "errorPhotoNotSaved": "Impossibile salvare la foto. Riprova.",
      "hapticsDescription": "Una breve vibrazione quando un check-in, una scansione o un cambio ospite vanno a buon fine, così puoi tenere gli occhi sull’ospite. Si applica subito su questo dispositivo.",
      "hapticsTitle": "Vibrazione",
      "hapticsToggle": "Vibra alle conferme",
      "languageArabic": "Arabo",
      "languageDefault": "Predefinita (inglese)",
      "languageChinese": "Cinese",
      "languageEnglish": "Inglese",
      "languageFrench": "Francese",
      "languageGerman": "Tedesco",
      "languageItalian": "Italiano",
      "languageJapanese": "Giapponese",
      "languagePortuguese": "Portoghese",
      "languageSlovenian": "Sloveno",
      "languageSpanish": "Spagnolo",
      "nameDescription": "Visibile al tuo team e sui messaggi che invii.",
      "namePlaceholder": "Inserisci il tuo nome",
      "nameTitle": "Nome e cognome",
      "phoneDescription": "Il tuo numero di lavoro.",
      "phoneTitle": "Numero di telefono",
      "photoAlt": "Profilo",
      "photoCaption": "Tocca per cambiare la foto del profilo",
      "subtitle": "Gestisci il tuo profilo e le tue informazioni",
      "themeDark": "Scuro",
      "themeLight": "Chiaro",
      "themeSystem": "Sistema",
      "title": "Account",
      "translationLanguageDescription": "I messaggi in altre lingue vengono tradotti in questa.",
      "translationLanguageTitle": "Lingua di traduzione"
    },
    "addressSection": {
      "countryLabel": "Paese",
      "hint": "Cerca e seleziona l’indirizzo della struttura. Lo usiamo per fissare la posizione e impostare il Paese.",
      "label": "Indirizzo",
      "placeholder": "Cerca l’indirizzo della struttura…"
    },
    "availabilityDisplay": {
      "availableDuring": "Disponibile {summary}",
      "awayOn": "Assente il {date}",
      "awayRange": "Assente {range}",
      "awayThrough": "Assente fino al {end}",
      "awayToday": "Assente oggi",
      "awayTomorrow": "Assente domani",
      "outsideAvailability": "Fuori disponibilità"
    },
    "breakfastPage": {
      "adult": "Adulto",
      "child": "Bambino",
      "errorSave": "Impossibile salvare le impostazioni della colazione. Riprova.",
      "from": "Dalle",
      "inclusionCharged": "A pagamento",
      "inclusionChargedDetail": "Gli ospiti la pagano. È gratuita solo per i soggiorni venduti con tariffa bed & breakfast.",
      "inclusionComplimentary": "Omaggio",
      "inclusionComplimentaryDetail": "Gratuita per ogni ospite, qualunque tariffa abbia prenotato. Nulla finisce sul conto.",
      "inclusionIncluded": "Inclusa nella tariffa",
      "inclusionLabel": "Come viene pagata",
      "placeLabel": "Servita di solito",
      "priceHint": "A persona, a mattina, in {currency}. Chi conta come bambino lo stabilisce la prenotazione, quindi un soggiorno da un canale segue la regola d’età del canale.",
      "priceLabel": "Prezzo",
      "save": "Salva",
      "saved": "Salvato",
      "serveBreakfast": "Servi la colazione",
      "serveBreakfastHint": "Se disattivato, non viene pianificata nessuna mattina e in Oggi non compare nulla.",
      "serviceHint": "Gli ospiti vedono questi orari. Dove viene servita si può cambiare per ogni camera la mattina stessa.",
      "serviceLabel": "Servizio",
      "title": "Colazione",
      "unavailableDescription": "Vidimo non riesce a caricare le impostazioni della colazione su questo dispositivo. Tocca Riprova per ricaricare l’app.",
      "unavailableTitle": "Al momento non è possibile modificare le impostazioni della colazione",
      "until": "Alle"
    },
    "cancellationSection": {
      "flexible": "Flessibile",
      "hint": "{policyDescription} Chi prenota dalla tua pagina pubblica la vede prima di pagare, e i rimborsi la seguono.",
      "label": "Politica di cancellazione",
      "moderate": "Moderata",
      "nonRefundable": "Non rimborsabile",
      "placeholder": "Seleziona la politica di cancellazione",
      "strict": "Rigida"
    },
    "channelCards": {
      "announced": "Collega {label} per sincronizzare disponibilità e prezzi in entrambe le direzioni e ricevere nuove prenotazioni direttamente in Vidimo.",
      "cancel": "Annulla",
      "comingSoon": "Il collegamento con {label} arriverà presto.",
      "connectButton": "Collega {label}",
      "connectTitle": "Collega {label}",
      "connecting": "Collegamento…",
      "continue": "Continua",
      "errorConnect": "Impossibile collegare il canale. Riprova.",
      "errorOpenSetup": "Impossibile aprire la configurazione del canale. Riprova.",
      "errorSync": "Impossibile sincronizzare. Riprova.",
      "explainerLogin": "Si aprirà una pagina di configurazione sicura: tieni a portata di mano le credenziali di {label}.",
      "explainerOwnerOnly": "Solo l’account proprietario dell’annuncio può collegare {label}, non un co-host.",
      "explainerSync": "Disponibilità e prezzi restano sincronizzati con {label} in entrambe le direzioni, e le nuove prenotazioni arrivano in Vidimo.",
      "noUnits": "Aggiungi prima un’unità a questa struttura.",
      "opening": "Apertura…",
      "setUpChannels": "Configura {label}",
      "statusError": "errore",
      "syncAction": "Sincronizza disponibilità e prezzi",
      "syncDone": "Disponibilità e prezzi risincronizzati con {label}.",
      "syncSlow": "{label} risponde lentamente. La sincronizzazione terminerà automaticamente.",
      "syncStarted": "Sincronizzazione avviata. Terminerà in background.",
      "syncing": "Sincronizzazione…",
      "warnings": {
        "delayed": "La sincronizzazione è in ritardo. Riproveremo in automatico, non devi fare nulla.",
        "ourSide": "Si è verificato un problema da parte nostra con questo canale. Siamo già stati avvisati.",
        "unlinkedRoom": "Non siamo riusciti ad abbinare una nuova prenotazione. Controlla la configurazione del canale."
      },
      "whichUnits": "Quali unità sono pubblicate su {label}?"
    },
    "chrome": {
      "statusActionNeeded": "Intervento richiesto",
      "statusConnected": "Collegato",
      "statusOff": "Disattivato",
      "statusSettingUp": "In configurazione"
    },
    "cleaningChecklistEditor": {
      "addStep": "Aggiungi passaggio",
      "alwaysLast": "· sempre per ultimo",
      "guestNeedsHint": "Le esigenze degli ospiti indicate nella prenotazione, come una culla o un animale, vengono aggiunte subito prima del controllo finale.",
      "listFull": "{count, plural, one {Una checklist può contenere al massimo # passaggio.} other {Una checklist può contenere al massimo # passaggi.}}",
      "moveDown": "Sposta giù il passaggio {position}",
      "moveUp": "Sposta su il passaggio {position}",
      "remove": "Rimuovi il passaggio {position}",
      "saveList": "Salva checklist",
      "saving": "Salvataggio…",
      "stepBlank": "Compila questo passaggio o rimuovilo.",
      "stepLabel": "Passaggio {position}",
      "stepLength": "{length} / {max}",
      "stepPlaceholder": "Descrivi il passaggio",
      "stepTooLong": "{count, plural, one {Troppo lungo di {count} carattere.} other {Troppo lungo di {count} caratteri.}}",
      "unsavedChanges": "Modifiche non salvate"
    },
    "cleaningPage": {
      "allRooms": "Tutte le camere",
      "assignHeading": "Assegnazione",
      "discard": "Scarta",
      "discardDescription": "Questa checklist ha modifiche non salvate. Se cambi selezione ora, andranno perse.",
      "discardDescriptionReload": "Hai modifiche non salvate. Se ricarichi l’app ora, andranno perse.",
      "discardTitle": "Scartare le modifiche?",
      "errorReset": "Impossibile cambiare la checklist. Riprova.",
      "errorSave": "Impossibile salvare la checklist. Riprova.",
      "giveOwnList": "Dai a {unitName} una checklist propria",
      "hintPostCheckout": "Un ospite è partito e quel giorno non arriva nessuno.",
      "hintRefresh": "Poco prima dell’arrivo di ogni ospite, la reception ripassa la camera già pulita.",
      "hintTurnover": "Qualcuno parte e qualcun altro arriva lo stesso giorno.",
      "inheritedPostCheckoutFromProperty": "{unitName} usa la checklist della struttura per la pulizia post check-out:",
      "inheritedPostCheckoutFromStandard": "{unitName} usa la checklist standard per la pulizia post check-out:",
      "inheritedPreCheckinRefreshFromProperty": "{unitName} usa la checklist di ripasso pre-arrivo della struttura:",
      "inheritedPreCheckinRefreshFromStandard": "{unitName} usa la checklist di ripasso pre-arrivo standard:",
      "inheritedTurnoverFromProperty": "{unitName} usa la checklist della struttura per il cambio ospite:",
      "inheritedTurnoverFromStandard": "{unitName} usa la checklist standard per il cambio ospite:",
      "intro": "Queste impostazioni decidono a chi viene assegnata ogni attività di pulizia creata da Vidimo e con quali passaggi inizia. Un’assegnazione fatta a mano ha sempre la precedenza, e le attività già create mantengono l’assegnazione e i passaggi con cui sono state create.",
      "keepEditing": "Continua a modificare",
      "kindLabel": "Tipo di pulizia",
      "loading": "Caricamento delle checklist…",
      "ownListCreated": "Ora {name} ha una checklist propria. Modificala qui sotto.",
      "refreshError": "Impossibile attivare o disattivare il ripasso. Riprova.",
      "refreshHint": "La reception ripassa ogni camera dopo la pulizia, poco prima dell’arrivo dell’ospite. Vale solo per le prenotazioni aggiunte dopo l’attivazione.",
      "refreshLabel": "Ripasso prima di ogni arrivo",
      "resetLabelProperty": "Usa la checklist della struttura",
      "resetLabelStandard": "Ripristina la checklist standard",
      "resetToProperty": "Ora {name} usa la checklist della struttura.",
      "resetToStandard": "Checklist standard ripristinata.",
      "saveAndSwitch": "Salva e cambia",
      "saveFirstDescription": "Questa checklist ha modifiche non salvate. Salvale prima di cambiare, oppure scartale.",
      "saveFirstTitle": "Salvare le modifiche?",
      "saved": "Checklist salvata. Le attività di pulizia che Vidimo crea d’ora in poi la useranno.",
      "scopeHint": "Dai una checklist propria a una camera solo se richiede passaggi diversi, ad esempio per un balcone o una vasca idromassaggio.",
      "scopeLabel": "Si applica a",
      "stepsHeading": "Checklist di pulizia",
      "thisRoom": "Questa camera",
      "title": "Pulizie",
      "unavailableDescription": "Vidimo non riesce a caricare le checklist su questo dispositivo. Tocca Riprova per ricaricare l’app.",
      "unavailableTitle": "Al momento non è possibile modificare le checklist",
      "undo": "Annulla"
    },
    "createPage": {
      "created": "Struttura creata",
      "createdPendingSync": "Struttura creata. Comparirà appena la connessione si allinea.",
      "description": "Configura una nuova struttura per gestire ospiti e personale.",
      "errorNotCreated": "Impossibile creare la struttura. Riprova.",
      "title": "Crea una struttura"
    },
    "createPropertyForm": {
      "addressHint": "Cerca e seleziona l’indirizzo per fissare la posizione e compilare il Paese. Puoi aggiungere l’indirizzo in seguito.",
      "addressLabel": "Indirizzo",
      "addressNoCountry": "Quell’indirizzo non ha un Paese. Sceglilo qui sotto.",
      "addressPlaceholder": "Cerca l’indirizzo della struttura…",
      "cancel": "Annulla",
      "countryHint": "Determina la registrazione degli ospiti, l’imposta di soggiorno e l’IVA della struttura.",
      "countryLabel": "Paese *",
      "countryPlaceholder": "Seleziona il Paese",
      "nameLabel": "Nome della struttura *",
      "namePlaceholder": "Inserisci il nome della struttura",
      "submit": "Continua"
    },
    "credentialHealth": {
      "accepted": "Il {checkedAt} {system} ha accettato il tuo accesso e una comunicazione di prova. La verifica non invia nulla.",
      "badge": {
        "enterAgain": "Da reinserire",
        "keyRefused": "Chiave rifiutata",
        "noAnswer": "Nessuna risposta",
        "refusedAccount": "Account rifiutato",
        "signInRefused": "Accesso rifiutato",
        "works": "Account funzionante"
      },
      "enterAgain": "Dal {since} Vidimo non può usare le credenziali salvate, quindi non è stato inviato nulla a {system}. Inseriscile di nuovo.",
      "keyRefused": "Dal {since} {system} rifiuta questa {key}.{said} Generane una nuova e inseriscila con Aggiorna credenziali. {help}",
      "noAnswer": "Il {checkedAt} {system} non ha risposto alla verifica di Vidimo.{streak} Vidimo riproverà entro un giorno.",
      "recordRefused": "Il tuo accesso funziona. Il {checkedAt} {system} ha rifiutato la comunicazione di prova di Vidimo: tocca a noi risolvere, non a te.{said} Non è stato inviato nulla.",
      "refusedAccount": "Dal {since} {system} accetta l’accesso ma rifiuta la verifica per questo account.{said} Controlla che il web service sia attivo per questo account e che l’eventuale ID appartamento o numero di account qui sotto sia corretto.",
      "said": " Ha risposto: «{message}».",
      "signInRefused": "Dal {since} {system} rifiuta l’accesso con queste credenziali.{said} Controlla nome utente e password.",
      "streak": " Non dà un esito dal {since}.",
      "unanswered": "Il {checkedAt} {system} ha restituito un errore invece di un esito: «{message}».{streak} Vidimo riproverà entro un giorno."
    },
    "customDomainView": {
      "addDomain": "Aggiungi dominio",
      "copied": "Copiato negli appunti",
      "copyRecordValue": "Copia il valore del record {type}",
      "dnsInstructions": "Aggiungi questi record presso il registrar del tuo dominio. La propagazione delle modifiche DNS può richiedere qualche minuto.",
      "domainAdded": "Dominio aggiunto: configura i record DNS per verificarlo",
      "domainLabel": "Il tuo dominio",
      "domainLive": "Il tuo dominio è attivo",
      "domainPlaceholder": "il-tuo-hotel.it",
      "domainRemoved": "Dominio personalizzato rimosso",
      "errorAdd": "Impossibile aggiungere il dominio",
      "errorCopy": "Impossibile copiare negli appunti",
      "errorRemove": "Impossibile rimuovere il dominio",
      "intro": "Pubblica il sito Places della struttura sul tuo dominio, ad esempio <example>www.il-tuo-hotel.it</example>. Gli ospiti non vedono mai l’indirizzo vidimo.app.",
      "loadFailedBody": "Controlla la connessione e riprova.",
      "loadFailedTitle": "Impossibile caricare le impostazioni del dominio",
      "openSite": "Apri sito",
      "primary": "principale",
      "remove": "Rimuovi",
      "retry": "Riprova",
      "siteLiveBody": "Gli ospiti possono trovarti su {url}.",
      "siteLiveTitle": "Il tuo sito è online",
      "statusActive": "Attivo",
      "statusError": "Errore",
      "statusPendingDns": "DNS in attesa",
      "statusVerifying": "Verifica in corso",
      "stillWaiting": "Ancora in attesa del DNS: può richiedere qualche minuto",
      "title": "Dominio personalizzato",
      "verificationFailedBody": "Controlla i record DNS qui sotto e riprova.",
      "verificationFailedTitle": "Verifica non riuscita",
      "verify": "Verifica"
    },
    "deleteAccountSection": {
      "confirmPhrase": "elimina definitivamente",
      "description": "Elimina definitivamente il tuo account e i tuoi dati personali, inclusi il profilo, i messaggi nelle chat del team e l’accesso a tutte le strutture di cui fai parte. L’operazione è irreversibile.",
      "errorLoad": "Impossibile verificare questo account. Controlla la connessione e riprova.",
      "errorNotDeleted": "Impossibile eliminare il tuo account. Riprova.",
      "errorOffline": "Sei offline, quindi al momento non è possibile verificare questo account.",
      "title": "Elimina account"
    },
    "deleteConfirmDialog": {
      "cancel": "Annulla",
      "confirmNamePrompt": "Per confermare, digita: <strong>{entityName}</strong>",
      "confirmPhrasePrompt": "Per confermare l’eliminazione di <strong>{entityName}</strong>, digita <strong>«{expectedValue}»</strong>",
      "deleting": "Eliminazione…",
      "placeholder": "Digita «{expectedValue}»"
    },
    "deleteDangerSection": {
      "checking": "Verifica…",
      "retry": "Riprova"
    },
    "disconnectIntegration": {
      "cancel": "Annulla",
      "disconnect": "Scollega",
      "disconnected": "{channel} scollegato",
      "disconnecting": "Scollegamento…",
      "error": "Impossibile scollegare {channel}. Riprova.",
      "title": "Scollegare {channel}?"
    },
    "editableSettingCard": {
      "errorNotSaved": "Impossibile salvare. Riprova.",
      "save": "Salva",
      "saved": "Salvato",
      "saving": "Salvataggio…"
    },
    "emailPreviewSheet": {
      "frameTitle": "Anteprima email",
      "loading": "Caricamento…",
      "sampleNote": "Un esempio con nome e indirizzo della tua struttura. Date, ospite e riferimento della prenotazione sono fittizi.",
      "subject": "Oggetto",
      "title": "Anteprima"
    },
    "facilityNumber": {
      "addedWithLogin": "Il «{field}» si inserisce quando configuri l’accesso qui sotto.",
      "elsewhere": "Nel registro, il numero indicato nel campo «{field}» corrisponde a una struttura del Comune di {other}, non di questo. Controlla il numero o il Comune della struttura.",
      "errorSave": "Impossibile salvare il campo «{field}». Riprova.",
      "listed": "La struttura risulta iscritta nel registro di questo Comune.",
      "listedNamed": "Nel registro questo numero corrisponde a {name}.",
      "neededForTax": "Qui la tassa di soggiorno dipende dalla struttura: da dove si trova nel Comune, dalla sua tipologia o da chi la gestisce. A Vidimo serve questo numero per calcolarla.",
      "notListed": "Nel registro non risulta alcuna struttura attiva in questo Comune con il numero indicato nel campo «{field}». Una struttura iscritta oggi compare dal giorno successivo.",
      "registerIncomplete": "Nel registro mancano ancora alcuni dati di questa struttura che servono a calcolarne la tassa di soggiorno. Vidimo la mostrerà non appena saranno disponibili.",
      "save": "Salva",
      "saved": "{field} salvato",
      "saving": "Salvataggio…"
    },
    "guestPortalForm": {
      "cancel": "Annulla",
      "errorNotSaved": "Impossibile salvare il portale ospiti. Riprova.",
      "intro": "Gli ospiti leggono queste informazioni nella pagina del soggiorno, e le bozze di risposta dell’IA le usano per rispondere. Alle bozze non vengono mai comunicati la password del Wi-Fi né i codici delle porte.",
      "parking": "Parcheggio",
      "parkingSummary": "{count, plural, =0 {Non ancora configurato} one {# posto} other {# posti}}",
      "save": "Salva",
      "subtitle": "Cosa leggono gli ospiti nella pagina del soggiorno",
      "title": "Portale ospiti"
    },
    "guestPortalPage": {
      "title": "Portale ospiti"
    },
    "guestPreviewPage": {
      "desktopUnavailable": "L’anteprima si apre nella web app e nelle app per telefono e tablet.",
      "title": "Vedi come ospite"
    },
    "guestRegistryPage": {
      "bornOn": "n. {date}",
      "document": "{type} {number}",
      "documentIdCard": "Carta d’identità",
      "documentOther": "Documento",
      "documentPassport": "Passaporto",
      "documentWithIssuer": "{type} {number} ({country})",
      "emptyDescription": "Gli ospiti compaiono qui dopo il check-in.",
      "emptyFilteredDescription": "Nessuna registrazione corrisponde a questi filtri.",
      "emptyTitle": "Nessuna registrazione",
      "errorLoad": "Impossibile caricare il registro. Riprova.",
      "loadMore": "Carica altri",
      "loadingMore": "Caricamento…",
      "noDocument": "Nessun documento",
      "occupancy": "{adults, plural, one {# ad.} other {# ad.}}",
      "occupancyUnknownAdults": "? ad.",
      "occupancyUnknownAdultsWithChildren": "? ad. · {children, plural, one {# bamb.} other {# bamb.}}",
      "occupancyWithChildren": "{adults, plural, one {# ad.} other {# ad.}} · {children, plural, one {# bamb.} other {# bamb.}}",
      "title": "Registro ospiti"
    },
    "guestRegistryParams": {
      "statusAll": "Tutti i soggiorni",
      "statusCheckedIn": "In casa",
      "statusCheckedOut": "Partiti"
    },
    "guestRegistryRegistryFilterBar": {
      "allTime": "Sempre",
      "count": "{count, plural, one {{count} registrazione} other {{count} registrazioni}}",
      "countPartial": "{shown} su {total, plural, one {{total} registrazione} other {{total} registrazioni}}",
      "customRange": "Intervallo personalizzato",
      "exportCsv": "Esporta CSV",
      "exporting": "Esportazione…",
      "intro": "Il registro legale di chi ha soggiornato, compilato al check-in. Le registrazioni si possono solo aggiungere; consultarle ed esportarle non le modifica mai.",
      "rangePlaceholder": "Seleziona un intervallo di date",
      "searchPlaceholder": "Cerca il nome dell’ospite…",
      "statusFilterLabel": "Filtra per stato del soggiorno",
      "yearFilterLabel": "Filtra per anno"
    },
    "guestRegistryUseGuestRegistry": {
      "errorExport": "Impossibile esportare il registro.",
      "errorLoadMore": "Impossibile caricare altre registrazioni."
    },
    "houseRulesSection": {
      "houseInfoHint": "Come funziona la casa: riscaldamento, rifiuti, elettrodomestici, ore di silenzio.",
      "houseInfoLabel": "Info sulla struttura",
      "houseInfoPlaceholder": "Il riscaldamento si regola dal pannello vicino alla porta.\nI rifiuti si portano fuori il martedì sera.",
      "houseRulesHint": "Una regola per riga. Gli ospiti le leggono nel portale e le accettano una volta al check-in; lascia vuoto per saltare questo passaggio.",
      "houseRulesLabel": "Regole della struttura",
      "houseRulesPlaceholder": "Vietato fumare in tutto l’edificio.\nSilenzio dalle 22:00 alle 08:00.",
      "localTipsHint": "I tuoi consigli in zona: dove mangiare, trasporti, cosa non perdere.",
      "localTipsLabel": "Consigli locali",
      "localTipsPlaceholder": "Il caffè migliore: il bar all’angolo.\nIl bus 6 porta dritto al centro storico."
    },
    "importsPage": {
      "applyChange": "Usa la versione di {source}",
      "brief": "{guest} · {dates} · {rooms}",
      "briefBlock": "Blocco · {dates} · {rooms}",
      "briefCancelled": "{brief} · cancellata",
      "candidate": "Prenotazione già importata {number}",
      "changes": "{added, plural, one {# aggiunta} other {# aggiunte}} · {amended, plural, one {# aggiornata} other {# aggiornate}} · {cancelled, plural, one {# cancellata} other {# cancellate}} · {unchanged, plural, one {# invariata} other {# invariate}}",
      "current": "Su Vidimo",
      "detail": "{field}: {value}",
      "detailNone": "nessun dato",
      "details": {
        "adults": "Adulti",
        "amountMinor": "Totale",
        "children": "Bambini",
        "email": "Indirizzo email",
        "infants": "Neonati",
        "notes": "Note",
        "phone": "Telefono",
        "reason": "Motivo",
        "source": "Origine",
        "status": "Stato"
      },
      "emptyDescription": "Vidimo gestisce già questa struttura, quindi non è possibile importarvi prenotazioni. Le importazioni sono solo per una struttura ancora in preparazione.",
      "emptyTitle": "Nessuna prenotazione importata",
      "errorLoad": "Impossibile caricare le tue importazioni. Riprova tra poco.",
      "held": "{count, plural, one {# prenotazione richiede una tua decisione} other {# prenotazioni richiedono una tua decisione}}",
      "heldReason": {
        "host_changed": "Hai modificato la prenotazione {number} in Vidimo, o hai registrato ospiti in una camera da cui ora {source} l’ha tolta, e da allora {source} l’ha modificata. La tua versione resta finché non scegli.",
        "host_deleted": "Hai eliminato la prenotazione {number} in Vidimo, e da allora {source} l’ha modificata. Resta eliminata finché non scegli.",
        "possible_match": "La prenotazione {number} in {source} potrebbe corrispondere a una già aggiunta da un’importazione precedente con un altro numero. Non è stata aggiunta, quindi non ci sono doppioni."
      },
      "heldRoomRemoved": "La sua camera è stata rimossa da Vidimo, quindi la versione di {source} non si può usare qui.",
      "heldUntilNext": "Decidi prima che la tua app di IA esegua la prossima importazione: chiuderà queste decisioni e ti chiederà di nuovo di decidere su quelle ancora da chiarire.",
      "how": {
        "connect": "Aggiungi Vidimo a Claude o ChatGPT come connettore e, quando Vidimo te lo chiede, lascia spuntato «{importLabel}».",
        "copied": "Copiato",
        "copy": "Copia il prompt",
        "copyFailed": "Impossibile copiare. Seleziona il prompt e copialo tu.",
        "guide": "Leggi la guida",
        "paste": "Incolla questo prompt in una nuova chat. La tua app di IA ti aiuta ad aggiungere ciò che manca, ti fa qualche domanda e copia le prenotazioni.",
        "prompt": "Voglio copiare nella mia struttura Vidimo {property} le mie prenotazioni dal sistema che uso oggi. Prima di tutto, controlla di avere le due cose che servono. Se ne manca una, fermati, dimmi quale e guidami nella configurazione.\n\n1. Gli strumenti di Vidimo, come getImportPlaybook. Se non li hai, Vidimo è disattivato per questa chat oppure non è ancora stato aggiunto a questa app. Prima chiedimi di guardare tra i connettori di questa app: se Vidimo c’è, lo attivo. Se non c’è, aiutami ad aggiungerlo come connettore personalizzato con l’indirizzo {connectorUrl}. In Claude si fa da Customize, Connectors, Add, Add custom connector. In ChatGPT da Plugins, Add, Add custom MCP server. Queste sono le voci in inglese: se la mia interfaccia è in un’altra lingua, indicami quelle che compaiono sul mio schermo. Quando Vidimo me lo chiede, accedo e lascio spuntato «{importLabel}». Poi dimmi di aprire una nuova chat e di incollare di nuovo questo prompt, perché una chat ha solo i connettori con cui è stata avviata. Se puoi aprire pagine web, i passaggi sono anche su {guideUrl}.\n\n2. Un browser che puoi usare per me, in cui accedo al mio sistema e di cui leggi le pagine, come Claude in Chrome o la Work mode di ChatGPT. La ricerca web non basta, perché il mio sistema richiede l’accesso. Se in questa chat non puoi usarne uno, dimmi come ottenerlo in questa app.\n\nQuando hai entrambe le cose, chiama getImportPlaybook e seguilo.",
        "signIn": "Nel browser usato dalla tua app di IA, apri il tuo sistema attuale ed esegui l’accesso.",
        "title": "Importa le tue prenotazioni con la tua app di IA"
      },
      "ignore": "Non aggiungerla",
      "intro": "Ogni importazione eseguita dalla tua app di IA, confrontata con i totali del tuo sistema attuale, se li mostra.",
      "introUndo": "Finché questa struttura è in preparazione, puoi annullare un’importazione per rimuovere le prenotazioni che ha aggiunto.",
      "keep": "Mantienila",
      "keepDeleted": "Mantienila eliminata",
      "keepMine": "Mantieni la mia",
      "matches": "Corrisponde a {source}: le prenotazioni di ogni mese e le notti di ogni camera coincidono.",
      "mismatch": "Non corrisponde a {source}",
      "missingInVidimo": "{room}, notti del {nights}: prenotate in {source}, libere in Vidimo",
      "monthDifference": "{month}: {pms, plural, one {# arrivo} other {# arrivi}} in {source}, {vidimo} in Vidimo",
      "noTotals": "I totali di {source} non sono stati inviati con questa importazione, quindi Vidimo non può confermare che non manchi nulla. Confrontala tu con {source}.",
      "notInPms": "{room}, notti del {nights}: prenotate in Vidimo, libere in {source}",
      "notSent": "{count, plural, one {# prenotazione di un’importazione precedente non era in questa. È stata lasciata com’è, non cancellata.} other {# prenotazioni di importazioni precedenti non erano in questa. Sono state lasciate come sono, non cancellate.}}",
      "problems": "{count, plural, one {# elemento da controllare} other {# elementi da controllare}}, come segnalato dalla tua app di IA al termine",
      "proposed": "Su {source}",
      "resolveFailed": "Impossibile salvare la tua scelta. Riprova tra poco.",
      "resolveRefused": "Questa scelta non si può applicare così com’è: nel frattempo la prenotazione è cambiata, non rientra più nelle sue date o camere, oppure rimuoverebbe ospiti che hai registrato in una camera. Controlla la prenotazione in Vidimo, poi scegli di nuovo.",
      "restore": "Ripristina da {source}",
      "runTitle": "Da {source}",
      "sameBooking": "È questa prenotazione",
      "separateBooking": "Aggiungi come nuova prenotazione",
      "status": {
        "finished": "Completata",
        "open": "In corso",
        "undone": "Annullata"
      },
      "stillImporting": "Importazione ancora in corso. Al termine, viene confrontata con i totali di {source}, se la tua app di IA può inviarli.",
      "title": "Prenotazioni importate",
      "superseded": "Da allora è stata completata un’importazione più recente da {source}, quindi la verifica di questa non vale più: vedi quella più recente.",
      "totals": "{source}: {pmsBookings, plural, one {# prenotazione} other {# prenotazioni}} in arrivo, {pmsNights, plural, one {# notte camera} other {# notti camera}}. Vidimo: {vidimoBookings, plural, one {# prenotazione} other {# prenotazioni}}, {vidimoNights, plural, one {# notte camera} other {# notti camera}}.",
      "totalsFrom": "Confrontata con i totali di {source} al {date}.",
      "undo": "Annulla importazione",
      "undoAmended": "Le modifiche che ha apportato alle prenotazioni aggiunte da importazioni precedenti restano.",
      "undoBody": "Questa operazione rimuove da Vidimo {reservations, plural, one {la prenotazione} other {le # prenotazioni}}{blocks, plural, =0 {} one { e # camera bloccata} other { e # camere bloccate}} che questa importazione ha copiato da {source}. In {source} non cambia nulla, e le prenotazioni create da te o aggiunte da altre importazioni restano.",
      "undoFailed": "Impossibile annullare l’importazione. Riprova tra poco.",
      "undoGuestDetails": "{count, plural, one {# delle prenotazioni importate contiene ospiti che hai registrato: anche le loro registrazioni vengono eliminate, ma i profili degli ospiti restano.} other {# delle prenotazioni importate contengono ospiti che hai registrato: anche le loro registrazioni vengono eliminate, ma i profili degli ospiti restano.}}",
      "undoNothingAdded": "Nulla di ciò che questa importazione ha aggiunto è ancora in Vidimo, quindi annullarla non rimuove niente. Viene segnata come annullata, e le decisioni ancora in sospeso sulle sue prenotazioni vengono chiuse.",
      "undoOpenBody": "Questa importazione è ancora in corso. Annullarla la interrompe e rimuove da Vidimo tutte le prenotazioni che ha copiato finora da {source} ({reservations}). In {source} non cambia nulla, e le prenotazioni create da te o aggiunte da altre importazioni restano.",
      "undoRefusedActive": "Ora Vidimo gestisce questa struttura, quindi un’importazione non si può annullare. Modifica le sue prenotazioni una alla volta.",
      "undoTitle": "Annullare questa importazione?",
      "undone": "Importazione annullata: {reservations, plural, one {rimossa # prenotazione} other {rimosse # prenotazioni}}{blocks, plural, =0 {} one { e # camera bloccata} other { e # camere bloccate}}.",
      "undoneOn": "Annullata il {date}. Le prenotazioni che aveva aggiunto sono state rimosse.",
      "unknownRoom": "Una camera rimossa"
    },
    "infoEdit": {
      "errorNotDeleted": "Impossibile eliminare la struttura. Riprova."
    },
    "inviteMemberDrawer": {
      "emailHint": "Gli invieremo via email un link per unirsi, più un codice di invito da inserire nell’app.",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.it",
      "errorFailed": "Invito non riuscito",
      "noPermission": "Non hai il permesso di invitare membri in questa struttura.",
      "roleLabel": "Ruolo",
      "submit": "Invia invito",
      "submitPending": "Invio in corso…",
      "title": "Invita un membro"
    },
    "joinPage": {
      "description": "Inserisci il codice di invito ricevuto per unirti al tuo team.",
      "title": "Unisciti a una struttura"
    },
    "joinPropertyForm": {
      "cancel": "Annulla",
      "codeLabel": "Codice di invito",
      "codePlaceholder": "Inserisci il codice di invito",
      "submit": "Unisciti"
    },
    "linkError": {
      "alreadyLinkedToDifferentUser": "Quell’account è già collegato a un altro account Vidimo. Scollegalo prima da lì.",
      "emailDoesNotMatch": "Quell’account usa un indirizzo email diverso. Puoi collegarne solo uno con la stessa email di questo account.",
      "emailNotFound": "Quel provider non ha condiviso un indirizzo email, quindi non è possibile associarlo a questo account.",
      "generic": "Impossibile collegare quell’account. Riprova.",
      "unableToLinkAccount": "Impossibile collegare quell’account. Verifica che il suo indirizzo email sia confermato presso il provider, poi riprova."
    },
    "linkSocialAccount": {
      "linkFailed": "Impossibile collegare il tuo account {provider}"
    },
    "membersAvailability": {
      "notFound": "Membro non trovato"
    },
    "membersMembers": {
      "errorNotResent": "Impossibile reinviare l’invito. Riprova.",
      "errorNotWithdrawn": "Impossibile revocare l’invito. Riprova.",
      "resent": "Invito reinviato a {email}",
      "withdrawn": "Invito revocato"
    },
    "connectRefusal": {
      "account_claimed": "Questo account è già associato a un’altra struttura e non può essere collegato qui.",
      "contactSupport": "Contatta l’assistenza",
      "number_claimed": "Questo numero è già associato a un’altra struttura e non può essere collegato qui.",
      "numberClaimedBy": "Questo numero è già associato a {property} e non può essere collegato qui.",
      "property_preparing": "Questa struttura è in preparazione, quindi non puoi ancora collegare nulla. Un collegamento potrebbe sostituirsi a un servizio gestito dal tuo sistema attuale.",
      "setup_broken": "Non è possibile completare questa configurazione. Il team Vidimo può risolvere il problema.",
      "subscription_required": "Per collegare un canale serve un abbonamento attivo."
    },
    "messagingCards": {
      "addressCopied": "Indirizzo copiato",
      "checking": "Verifica…",
      "codeAccepted": "Codice accettato. Completamento del collegamento.",
      "codeHint": "WhatsApp lo invia via SMS o con una chiamata automatica. Può impiegare un paio di minuti ad arrivare.",
      "codeLabel": "Inserisci il codice che ti ha inviato WhatsApp",
      "codeLabelSentTo": "Inserisci il codice inviato al {e164}",
      "comingSoon": "In arrivo",
      "connectFailed": "Impossibile collegare. Riprova.",
      "connectInstagram": "Collega Instagram",
      "connectWhatsApp": "Collega WhatsApp",
      "copyEmailAddress": "Copia indirizzo email",
      "disconnectInstagramDescription": "I nuovi messaggi diretti non arriveranno più in Vidimo, e l’account viene liberato per poterlo ricollegare qui o a un’altra struttura. Le conversazioni esistenti restano in Chat.",
      "disconnectWhatsAppDescription": "I messaggi degli ospiti a questo numero non arriveranno più in Vidimo. Le conversazioni esistenti restano in Chat.",
      "emailDescription": "Gli ospiti possono scrivere a questo indirizzo. Le risposte arrivano qui in Chat: nessuna configurazione, nessun inoltro.",
      "errorCode": "Il codice non ha funzionato. Controllalo e riprova.",
      "errorConnectInstagram": "Impossibile avviare il collegamento di Instagram",
      "errorCopyAddress": "Impossibile copiare l’indirizzo",
      "errorLinkPhone": "Impossibile collegare il numero. Riprova.",
      "errorOpenManagement": "Impossibile aprire la gestione di WhatsApp. Riprova.",
      "errorReachWhatsApp": "Impossibile raggiungere WhatsApp. Riprova tra un momento.",
      "errorStartConnection": "Impossibile avviare il collegamento. Riprova.",
      "instagramConnected": "Feed e messaggi diretti sono collegati.",
      "instagramPitch": "Mostra il tuo feed e rispondi ai DM dalla casella.",
      "instagramReplyRule": "Instagram ti consente di rispondere solo dopo che un ospite ti ha scritto.",
      "linkPhone": "Collega telefono",
      "linking": "Collegamento…",
      "manageWhatsApp": "Gestisci su WhatsApp Business",
      "number": "Numero: <number>{e164}</number>",
      "numberConnected": "Numero collegato: <number>{e164}</number>",
      "numberConnecting": "Numero in collegamento: <number>{e164}</number>",
      "opening": "Apertura…",
      "phoneLinked": "Numero di telefono collegato",
      "phoneNumberLabel": "Numero di telefono (E.164)",
      "phoneSubtitle": "Voce + SMS Twilio per questa struttura",
      "reconnectInstagram": "Ricollega Instagram",
      "reconnecting": "Ricollegamento…",
      "retryConnection": "Riprova il collegamento",
      "senderOffline": {
        "displayNameRejected": "WhatsApp non ha approvato il nome visualizzato per questo numero. Scegli un altro nome in WhatsApp Manager, poi riprova il collegamento.",
        "numberReassigned": "Questo numero ora è registrato su un altro account WhatsApp, quindi i messaggi degli ospiti non arrivano più a questa struttura.",
        "numberRemoved": "Questo numero è stato rimosso da WhatsApp Business. Riprova il collegamento per configurarlo di nuovo.",
        "policyRestricted": "WhatsApp ha limitato questo numero per violazione delle sue regole per le aziende. Controlla in WhatsApp Manager cosa correggere.",
        "unrecognised": "WhatsApp ha disattivato questo numero. Riprova il collegamento per configurarlo di nuovo, o controlla i dettagli in WhatsApp Manager."
      },
      "statusActionNeeded": "Intervento richiesto",
      "statusActive": "Attivo",
      "statusConnected": "Collegato",
      "submit": "Invia",
      "twilioSidLabel": "SID del numero Twilio (facoltativo)",
      "update": "Aggiorna",
      "whatsAppEmpty": "Collega un numero WhatsApp Business per ricevere i messaggi degli ospiti di questa struttura.",
      "whatsAppNumberHeld": "WhatsApp sta ancora trattenendo questo numero. Scollegalo, poi collegalo di nuovo.",
      "whatsAppNumberHint": "Usa lo stesso numero nella procedura guidata di Meta, che si apre subito dopo.",
      "whatsAppNumberLabel": "Numero WhatsApp",
      "whatsAppReconnected": "WhatsApp ricollegato",
      "whatsAppSettingUp": "Di solito pochi minuti. Puoi lasciare questa schermata: si completa da sola.",
      "whatsAppSettingUpTitle": "Configurazione del numero con WhatsApp",
      "whatsAppSubtitle": "Messaggi degli ospiti sul numero della struttura",
      "whatsAppUnavailable": "Il collegamento di WhatsApp non è disponibile in questo ambiente."
    },
    "municipalitySection": {
      "countryPending": "Il Paese della struttura è appena cambiato. I suoi Comuni compariranno qui quando la modifica arriverà a Vidimo.",
      "loadFailed": "Impossibile caricare il Comune. Controlla la connessione.",
      "noCountry": "Prima aggiungi l’indirizzo e il Paese della struttura in <link>Generale</link>.",
      "noMatch": "Nessun Comune trovato",
      "notListed": "Vidimo non ha ancora l’elenco dei Comuni di questo Paese.",
      "pickFailed": "Impossibile salvare il Comune. Riprova.",
      "placeholder": "Scegli il tuo Comune",
      "retired": "Questo Comune non è più nell’elenco ufficiale. Scegli quello che lo ha sostituito.",
      "retry": "Riprova",
      "searchFailed": "Impossibile eseguire la ricerca. Controlla la connessione.",
      "searchLabel": "Cerca Comuni",
      "searching": "Ricerca…",
      "source": "{method, select, host {Scelto da te} address_register {Dal tuo indirizzo} other {Impostato per questa struttura}}",
      "title": "Comune",
      "typeToSearch": "Digita un nome per cercare"
    },
    "notificationsView": {
      "complianceDescription": "Registrazioni degli ospiti che Vidimo non invia e quelle prossime alla scadenza di legge",
      "complianceLabel": "Scadenze delle registrazioni",
      "messagesDescription": "Nuovi messaggi da ospiti e team",
      "messagesLabel": "Messaggi",
      "reservationsDescription": "Arrivi degli ospiti, cancellazioni e preautorizzazioni scadute",
      "reservationsLabel": "Prenotazioni",
      "title": "Notifiche"
    },
    "operationalState": {
      "badge": "In preparazione",
      "blocked": "Questa struttura è in preparazione, quindi Vidimo non la gestisce ancora. Prenotazioni e ospiti sono ancora gestiti dal tuo sistema attuale.",
      "description": "Il tuo sistema attuale la gestisce ancora. Configurala ed esplora liberamente: nulla di ciò che fai qui arriva ancora a ospiti, canali o autorità.",
      "importBookings": "Importa le tue prenotazioni",
      "noConnections": "Non è possibile collegare canali, WhatsApp, Instagram o numeri di telefono.",
      "noFilings": "Non vengono inviate registrazioni degli ospiti né statistiche.",
      "noGuestContact": "Gli ospiti non ricevono messaggi, link per il check-in o richieste di pagamento.",
      "noReservations": "Non è possibile creare, modificare o cancellare prenotazioni.",
      "privateWebsite": "Il tuo sito web e la pagina di prenotazione restano privati.",
      "title": "Questa struttura è in preparazione"
    },
    "parkingEditor": {
      "addParking": "Aggiungi parcheggio",
      "addPhotos": "Aggiungi foto",
      "cancel": "Annulla",
      "checkOnMap": "Controlla sulla mappa",
      "delete": "Elimina questo parcheggio",
      "directionsLabel": "Indicazioni",
      "directionsPlaceholder": "Entra da via Roma. Prendi il biglietto alla sbarra; lo convalidiamo alla reception.",
      "errorUpload": "Impossibile caricare quella foto.",
      "linkErrorNoLocation": "Non abbiamo trovato una posizione in quel link. In Google Maps, metti un segnaposto sul punto, tocca Condividi e incolla qui il link.",
      "linkErrorNotGoogle": "Qui funzionano solo i link di Google Maps. Apri il punto in Google Maps, tocca Condividi e incolla il link.",
      "linkErrorTooLong": "{count, plural, one {Quel link è troppo lungo da salvare (oltre {count} carattere). Metti un segnaposto in Google Maps e condividilo.} other {Quel link è troppo lungo da salvare (oltre {count} caratteri). Metti un segnaposto in Google Maps e condividilo.}}",
      "linkErrorUnreadable": "Impossibile leggere quel link. Controlla la connessione e riprova.",
      "locationLabel": "Posizione",
      "mapsLinkHint": "Per un punto senza indirizzo, metti un segnaposto in Google Maps e incollane il link. Facoltativo: lascialo vuoto se le indicazioni bastano.",
      "mapsLinkLabel": "Link di Google Maps",
      "mapsLinkPlaceholder": "Oppure incolla un link di Google Maps",
      "nameLabel": "Nome",
      "namePlaceholder": "Garage in piazza Garibaldi",
      "photoAlt": "Parcheggio {number}",
      "photosHint": "{count, plural, one {L’ingresso, la sbarra o il posto auto: fino a # foto. Vanno bene anche gli screenshot.} other {L’ingresso, la sbarra o il posto auto: fino a # foto. Vanno bene anche gli screenshot.}}",
      "photosLabel": "Foto",
      "pinnedAt": "Segnaposto a {latitude}, {longitude}",
      "removeLocation": "Rimuovi posizione",
      "removePhoto": "Rimuovi foto {number}",
      "save": "Salva",
      "searchAddress": "Cerca un indirizzo",
      "searchDifferentAddress": "Cerca un altro indirizzo",
      "uploading": "Caricamento…",
      "useLink": "Usa link"
    },
    "parkingEditorPage": {
      "deleted": "{label} eliminato.",
      "deleting": "Eliminazione…",
      "errorDelete": "Impossibile eliminare il parcheggio. Riprova.",
      "errorRestore": "Impossibile ripristinare il parcheggio. Aggiungilo di nuovo.",
      "errorSave": "Impossibile salvare il parcheggio. Riprova.",
      "newTitle": "Nuovo parcheggio",
      "notFound": "Questo parcheggio è stato eliminato o non è mai esistito.",
      "saved": "Parcheggio salvato.",
      "title": "Parcheggio",
      "undo": "Annulla"
    },
    "parkingPage": {
      "add": "Aggiungi parcheggio",
      "emptyDescription": "Aggiungi il garage, la via o l’area che usano i tuoi ospiti, con indicazioni e una foto dell’ingresso.",
      "emptyTitle": "Ancora nessun parcheggio",
      "errorReorder": "Impossibile cambiare l’ordine. Riprova.",
      "intro": "Indica agli ospiti dove lasciare l’auto. Lo vedono prima di arrivare, per organizzare il viaggio, e per tutto il soggiorno.",
      "loading": "Caricamento dei parcheggi…",
      "moveDown": "Sposta giù {label}",
      "moveUp": "Sposta su {label}",
      "photoCount": "{count, plural, one {{count} foto} other {{count} foto}}",
      "pinnedLocation": "Posizione segnata",
      "title": "Parcheggio"
    },
    "passwordDialog": {
      "cancel": "Annulla",
      "changeDescription": "Inserisci la password attuale, poi scegline una nuova. Qui la sessione resta attiva; sugli altri dispositivi viene chiusa.",
      "changeSubmit": "Cambia password",
      "changeTitle": "Cambia password",
      "confirmPasswordLabel": "Conferma la nuova password",
      "confirmPasswordPlaceholder": "Inserisci di nuovo la password",
      "currentPasswordLabel": "Password attuale",
      "errorCurrentRequired": "Inserisci la password attuale",
      "errorMismatch": "Le password non coincidono",
      "errorNotSaved": "Impossibile salvare la password. Riprova.",
      "errorTooShort": "La password deve avere almeno {count, plural, one {# carattere} other {# caratteri}}",
      "newPasswordLabel": "Nuova password",
      "newPasswordPlaceholder": "Almeno {count, plural, one {# carattere} other {# caratteri}}",
      "setDescription": "Scegli una password per poter accedere anche con il tuo indirizzo email. I metodi di accesso attuali continuano a funzionare.",
      "setSubmit": "Imposta password",
      "setTitle": "Imposta una password",
      "submitPending": "Salvataggio…"
    },
    "paymentsCard": {
      "statusActionNeeded": "Intervento richiesto",
      "statusConnected": "Collegato",
      "statusDisabled": "Disabilitato",
      "statusNotConnected": "Non collegato",
      "statusOff": "Disattivato",
      "statusSetupUnfinished": "Configurazione incompleta",
      "subtitle": "Incassa i pagamenti con carta degli ospiti tramite il tuo account Stripe",
      "subtitleSettles": "Stripe · accredito in {currency}",
      "subtitleSettlesAccountCurrency": "Stripe · accredito nella valuta del tuo account",
      "title": "Pagamenti con carta"
    },
    "paymentsPage": {
      "title": "Pagamenti"
    },
    "paymentsView": {
      "checkAgain": "Verifica di nuovo",
      "checkingWithStripe": "Verifica con Stripe",
      "connectStripe": "Collega account Stripe",
      "continueStripeSetup": "Continua la configurazione di Stripe",
      "depositChargeBody": "Incassa subito il denaro. Arriva sul tuo saldo Stripe e per restituirlo serve un rimborso.",
      "depositChargeLabel": "Addebita",
      "depositHoldBody": "Bloccalo sulla carta dell’ospite senza incassarlo. Incassa ciò che ti serve o sblocca il resto. Le preautorizzazioni scadono dopo circa 7 giorni.",
      "depositHoldLabel": "Preautorizza sulla carta",
      "depositsTitle": "Acconti",
      "description": "Incassa i pagamenti con carta degli ospiti tramite il tuo account Stripe. Il denaro arriva direttamente a te: Vidimo non trattiene commissioni.",
      "errorLoad": "Impossibile caricare le impostazioni",
      "errorOpenStripe": "Impossibile aprire Stripe",
      "errorReachStripe": "Impossibile raggiungere Stripe",
      "errorSave": "Impossibile salvare",
      "finishingSetup": "Completamento della configurazione con Stripe. Di solito servono pochi secondi.",
      "loadFailed": "Non siamo riusciti a caricare le impostazioni di pagamento. Il tuo account Stripe e i pagamenti già incassati non sono interessati.",
      "offHint": "Lascialo disattivato per continuare a registrare i pagamenti a mano, come fai oggi.",
      "openStripe": "Apri Stripe",
      "payoutsEnabled": "I bonifici sono attivi.",
      "payoutsEnabledSettles": "I bonifici sono attivi. Accredito in {currency}.",
      "payoutsNotEnabled": "I bonifici non sono ancora attivi.",
      "payoutsNotEnabledSettles": "I bonifici non sono ancora attivi. Accredito in {currency}.",
      "statusActive": "Pronto per incassare",
      "statusDisabled": "Disabilitato da Stripe",
      "statusNotStarted": "Non collegato",
      "statusPending": "Configurazione incompleta",
      "statusRestricted": "Intervento richiesto",
      "stripeAccount": "Account Stripe",
      "stripeDashboardHint": "Rimborsi, bonifici e contestazioni si gestiscono nella tua dashboard Stripe.",
      "title": "Pagamenti con carta",
      "tryAgain": "Riprova",
      "unavailable": "L’incasso con carta non è ancora disponibile in questo ambiente."
    },
    "propertyActivityView": {
      "emptyDescription": "Le modifiche a tariffe, prenotazioni, attività e ospiti verranno elencate qui man mano.",
      "emptyTitle": "Ancora niente",
      "errorLoad": "Impossibile leggere la cronologia. Trascina verso il basso per riprovare.",
      "intro": "Chi ha modificato tariffe, prenotazioni, attività e ospiti qui, e quando. Per le modifiche tariffarie è indicato se i tuoi canali le hanno accettate.",
      "loading": "Caricamento…",
      "noPropertyDescription": "Scegli una struttura per leggerne la cronologia.",
      "noPropertyTitle": "Nessuna struttura selezionata",
      "ratesChanged": "Tariffe o regole modificate per {nights}",
      "ratesChangedSpan": "Tariffe o regole modificate per {nights}, {span}",
      "title": "Cronologia",
      "unitsFreeUpdated": "Unità libere aggiornate per {nights}",
      "unitsFreeUpdatedSpan": "Unità libere aggiornate per {nights}, {span}"
    },
    "propertyBlocksView": {
      "emptyDescription": "Nulla è escluso dalla vendita. Aggiungi un blocco qui sopra per chiudere delle date.",
      "emptyTitle": "Nessuna data bloccata",
      "errorAdd": "Impossibile aggiungere il blocco. Riprova.",
      "errorRemoveRolledBack": "Impossibile rimuovere il blocco. È stato ripristinato.",
      "everyUnitType": "Ogni {unitType}",
      "firstNight": "Prima notte",
      "fromSource": "· da {source}",
      "intro": "Togli dalla vendita delle notti senza una prenotazione: un soggiorno del proprietario, una manutenzione o una chiusura manuale. Le notti bloccate non vengono più vendute qui né sui canali collegati.",
      "lastNight": "Ultima notte",
      "noPropertyDescription": "Scegli una struttura per gestirne le date bloccate.",
      "noPropertyTitle": "Nessuna struttura selezionata",
      "reason": "Motivo",
      "removeBlock": "Rimuovi il blocco dal {firstNight}",
      "submit": "Blocca date",
      "targetLabel": "Cosa bloccare",
      "targetPlaceholder": "Scegli un’unità o una tipologia di unità",
      "title": "Date bloccate",
      "unknownUnit": "Unità sconosciuta"
    },
    "propertyColorPicker": {
      "customPlaceholder": "#RRGGBB (personalizzato)",
      "hint": "Riferimento visivo usato in tutta l’app per identificare questa struttura. Lascia vuoto per scegliere automaticamente un colore stabile in base all’ID della struttura.",
      "label": "Colore",
      "reset": "Ripristina automatico",
      "swatchLabel": "Imposta il colore {color}"
    },
    "propertyEmailsView": {
      "bookingConfirmationDescription": "Inviata quando un ospite prenota e paga sul tuo sito. Le prenotazioni che arrivano da un canale vengono confermate dal canale, non da noi.",
      "bookingConfirmationLabel": "Conferma di prenotazione",
      "checkInInviteDescription": "Inviato una volta all’arrivo della prenotazione, per chiedere all’ospite di fare il check-in online. Se lo disattivi, non arriveranno prima del check-in nemmeno i dati dell’ospite che servono per le registrazioni.",
      "checkInInviteLabel": "Invito al check-in",
      "errorNotLoaded": "Impossibile caricare le impostazioni email",
      "errorNotSaved": "Impossibile salvare. Riprova.",
      "errorPreviewNotLoaded": "Impossibile caricare l’anteprima",
      "intro": "Queste email partono automaticamente verso i tuoi ospiti, dall’indirizzo della struttura, così le risposte ti arrivano in Chat. Tocca Anteprima su una di esse per leggere cosa riceve l’ospite.",
      "paymentsNeeded": "Ancora niente da inviare: parte quando un ospite paga sul tuo sito, e per questo devi prima configurare i <link>pagamenti con carta</link>.",
      "preview": "Anteprima",
      "signInLinkNote": "Gli ospiti possono anche richiedere un link di accesso al soggiorno. In quel caso è l’ospite a chiedere di rientrare nella propria prenotazione, quindi viene sempre inviato. Ciò che scrivi tu in Chat parte quando lo invii.",
      "title": "Email agli ospiti"
    },
    "propertyForm": {
      "avatarFallbackName": "Struttura",
      "cancel": "Annulla",
      "confirmPhrase": "elimina",
      "deleteDescription": "Rimuovi definitivamente questa struttura e tutti i dati associati (unità, prenotazioni, attività). L’operazione è irreversibile.",
      "deleteTitle": "Elimina struttura",
      "descriptionHint": "Questa descrizione sarà visibile a ospiti e utenti",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "Descrivi questa struttura",
      "errorNotSaved": "Impossibile salvare la struttura. Riprova.",
      "imageCaption": "Tocca per cambiare l’immagine della struttura",
      "nameLabel": "Nome della struttura",
      "namePlaceholder": "Inserisci il nome della struttura",
      "readOnlyNotice": "Questa struttura non ha un abbonamento attivo, quindi i suoi dati non si possono modificare.",
      "save": "Salva",
      "shortCodeHintAuto": "Compilato in automatico dal nome della struttura. Scrivi per modificarlo; svuota il campo per riattivare la compilazione automatica.",
      "shortCodeHintManual": "Usato come etichetta compatta in calendari e badge. Svuota il campo per seguire automaticamente il nome della struttura.",
      "shortCodeLabel": "Codice breve",
      "subtitle": "Gestisci i dati e l’immagine della struttura",
      "title": "Generale"
    },
    "propertyIntegrationsView": {
      "communicationSubtitle": "Canali di {name}",
      "communicationTitle": "Comunicazione con gli ospiti",
      "distributionSubtitle": "Dove {name} riceve prenotazioni",
      "distributionTitle": "Canali di distribuzione",
      "loading": "Caricamento…",
      "paymentsSubtitle": "Come incassa {name}",
      "paymentsTitle": "Pagamenti"
    },
    "propertyMembersView": {
      "cancelInvitation": "Annulla invito",
      "codeCopied": "Codice di invito copiato",
      "copyCode": "Copia codice di invito",
      "errorCodeNotCopied": "Impossibile copiare: seleziona il codice e copialo a mano.",
      "invite": "Invita",
      "invitedAs": "Ruolo: {role}",
      "memberCount": "{count, plural, one {# membro} other {# membri}}",
      "moreActions": "Altre azioni",
      "noMatches": "Nessun membro corrisponde alla ricerca.",
      "pendingInvitations": "Inviti in sospeso",
      "removeConfirm": "Rimuovere {name} da {property}?",
      "removeFromProperty": "Rimuovi dalla struttura",
      "resend": "Reinvia",
      "searchPlaceholder": "Cerca membri…",
      "title": "Membri"
    },
    "propertyNotFound": {
      "notFound": "Struttura non trovata",
      "syncing": "Sincronizzazione della struttura…"
    },
    "propertyPhotosView": {
      "addPhotos": "Aggiungi foto",
      "added": "{count, plural, one {Foto aggiunta} other {# foto aggiunte}}",
      "addedSome": "{total, plural, one {Aggiunte {added} foto su #.} other {Aggiunte {added} foto su #.}}",
      "addedSomeWithReason": "{total, plural, one {Aggiunte {added} foto su #. {reason}} other {Aggiunte {added} foto su #. {reason}}}",
      "descriptionHint": "Letta ad alta voce dagli screen reader, ed è l’unico testo che i motori di ricerca hanno per questa immagine.",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "es. La terrazza al tramonto",
      "emptyDescription": "Aggiungi foto della struttura e delle camere. Finché non lo fai, la tua pagina pubblica resta fuori dai risultati di ricerca.",
      "emptyTitle": "Ancora nessuna foto",
      "errorDescriptionNotSaved": "Impossibile salvare la descrizione",
      "errorNotAdded": "Impossibile aggiungere la foto",
      "errorNotMoved": "Impossibile spostare la foto",
      "errorNotRemoved": "Impossibile rimuovere la foto",
      "errorNotReordered": "Impossibile riordinare le foto",
      "intro": "Compaiono sulla pagina pubblica della struttura. La prima foto apre la galleria e viene usata quando la pagina viene condivisa.",
      "mainGallery": "Galleria principale",
      "moveEarlier": "Sposta prima",
      "moveLater": "Sposta dopo",
      "removePhoto": "Rimuovi foto",
      "removed": "Foto rimossa",
      "showsOn": "Compare in",
      "title": "Foto",
      "uploading": "Caricamento…"
    },
    "propertyRatesView": {
      "addSeason": "Aggiungi stagione",
      "basePerNight": "Base / notte",
      "cancel": "Annulla",
      "editSeason": "Modifica la stagione {name}",
      "editingSeason": "Modifica di «{name}»",
      "ensureFailedDescription": "Non siamo riusciti a creare i piani tariffari. Controlla la connessione e riprova.",
      "ensureFailedTitle": "Impossibile configurare i prezzi",
      "errorBaseRateRolledBack": "Impossibile salvare il prezzo per notte. Riprova.",
      "errorFloorRolledBack": "Impossibile salvare il prezzo minimo. Riprova.",
      "errorRemoveSeasonRolledBack": "Impossibile rimuovere la stagione. È stata ripristinata.",
      "errorSaveSeason": "Impossibile salvare la stagione. Riprova.",
      "firstNight": "Prima notte",
      "floorHint": "Nessuna notte, stagione o tariffa base può scendere sotto questo valore.",
      "floorLabel": "Prezzo minimo",
      "floorOwnerOnly": "Solo il titolare può modificarlo.",
      "intro": "Imposta una tariffa base per tipologia di unità e dai un prezzo a periodi di notti con le stagioni. Le modifiche si sincronizzano con i canali collegati.",
      "lastNight": "Ultima notte",
      "minStay": "Soggiorno min.",
      "minStayPlaceholder": "Qualsiasi",
      "noFloor": "Nessun prezzo minimo impostato",
      "noSeasons": "Nessuna stagione. Le notti usano la tariffa base qui sopra.",
      "noUnitsDescription": "Aggiungi unità a questa struttura prima di impostare i prezzi.",
      "noUnitsTitle": "Ancora nessuna unità",
      "none": "Nessuno",
      "notSet": "Non impostato",
      "occupancyReduction": "Per ospite in meno",
      "occupancyReductionHint": "Sottratto dalla tariffa per notte per ogni ospite al di sotto della capienza della tipologia di unità. Solo prenotazioni dirette; sui canali si vende a tariffa piena.",
      "openRates": "Vedi e modifica le tariffe per notte",
      "pricePerNight": "Prezzo / notte",
      "pricePlaceholder": "Base",
      "priority": "Priorità",
      "removeSeason": "Rimuovi la stagione {name}",
      "saveChanges": "Salva modifiche",
      "savedFloor": "Salvato: {amount}",
      "savedNoFloor": "Salvato: nessun prezzo minimo",
      "seasonBaseRate": "tariffa base",
      "seasonDates": "dal {start} al {end}",
      "seasonLabel": "Stagione",
      "seasonMinStay": "{count, plural, one {· min {count} notte} other {· min {count} notti}}",
      "seasonOccupancyReduction": "· −{amount} per ospite sotto la capienza (dirette)",
      "seasonPlaceholder": "Estate 2027",
      "seasonPriority": "· priorità {priority}",
      "seasonShortStaySurcharge": "{count, plural, one {· +{amount} sotto {count} notte (dirette)} other {· +{amount} sotto {count} notti (dirette)}}",
      "seasonsHeading": "Stagioni",
      "seasonsPriorityHint": "Dove i periodi si sovrappongono vince la priorità più alta",
      "settingUp": "Configurazione…",
      "shortStayPlaceholder": "notti",
      "shortStayUnder": "Soggiorno breve sotto",
      "surcharge": "Supplemento",
      "surchargeHint": "Aggiunto a un soggiorno più breve delle notti indicate sopra. Solo prenotazioni dirette: i dati inviati ai canali hanno un’unica tariffa fissa per notte e non possono esprimerlo.",
      "title": "Prezzi",
      "tryAgain": "Riprova"
    },
    "propertyRegistrationView": {
      "asksBeforeSubmitting": "Le tue credenziali restano salvate. Vidimo ti chiederà conferma prima di inviare qualsiasi cosa con queste credenziali.",
      "checkAgainAfter": "Puoi verificare di nuovo dopo le {time}.",
      "checkBusy": "È già in corso una verifica.",
      "checkFailed": "Impossibile eseguire la verifica. Riprova.",
      "checkNow": "Verifica ora",
      "checkRefused": "Queste credenziali sono state rifiutate. Aggiornale per verificare di nuovo.",
      "checkTooOften": "Troppe verifiche. Riprova più tardi.",
      "checking": "Verifica…",
      "confirmDisconnect": "Scollegare queste credenziali? Le rimuoveremo dal tuo account.",
      "confirmDisconnectChecked": "Scollegare queste credenziali? Le rimuoveremo dal tuo account e smetteremo di verificarle.",
      "confirmDisconnectFiling": "Scollegare queste credenziali? Smetteremo di inviare comunicazioni a questo sistema finché non le ricolleghi.",
      "confirmDisconnectWaiting": "Scollegare queste credenziali? Le rimuoveremo dal tuo account e la configurazione non si riaprirà finché l’invio automatico non sarà pronto.",
      "connectToCheck": "Collega per verificare",
      "connectToCheckLine": "Collega ora il tuo account e Vidimo verifica che funzioni. La verifica non invia nulla.",
      "credentialsDisconnected": "Credenziali scollegate",
      "credentialsStay": "Le tue credenziali restano salvate e inizieremo a inviare appena sarà pronto.",
      "disconnect": "Scollega",
      "disconnecting": "Scollegamento…",
      "errorDisconnect": "Impossibile scollegare. Riprova.",
      "errorLoadCredentials": "Impossibile caricare le credenziali. Riprova.",
      "fileEachGuestYourself": "Comunica tu ogni ospite prima della scadenza.",
      "filesFrom": "Vidimo comunica gli ospiti in arrivo dal {date}. Se Vidimo non ha comunicato un soggiorno precedente, comunicalo tu.",
      "inPreparationConnector": "Vidimo predispone le tue comunicazioni per {system}. L’invio automatico è ancora in sviluppo.",
      "onFileSecret": "{label}: ••••",
      "onFileValue": "{label}: {value}",
      "setUp": "Configura",
      "setupOpensLater": "La configurazione delle credenziali si aprirà qui quando sarà pronta.",
      "statusConnected": "Collegato",
      "statusInPreparation": "In sviluppo",
      "statusNeedsAttention": "Richiede un intervento",
      "statusNotConnected": "Non collegato",
      "updateCredentials": "Aggiorna credenziali"
    },
    "propertySettingsView": {
      "activityDescription": "Chi ha modificato tariffe e prenotazioni, e quando",
      "activityTitle": "Cronologia",
      "blockedDatesDescription": "Togli notti dalla vendita per soggiorni del proprietario, manutenzione o chiusure manuali",
      "blockedDatesTitle": "Date bloccate",
      "breakfastDescription": "Orari, prezzo e dove viene servita",
      "breakfastTitle": "Colazione",
      "cleaningDescription": "A chi va ogni attività di pulizia e con quali passaggi inizia",
      "cleaningTitle": "Pulizie",
      "complianceDescription": "Registrazione ospiti, statistiche, imposta di soggiorno e registro ospiti",
      "complianceTitle": "Adempimenti",
      "customDomainDescription": "Pubblica il sito Places sul tuo dominio",
      "customDomainTitle": "Dominio personalizzato",
      "generalDescription": "Nome, indirizzo, descrizione e dettagli",
      "generalTitle": "Generale",
      "groupAccount": "Account",
      "groupGuests": "Ospiti",
      "groupProperty": "Struttura",
      "guestEmailsDescription": "Cosa inviamo automaticamente via email ai tuoi ospiti, e da quale indirizzo",
      "guestEmailsTitle": "Email agli ospiti",
      "guestPortalDescription": "Cosa leggono gli ospiti nella pagina del soggiorno, con anteprima: accesso, regole, Wi-Fi",
      "guestPortalTitle": "Portale ospiti",
      "guestPreviewDescription": "Guarda la pagina del soggiorno come la vede un ospite, da prima dell’arrivo a dopo il check-out",
      "guestPreviewTitle": "Vedi come ospite",
      "guestRegistryDescription": "Registro legale di chi ha soggiornato, con esportazione CSV",
      "guestRegistryTitle": "Registro ospiti",
      "importsDescription": "Prenotazioni che la tua app di IA ha copiato dal tuo sistema attuale, confrontate con i suoi totali, se li mostra",
      "importsTitle": "Prenotazioni importate",
      "membersDescription": "Gestisci chi ha accesso a questa struttura",
      "membersTitle": "Membri",
      "messagingDescription": "Dove gli ospiti ti contattano e le email che inviamo per te",
      "messagingTitle": "Messaggistica",
      "notFoundTitle": "Struttura",
      "parkingDescription": "Dove parcheggiano gli ospiti, visibile prima e durante il soggiorno",
      "parkingTitle": "Parcheggio",
      "photosDescription": "Foto mostrate sulla pagina pubblica della struttura",
      "photosTitle": "Foto",
      "pricingDescription": "Tariffe per notte, soggiorno minimo e notti chiuse delle tue unità",
      "pricingTitle": "Prezzi",
      "roomsDescription": "Unità, prezzi, notti bloccate e i canali con cui si sincronizzano",
      "roomsTitle": "Camere e tariffe",
      "sectionExtras": "Extra",
      "sectionHousekeeping": "Pulizie e riassetto",
      "sectionInventory": "Cosa vendi",
      "sectionMoving": "Passaggio a Vidimo",
      "sectionPeople": "Persone",
      "sectionPublicPage": "Pagina pubblica",
      "sectionRecords": "Registri",
      "sectionSentAutomatically": "Invii automatici",
      "sectionStayPage": "Pagina del soggiorno",
      "siteDescription": "La tua pagina pubblica (contenuti, foto e dominio) e i pagamenti con carta",
      "siteTitle": "Sito web",
      "stayDescription": "Cosa leggono gli ospiti prima e durante il soggiorno, parcheggio e colazione",
      "stayTitle": "Soggiorno degli ospiti",
      "teamDescription": "Membri, regole e checklist delle pulizie, e chi ha modificato cosa",
      "teamTitle": "Team",
      "title": "Impostazioni",
      "unitsDescription": "Gestisci le unità e le tipologie di unità della struttura",
      "unitsTitle": "Unità",
      "websiteDescription": "Storia, punti di forza, recensioni e FAQ per la tua pagina pubblica",
      "websiteTitle": "Contenuti della pagina"
    },
    "propertyUnitsView": {
      "clearSearch": "Cancella ricerca",
      "createUnit": "Crea unità",
      "emptyDescription": "Crea la tua prima unità per iniziare.",
      "emptyTitle": "Ancora nessuna unità",
      "maxGuests": "{count, plural, one {{count} ospite} other {{count} ospiti}}",
      "noMatchDescription": "Prova un altro termine o cancella la ricerca.",
      "noMatchTitle": "Nessuna unità corrisponde alla ricerca",
      "searchPlaceholder": "Cerca unità…",
      "title": "Unità"
    },
    "propertyWebsiteView": {
      "activitiesIntroLabel": "Introduzione",
      "activitiesIntroPlaceholder": "Cosa c’è da fare nei dintorni?",
      "activityBlurbPlaceholder": "Sul fiume color smeraldo",
      "activityTitlePlaceholder": "Kayak",
      "addActivity": "Aggiungi un’attività",
      "addDistance": "Aggiungi una distanza",
      "addHighlight": "Aggiungi un punto di forza",
      "addQuestion": "Aggiungi una domanda",
      "addReview": "Aggiungi una recensione",
      "defaultsToPropertyName": "Di default è il nome della struttura",
      "enquiryLabel": "Mostra un pulsante per richieste via WhatsApp",
      "errorImageNotUploaded": "Impossibile caricare l’immagine",
      "errorNotLoaded": "Impossibile caricare i contenuti del sito",
      "errorNotSaved": "Impossibile salvare le modifiche",
      "facebookLabel": "URL Facebook",
      "faqAnswerPlaceholder": "Risposta",
      "faqQuestionPlaceholder": "Domanda",
      "headlineLabel": "Titolo personalizzato",
      "highlightIconPlaceholder": "Icona (es. waves)",
      "highlightLabelPlaceholder": "Piscina",
      "highlightSublabelPlaceholder": "Aperta da maggio a novembre",
      "instagramLabel": "Nome utente Instagram",
      "instagramPlaceholder": "iltuohotel",
      "intro": "Tutto ciò che è qui compare sulla pagina pubblica della struttura. Lascia vuota una sezione per nasconderla.",
      "loadFailed": "Non siamo riusciti a caricare i contenuti del sito.",
      "locationIntroLabel": "Introduzione alla posizione",
      "locationIntroPlaceholder": "Cosa c’è nei dintorni, in una o due frasi",
      "nearbyLabelPlaceholder": "Piazza principale",
      "nearbyValuePlaceholder": "2 min a piedi",
      "off": "Disattivato",
      "on": "Attivo",
      "remove": "Rimuovi",
      "removeImage": "Rimuovi immagine",
      "replacePhoto": "Sostituisci foto",
      "reviewAuthorPlaceholder": "Nome",
      "reviewLocationPlaceholder": "Città (facoltativa)",
      "reviewQuotePlaceholder": "Cosa ha detto l’ospite",
      "reviewRatingPlaceholder": "Voto 1–5",
      "reviewSourcePlaceholder": "TripAdvisor (facoltativo)",
      "saveChanges": "Salva modifiche",
      "saved": "Sito aggiornato",
      "sectionEnquiries": "Richieste",
      "sectionFaqs": "FAQ",
      "sectionHero": "Apertura",
      "sectionHighlights": "Punti di forza",
      "sectionLocation": "Posizione",
      "sectionReviews": "Recensioni",
      "sectionSearch": "Ricerca (SEO)",
      "sectionSocial": "Social",
      "sectionStory": "Storia",
      "sectionThingsToDo": "Cosa fare",
      "seoDescriptionLabel": "Meta description",
      "seoDescriptionPlaceholder": "Una o due frasi per i risultati di ricerca",
      "seoTitleLabel": "Titolo della pagina personalizzato",
      "storyImageLabel": "Immagine della storia",
      "storyLabel": "La tua storia",
      "storyPlaceholder": "Come è nato questo posto…",
      "taglineLabel": "Slogan",
      "taglinePlaceholder": "Una frase breve che faccia venire voglia di soggiornare",
      "tiktokLabel": "URL TikTok",
      "title": "Contenuti della pagina",
      "tryAgain": "Riprova",
      "uploadPhoto": "Carica foto",
      "viewPublicPage": "Vedi pagina pubblica"
    },
    "registrationCards": {
      "comingBody": "Vidimo sta attivando la registrazione degli ospiti e la gestione dell’imposta di soggiorno un Paese alla volta. Finché il Paese della tua struttura non sarà incluso, continua a occuparti di entrambe come fai oggi. Facci sapere se ti servono per {name} e ti avviseremo appena saranno disponibili.",
      "comingTitle": "In arrivo in altri Paesi",
      "filesGuests": "registrazione ospiti",
      "filesStatistics": "statistiche",
      "filesTouristTax": "imposta di soggiorno",
      "pickMunicipality": "Scegli il tuo Comune per configurare le integrazioni.",
      "registrationSubtitle": "Comunicazione degli ospiti di {name} alle autorità",
      "registrationTitle": "Registrazione ospiti",
      "statisticsNotCovered": "Vidimo non invia ancora le statistiche turistiche per la Regione del tuo Comune, quindi continua a inviarle tu all’ufficio turismo della tua Regione.",
      "statisticsSubtitle": "Comunicazioni statistiche sul turismo di {name}",
      "statisticsTitle": "Statistiche",
      "statusConnected": "Collegato",
      "statusInPreparation": "In sviluppo",
      "statusNeedsAttention": "Richiede un intervento",
      "statusNotConnected": "Non collegato"
    },
    "registrationCredentialForm": {
      "beforeYouStart": "Prima di iniziare",
      "checkNotice": "Quando salvi, Vidimo accede a {system} e verifica una comunicazione di prova. La verifica non invia nulla.",
      "checkNoticeAsks": "Quando salvi, Vidimo accede a {system} e verifica una comunicazione di prova. La verifica non invia nulla, e Vidimo ti chiederà conferma prima di comunicare qualsiasi ospite.",
      "chooseFile": "Scegli file",
      "connect": "Collega",
      "errorInvalid": "Impossibile salvare. Controlla i valori inseriti e riprova.",
      "errorPlaceChanged": "Impossibile salvare: {system} non è disponibile dove si trova ora la tua struttura. Controlla il suo Comune.",
      "errorReadFile": "Impossibile leggere quel file.",
      "errorSave": "Impossibile salvare le credenziali. Riprova.",
      "fileOnFile": "salvato",
      "fileOnFileNamed": "{name} salvato",
      "noFileSelected": "Nessun file selezionato",
      "openAuthority": "Apri {authority}",
      "replaceFile": "Sostituisci file",
      "saved": "Credenziali salvate",
      "savedAlreadyRefused": "Salvate. {system} le aveva già rifiutate, quindi non sono state verificate di nuovo",
      "savedNoAnswer": "Salvate. {system} non ha risposto alla verifica",
      "savedNotChecked": "Salvate. Non ancora verificate",
      "savedRefused": "Salvate, ma {system} le ha rifiutate",
      "savedRefusedAccount": "Salvate, ma {system} ha rifiutato la verifica per questo account",
      "savedUnreadable": "Salvate, ma Vidimo non è riuscito a leggerle",
      "savedWorks": "Salvate. Il tuo account funziona",
      "secretOnFilePlaceholder": "•••••••• salvata. Lascia vuoto per mantenerla.",
      "update": "Aggiorna"
    },
    "integrationPage": {
      "changeMunicipality": "Cambia il Comune in Adempimenti",
      "deadline": "Scadenza",
      "deadlineFromArrival": "{hours, plural, one {entro {hours} ora dall’arrivo} other {entro {hours} ore dall’arrivo}}",
      "deadlineFromArrivalWithDeparture": "{hours, plural, one {entro {hours} ora dall’arrivo; si comunica anche la partenza} other {entro {hours} ore dall’arrivo; si comunica anche la partenza}}",
      "deadlineShortStay": "{hours, plural, one {entro {hours} ora} other {entro {hours} ore}} se il soggiorno non supera {maxStayHours, plural, one {{maxStayHours} ora} other {le {maxStayHours} ore}}",
      "disconnectAccount": "Puoi scollegare l’account configurato in precedenza.",
      "lawRequires": "Cosa prevede la legge",
      "loginTitle": "Accesso a {system}",
      "municipality": "Comune",
      "noMunicipality": "Scegli il Comune della tua struttura, così Vidimo sa che lì si applica {system}.",
      "notFound": "Integrazione non trovata",
      "notOffered": "{system} non è disponibile nel Paese della tua struttura. Controlla l’indirizzo della struttura.",
      "notPicked": "Non ancora scelto",
      "pickMunicipality": "Scegli il Comune in Adempimenti",
      "propertyTitle": "La tua struttura su {system}",
      "regionMoved": "Queste credenziali sono della Regione {onFile}, ma il tuo Comune fa capo alla Regione {current}. Aggiornale con i tuoi dati di accesso della Regione {current}.",
      "regionNotCovered": "Vidimo non invia ancora le statistiche per la Regione del tuo Comune.",
      "reportsTo": "Regione di riferimento",
      "requiredFields": "Obbligatori per ogni ospite comunicato",
      "scopeAllGuests": "Tutti gli ospiti",
      "scopeForeignGuestsOnly": "Solo ospiti stranieri",
      "setBy": "Stabilito da <bases></bases>",
      "who": "Chi"
    },
    "roleSelect": {
      "changeRoleFrom": "Cambia ruolo da {role}",
      "title": "Cambia ruolo"
    },
    "searchSortBar": {
      "sortAscending": "Ordina A-Z (tocca per Z-A)",
      "sortDescending": "Ordina Z-A (tocca per A-Z)"
    },
    "settingsRowStates": {
      "breakfastOff": "Disattivata",
      "breakfastOn": "Attiva",
      "members": "{count, plural, one {# persona} other {# persone}}",
      "parking": "{count, plural, =0 {Ancora nessuno} one {# posto} other {# posti}}",
      "photos": "{count, plural, =0 {Ancora nessuna} one {# foto} other {# foto}}",
      "units": "{count, plural, =0 {Ancora nessuna} one {# unità} other {# unità}}"
    },
    "signInMethods": {
      "apple": "Apple",
      "credential": "Email e password",
      "google": "Google"
    },
    "signInSecuritySection": {
      "changePassword": "Cambia password",
      "connect": "Collega",
      "description": "I modi in cui puoi accedere a questo account. Aggiungine un secondo, così non perdi mai l’accesso se un provider non è disponibile.",
      "errorLoad": "Impossibile caricare i metodi di accesso. Controlla la connessione e riprova.",
      "errorOffline": "Sei offline, quindi al momento non è possibile caricare i metodi di accesso.",
      "errorPasswordNotChanged": "Impossibile cambiare la password. Riprova.",
      "errorSessionNotFresh": "Per sicurezza, esci e accedi di nuovo prima di rimuovere un metodo di accesso.",
      "errorUnlinkFailed": "Impossibile rimuovere quel metodo di accesso.",
      "errorWrongCurrentPassword": "Non è la tua password attuale. Riprova.",
      "loading": "Caricamento dei metodi di accesso…",
      "remove": "Rimuovi",
      "retry": "Riprova",
      "setPassword": "Imposta password",
      "statusConnected": "Collegato",
      "statusNoPassword": "Nessuna password impostata",
      "statusNotConnected": "Non collegato",
      "statusOnlyMethod": "Il tuo unico metodo di accesso",
      "statusPasswordSet": "Password impostata",
      "title": "Accesso e sicurezza"
    },
    "staffAvailabilityForm": {
      "addTimeOff": "Aggiungi assenza",
      "addWindow": "Aggiungi fascia",
      "dayLabel": "Giorno",
      "endLabel": "Fine <optional>(facoltativa)</optional>",
      "errorTimeOffNotAdded": "Impossibile aggiungere l’assenza. Riprova.",
      "errorTimeOffNotRemoved": "Impossibile rimuovere l’assenza. È stata ripristinata.",
      "errorWindowNotAdded": "Impossibile aggiungere l’orario. Riprova.",
      "errorWindowNotRemoved": "Impossibile rimuovere quell’orario. È stato ripristinato.",
      "fromLabel": "Dalle",
      "noTimeOff": "Nessuna assenza registrata.",
      "noWindows": "Ancora nessuna fascia: {name} risulta non disponibile ovunque.",
      "noteLabel": "Nota",
      "notePlaceholder": "Facoltativa (es. dentista)",
      "removeTimeOff": "Rimuovi assenza",
      "removeWindow": "Rimuovi fascia",
      "startLabel": "Inizio",
      "timeOffTitle": "Assenze",
      "title": "Disponibilità",
      "toLabel": "Alle",
      "viewOnly": "Sola lettura: la disponibilità la imposta un titolare o un manager.",
      "weeklyDescription": "{name} è disponibile in queste fasce. Al di fuori puoi comunque assegnare attività a mano per casi singoli.",
      "weeklyTitle": "Disponibilità settimanale",
      "windowRange": "{day} {start}-{end}"
    },
    "staffTaskFunctionsForm": {
      "description": "Una regola di pulizia che richiede una di queste mansioni assegna l’attività solo a chi ha quella mansione. Puoi comunque assegnare chiunque a mano.",
      "errorNotSaved": "Impossibile salvare la modifica. Riprova.",
      "title": "Mansioni"
    },
    "statisticsFilingsHistory": {
      "description": "Comunicazioni di arrivi e presenze inviate alla tua Regione.",
      "errorRetry": "Impossibile ritentare la comunicazione. Riprova.",
      "reference": "Riferimento: {reference}",
      "retry": "Riprova",
      "retryFailedAgain": "La comunicazione non è riuscita di nuovo.",
      "retryFiled": "Comunicazione statistica inviata.",
      "retryNotWaiting": "Questa comunicazione non richiede più un tuo intervento.",
      "statusActionNeeded": "Intervento richiesto",
      "statusCanceled": "Annullata",
      "statusFiled": "Confermata",
      "statusFiling": "Invio in corso…",
      "statusRetrying": "Nuovo tentativo",
      "statusScheduled": "Programmata",
      "statusSubmitted": "Inviata",
      "title": "Comunicazioni statistiche"
    },
    "stayTimesSection": {
      "checkIn": "Check-in dalle",
      "checkOut": "Check-out entro le"
    },
    "taskCalendarFeedSection": {
      "cancel": "Annulla",
      "copyLink": "Copia link",
      "create": "Crea link al calendario",
      "createPending": "Creazione del link…",
      "description": "Segui le attività assegnate a te in Google Calendar, Calendario di Apple o Outlook.",
      "errorCopy": "Impossibile copiare il link",
      "errorCreate": "Impossibile creare il link al calendario. Riprova.",
      "errorLoad": "Impossibile caricare il link al calendario. Controlla la connessione e riprova.",
      "errorOffline": "Sei offline, quindi al momento non è possibile caricare il link al calendario.",
      "errorRegenerate": "Impossibile creare un nuovo link. Riprova.",
      "errorTurnOff": "Impossibile disattivare il link. Riprova.",
      "linkCopied": "Link al calendario copiato",
      "linkLabel": "Link al calendario",
      "loading": "Caricamento del link al calendario…",
      "newLink": "Nuovo link",
      "offlineActionsNote": "Sei offline. Puoi ancora copiare; per creare un nuovo link o disattivarlo serve la connessione.",
      "offlineCreateNote": "Sei offline. Per creare un link serve la connessione.",
      "privacyNote": "Chiunque abbia questo link può vedere le tue attività. Se finisce in mani sbagliate, creane uno nuovo.",
      "regenerateConfirm": "Crea nuovo link",
      "regenerateDescription": "Il link attuale smette subito di funzionare, e i calendari che lo usano non si aggiornano più finché non aggiungi quello nuovo.",
      "regeneratePending": "Creazione del link…",
      "regenerateTitle": "Creare un nuovo link?",
      "retry": "Riprova",
      "subscribeHelp": "Aggiungilo alla tua app di calendario come calendario da URL. Le app di calendario controllano le modifiche con i loro tempi, che possono arrivare a qualche ora.",
      "title": "Calendario attività",
      "turnOff": "Disattiva",
      "turnOffConfirm": "Disattiva",
      "turnOffDescription": "Il link smette subito di funzionare e i calendari che lo usano non si aggiornano più. Puoi creare un nuovo link qui in qualsiasi momento.",
      "turnOffPending": "Disattivazione…",
      "turnOffTitle": "Disattivare il link al calendario?"
    },
    "taskRulesPage": {
      "anyone": "Chiunque",
      "assignTo": "Assegna a",
      "defaultOperator": "Un Operatore (predefinito)",
      "defaultReceptionist": "Un Receptionist (predefinito)",
      "errorSave": "Impossibile salvare la regola. Riprova.",
      "fallbackOperator": "Nessun Operatore di questa struttura ha orari di lavoro impostati, quindi queste attività vengono assegnate a un Titolare o a un Manager in servizio in quel momento, e restano non assegnate se non ce n’è nessuno. Per assegnarle invece a un Operatore, imposta gli orari di lavoro di uno di loro in Membri.",
      "fallbackReceptionist": "Nessun Receptionist di questa struttura ha orari di lavoro impostati, quindi queste attività vengono assegnate a un Titolare o a un Manager in servizio in quel momento, e restano non assegnate se non ce n’è nessuno. Per assegnarle invece a un Receptionist, imposta gli orari di lavoro di uno di loro in Membri.",
      "formerMember": "Una persona che non fa più parte della struttura",
      "functionHint": "Imposta le mansioni di ogni persona in Membri.",
      "functionLabel": "Mansione richiesta",
      "hintAny": "Tutte le altre attività di pulizia, comprese quelle create a mano.",
      "hintDefaultOperator": "Viene assegnata a un Operatore in servizio in quel momento, scegliendo chi ha meno attività quel giorno. Se in quel momento non c’è nessun Operatore in servizio, va a un Titolare o a un Manager in servizio. Se non c’è nessuno, resta non assegnata.",
      "hintDefaultReceptionist": "Viene assegnata a un Receptionist in servizio in quel momento, scegliendo chi ha meno attività quel giorno. Se in quel momento non c’è nessun Receptionist in servizio, va a un Titolare o a un Manager in servizio. Se non c’è nessuno, resta non assegnata.",
      "hintFollowsAny": "Segue la regola di tutte le altre attività di pulizia, qui sotto.",
      "loading": "Caricamento delle assegnazioni delle pulizie…",
      "noOperator": "Nessun Operatore, Titolare o Manager qui ha orari di lavoro impostati, quindi queste attività restano non assegnate. Imposta gli orari di lavoro in Membri.",
      "noReceptionist": "Nessun Receptionist, Titolare o Manager qui ha orari di lavoro impostati, quindi queste attività restano non assegnate. Imposta gli orari di lavoro in Membri.",
      "noRuleFollowsAny": "Come tutte le altre attività di pulizia",
      "noRuleKindDefaults": "L’impostazione predefinita di ogni tipo",
      "nobodyYet": "Ancora nessuno",
      "person": "Persona",
      "personHasLeft": "Questa persona non fa più parte della struttura, quindi la regola non assegna nessuno. Scegli qualcun altro.",
      "personHint": "Riceve l’attività anche quando è assente: vedrai l’avviso sull’attività stessa.",
      "summaryOperator": "Un Operatore",
      "summaryOwnerOrManager": "Un Titolare o un Manager",
      "summaryReceptionist": "Un Receptionist",
      "summaryUnassigned": "Non assegnata",
      "unavailableDescription": "Vidimo non riesce a caricare le regole su questo dispositivo. Tocca Riprova per ricaricare l’app.",
      "unavailableTitle": "Al momento non è possibile modificare le regole delle attività"
    },
    "taxReturns": {
      "badgeMore": "Da integrare",
      "badgeOpen": "Da pagare",
      "badgePaid": "Pagato",
      "badgeRunning": "Questo mese",
      "description": "Mese per mese, la tassa di soggiorno e di promozione relativa ai soggiorni la cui ultima notte cade in quel mese. Versala al Comune entro la scadenza, poi segna qui il mese come pagato. La tassa che un ospite ti ha pagato prima di quel mese va versata nel mese successivo a quello in cui l’hai riscossa.",
      "errorMarkPaid": "Impossibile segnarlo come pagato. Riprova.",
      "markPaid": "Segna come pagato",
      "markedPaid": "Segnato come pagato.",
      "overpaid": "Hai versato {amount} in più di quanto ora risulta dovuto per questi soggiorni.",
      "stays": "{count, plural, one {# soggiorno} other {# soggiorni}}",
      "summaryMore": "Ancora {amount} da pagare entro il {date}",
      "summaryOpen": "{amount} da pagare entro il {date}",
      "summaryPaid": "{amount} pagati",
      "summaryRunning": "{amount} finora, scadenza il {date}",
      "title": "Versamenti al Comune",
      "uncomputed": "{count, plural, one {# soggiorno non ancora calcolato è escluso} other {# soggiorni non ancora calcolati sono esclusi}} dall’importo."
    },
    "taxRules": {
      "ageFrom": "da {age} anni in su",
      "ageRange": "da {from} a {to} anni",
      "ageUnder": "meno di {age} anni",
      "chargesNothing": "Questo Comune non applica l’imposta di soggiorno",
      "checked": "Ultima verifica: {date}",
      "from": "Dal giorno {date}: {rule}",
      "maxNights": "{count, plural, one {al massimo # notte per soggiorno} other {al massimo # notti per soggiorno}}",
      "paysFree": "{ages}: esenti",
      "paysHalf": "{ages}: metà tariffa",
      "paysPercent": "{ages}: {percent} della tariffa",
      "perPersonNight": "{amounts} a persona a notte",
      "rateCategory": "{category}: {rate}",
      "ratePercent": "{percent} del prezzo, al massimo {cap}",
      "awaitsFacility": "Qui la tassa di soggiorno dipende dalla struttura: da dove si trova nel Comune, dalla sua tipologia o da chi la gestisce. Vidimo legge questi dati nel registro in base al «{field}» indicato nella pagina {system} e mostra la tassa non appena trova la struttura nel registro.",
      "errorLoad": "Impossibile caricare l’imposta di soggiorno. Riprova.",
      "notCovered": "Vidimo non conosce ancora l’imposta di soggiorno del luogo in cui si trova questa struttura, quindi per ora le sue prenotazioni non mostrano alcuna imposta.",
      "source": "Fonte",
      "withSurcharge": "{rate} + {surcharge} {label}",
      "zone": "Tariffa per {zone}"
    },
    "timezoneField": {
      "hint": "Usato per gli orari di check-in/check-out e la pianificazione",
      "label": "Fuso orario"
    },
    "unitForm": {
      "amenitiesLabel": "Servizi",
      "amenitiesPlaceholder": "Seleziona i servizi",
      "babyCots": "Culle",
      "cancel": "Annulla",
      "codeHintAuto": "{count, plural, one {Compilato in automatico dal nome dell’unità. Scrivi per modificarlo; svuota il campo per riattivare la compilazione automatica. Max # carattere.} other {Compilato in automatico dal nome dell’unità. Scrivi per modificarlo; svuota il campo per riattivare la compilazione automatica. Max # caratteri.}}",
      "codeHintManual": "{count, plural, one {Etichetta compatta per calendario ed elenchi attività. Es. 101, APH-SV. Svuota il campo per seguire automaticamente il nome dell’unità. Max # carattere.} other {Etichetta compatta per calendario ed elenchi attività. Es. 101, APH-SV. Svuota il campo per seguire automaticamente il nome dell’unità. Max # caratteri.}}",
      "codeLabel": "Codice breve",
      "codePlaceholder": "es. 101 o APH",
      "cotsAndExtraBeds": "Culle e letti aggiuntivi",
      "createSubtitle": "Aggiungi una nuova unità prenotabile a questa struttura",
      "createTitle": "Crea unità",
      "deleteDescription": "Rimuovi definitivamente questa unità. Le prenotazioni collegate potrebbero dover essere aggiornate. L’operazione è irreversibile.",
      "deleteLabel": "Elimina unità",
      "descriptionHint": "Compare sulla pagina pubblica della camera e la aiuta a comparire nelle ricerche.",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "Descrivi questa camera: la vista, la luce, cosa la rende speciale. Compare sulla pagina pubblica della camera.",
      "duplicate": "Duplica unità",
      "editSubtitle": "Gestisci i dettagli dell’unità",
      "editTitle": "Modifica unità",
      "errorDelete": "Impossibile eliminare l’unità. Riprova.",
      "errorDuplicate": "Impossibile duplicare l’unità. Riprova.",
      "errorSave": "Impossibile salvare l’unità. Riprova.",
      "extraBeds": "Letti aggiuntivi",
      "maxAdults": "Adulti max",
      "maxChildren": "Bambini max",
      "maxChildrenPayable": "Bambini paganti",
      "maxGuests": "Ospiti max",
      "nameLabel": "Nome",
      "namePlaceholder": "es. Camera 101 o Appartamento A",
      "occupancy": "Occupazione",
      "save": "Salva",
      "sizeLabel": "Superficie",
      "sizePlaceholder": "es. 25",
      "sizeUnitLabel": "Unità di misura",
      "smokingAllowed": "Fumatori ammessi",
      "smokingLabel": "Politica sul fumo",
      "smokingNonSmoking": "Non fumatori",
      "smokingPlaceholder": "Seleziona la politica",
      "smokingUnknown": "Non specificato",
      "unitTypeLabel": "Tipologia di unità",
      "unitTypePlaceholder": "Seleziona la tipologia"
    },
    "unitsEdit": {
      "notFound": "Unità non trovata"
    },
    "unlinkMethodDialog": {
      "cancel": "Annulla",
      "confirm": "Rimuovi",
      "confirmPending": "Rimozione…",
      "description": "Non potrai più accedere con {method}. Gli altri metodi di accesso continuano a funzionare, e puoi ricollegarlo da questa schermata.",
      "title": "Rimuovere {method}?"
    },
    "wifiSection": {
      "hidePassword": "Nascondi la password del Wi-Fi",
      "hint": "Visibile agli ospiti dal giorno dell’arrivo, una volta impostati sia il nome della rete sia la password. La password non viene mai inclusa nelle bozze dell’IA.",
      "label": "Wi-Fi",
      "passwordLabel": "Password del Wi-Fi",
      "passwordPlaceholder": "Password",
      "revealPassword": "Mostra la password del Wi-Fi",
      "ssidLabel": "Nome della rete Wi-Fi",
      "ssidPlaceholder": "Nome della rete"
    }
  },

  "setup": {
    "setupBookingsStep": {
      "continue": "Continua",
      "description": "La tua app di IA può copiarle in Vidimo, così non devi tenere due calendari.",
      "fresh": "No, parto da zero",
      "import": "Sì, importale",
      "imported": "Prenotazioni importate da {source}.",
      "openImports": "Apri Prenotazioni importate",
      "results": "Puoi farlo anche più tardi da un computer. Il prompt e i risultati restano disponibili in Impostazioni, alla voce Prenotazioni importate.",
      "skip": "Salta per ora",
      "title": "Gestisci già le prenotazioni con un altro sistema?"
    },
    "setupEmptyState": {
      "calendarDescription": "Completa la configurazione della struttura e delle unità per vedere le prenotazioni sul calendario.",
      "calendarTitle": "Qui comparirà il calendario delle prenotazioni",
      "chatsDescription": "Completa la configurazione della struttura e qui inizieranno ad arrivare messaggi degli ospiti, prenotazioni e risposte dell’IA.",
      "chatsTitle": "Qui troverai le conversazioni con gli ospiti",
      "setUp": "Configura la struttura",
      "skip": "Salta per ora",
      "tasksDescription": "Completa la configurazione della struttura per assegnare al team pulizie, check-in e manutenzione.",
      "tasksTitle": "Qui compariranno le attività del team",
      "todayDescription": "Completa la configurazione della struttura e qui troverai ogni giorno arrivi, partenze e ospiti in casa.",
      "todayTitle": "La tua giornata inizia qui"
    },
    "setupEssentialsStep": {
      "addressHint": "Cerca e seleziona l’indirizzo per fissare la posizione e impostare il Paese.",
      "addressLabel": "Indirizzo",
      "addressPlaceholder": "Cerca l’indirizzo della struttura…",
      "continue": "Salva e continua",
      "description": "Le informazioni di base su cui contano ospiti e team. Potrai affinare tutto in seguito nelle impostazioni.",
      "errorNotSaved": "Impossibile salvare i dati della struttura. Riprova.",
      "nameLabel": "Nome della struttura *",
      "namePlaceholder": "Inserisci il nome della struttura",
      "timezoneConfirm": "Conferma",
      "timezoneDetected": "Rilevato da questo dispositivo: non viene salvato finché non lo confermi o scegli un indirizzo.",
      "timezoneHint": "Usato per gli orari di check-in/check-out e la pianificazione.",
      "timezoneLabel": "Fuso orario",
      "timezonePlaceholder": "Seleziona il fuso orario",
      "title": "Dati essenziali della struttura"
    },
    "setupStepLayout": {
      "back": "Indietro",
      "saving": "Salvataggio…",
      "skip": "Salta"
    },
    "setupSummaryStep": {
      "addressLabel": "Indirizzo",
      "bookingsImported": "Importate da {source}",
      "bookingsLabel": "Prenotazioni",
      "bookingsNone": "Niente da importare",
      "bookingsNotYet": "Non ancora importate",
      "descriptionComplete": "È tutto pronto. La tua struttura è operativa.",
      "descriptionIncomplete": "Puoi terminare ora e completare i dati essenziali mancanti in qualsiasi momento dalle impostazioni.",
      "finish": "Termina configurazione",
      "finishAnyway": "Termina comunque",
      "invitesNone": "Ancora nessun invito (facoltativo)",
      "invitesPending": "{count, plural, one {{count} invito in sospeso} other {{count} inviti in sospeso}}",
      "nameLabel": "Nome della struttura",
      "notSet": "Non ancora impostato",
      "teamLabel": "Team",
      "timezoneLabel": "Fuso orario",
      "title": "Riepilogo",
      "unitsAdded": "{count, plural, one {{count} unità aggiunta} other {{count} unità aggiunte}}",
      "unitsLabel": "Unità",
      "unitsNone": "Aggiungi almeno un’unità"
    },
    "setupTeamStep": {
      "continue": "Continua",
      "description": "Invita un collega ad aiutarti a gestire la struttura. Puoi farlo anche più tardi: è facoltativo.",
      "emailHint": "Gli invieremo via email un link per unirsi, più un codice di invito da inserire nell’app.",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@esempio.it",
      "errorNotSent": "Impossibile inviare l’invito.",
      "invitationPending": "{role} · invito in sospeso",
      "invitationSent": "Invito inviato",
      "noPermission": "Non hai il permesso di invitare membri in questa struttura.",
      "roleLabel": "Ruolo",
      "rolePlaceholder": "Seleziona un ruolo",
      "send": "Invia invito",
      "sending": "Invio in corso…",
      "skip": "Salta per ora",
      "title": "Invita il tuo team"
    },
    "setupUnitsStep": {
      "add": "Aggiungi unità",
      "adding": "Aggiunta in corso…",
      "continue": "Continua",
      "description": "Aggiungi le camere o gli appartamenti prenotabili dagli ospiti. Ne serve almeno uno; puoi aggiungerne altri quando vuoi nelle impostazioni.",
      "errorNotAdded": "Impossibile aggiungere l’unità. Riprova.",
      "errorNotRemoved": "Impossibile rimuovere l’unità. Riprova.",
      "maxGuestsLabel": "Ospiti max",
      "nameLabel": "Nome dell’unità",
      "namePlaceholder": "es. Camera 101 o Appartamento A",
      "remove": "Rimuovi {name}",
      "skip": "Salta per ora",
      "title": "Unità",
      "typeLabel": "Tipologia",
      "typePlaceholder": "Seleziona tipologia",
      "typeSleeps": "{count, plural, one {{type} · {count} posto letto} other {{type} · {count} posti letto}}",
      "unitFallback": "Unità"
    },
    "setupWizard": {
      "skipSetup": "Salta configurazione",
      "stepBookings": "Prenotazioni",
      "stepEssentials": "Essenziali",
      "stepReview": "Riepilogo",
      "stepTeam": "Team",
      "stepUnits": "Unità",
      "subtitle": "Prepara la tua struttura per l’operatività",
      "titleNamed": "Configura {name}",
      "titleUnnamed": "Configura la tua struttura"
    }
  },

  "shell": {
    "appHeader": {
      "search": "Cerca"
    },
    "appNavRail": {
      "label": "Principale"
    },
    "auditFormatting": {
      "fieldLabel": {
        "assignedTo": "assegnatario",
        "description": "descrizione",
        "endAt": "check-out",
        "expectedArrivalTime": "orario di arrivo previsto",
        "linkedGuest": "Collegamento ospite",
        "mergedDuplicate": "Unione",
        "startAt": "check-in",
        "status": "stato",
        "taxNote": "nota fiscale",
        "title": "titolo",
        "type": "tipo",
        "unitId": "unità"
      },
      "fromTo": "da {from} a {to}",
      "none": "nessuno",
      "withheldChange": "{kind, select, added {aggiunto} removed {rimosso} other {modificato}}",
      "withheldField": "{kind, select, added {aggiunto} removed {rimosso} other {modificato}}: {field}"
    },
    "auditTimeline": {
      "bySupport": "Assistenza Vidimo per conto di {actor}",
      "changeTo": "a",
      "headline": {
        "guestCreate": "Ospite aggiunto: {summary}",
        "guestDelete": "Ospite rimosso: {summary}",
        "guestUpdate": "Ospite modificato: {summary}",
        "rateCreate": "Tariffe aggiunte: {summary}",
        "rateDelete": "Tariffe rimosse: {summary}",
        "rateUpdate": "Tariffe modificate: {summary}",
        "reservationCreate": "Prenotazione aggiunta: {summary}",
        "reservationDelete": "Prenotazione rimossa: {summary}",
        "reservationUpdate": "Prenotazione modificata: {summary}",
        "taskCreate": "Attività aggiunta: {summary}",
        "taskDelete": "Attività rimossa: {summary}",
        "taskMissTakenBack": "Riaperta: l’ospite in realtà non è arrivato",
        "taskMissed": "Non svolta: l’ospite è arrivato prima che fosse fatta",
        "taskUpdate": "Attività modificata: {summary}"
      },
      "byVidimo": "Vidimo",
      "onBehalf": "{agent} (assistenza Vidimo) per conto di {actor}",
      "open": {
        "guest": "Apri ospite",
        "reservation": "Apri prenotazione",
        "task": "Apri attività"
      },
      "title": "Cronologia",
      "unknownActor": "Sconosciuto"
    },
    "avatarUpload": {
      "chooseImage": "Scegli immagine",
      "errorUpload": "Impossibile caricare l’immagine. Riprova."
    },
    "connectionStatusBanner": {
      "backendUnreachable": "Vidimo non è raggiungibile. Le modifiche si sincronizzeranno appena torna disponibile.",
      "changesNotSent": "Alcune modifiche non sono ancora state inviate. Tieni l’app aperta mentre riproviamo.",
      "deviceOffline": "Sei offline. Le modifiche si sincronizzeranno quando tornerai online."
    },
    "copyRecordLink": {
      "copied": "Link copiato",
      "errorNotCopied": "Impossibile copiare il link"
    },
    "deviceReplica": {
      "clearDatabase": {
        "cancel": "Mantieni",
        "confirm": "Cancella comunque",
        "unsynced": "{count, plural, one {{count} modifica su questo dispositivo non è ancora sincronizzata. Se cancelli ora, verrà eliminata da questo dispositivo e non arriverà a Vidimo.} other {{count} modifiche su questo dispositivo non sono ancora sincronizzate. Se cancelli ora, verranno eliminate da questo dispositivo e non arriveranno a Vidimo.}}",
        "unsyncedUnknown": "Alcune modifiche su questo dispositivo potrebbero non essere ancora sincronizzate. Se cancelli ora, verranno eliminate da questo dispositivo e non arriveranno a Vidimo."
      },
      "signOut": {
        "cancel": "Resta connesso",
        "confirm": "Esci comunque",
        "unsynced": "{count, plural, one {{count} modifica su questo dispositivo non è ancora sincronizzata. Se esci ora, verrà eliminata da questo dispositivo e non arriverà a Vidimo.} other {{count} modifiche su questo dispositivo non sono ancora sincronizzate. Se esci ora, verranno eliminate da questo dispositivo e non arriveranno a Vidimo.}}",
        "unsyncedUnknown": "Alcune modifiche su questo dispositivo potrebbero non essere ancora sincronizzate. Se esci ora, verranno eliminate da questo dispositivo e non arriveranno a Vidimo."
      },
      "signOutFailed": "Impossibile uscire. Controlla la connessione e riprova.",
      "signOutOffline": "Sei offline. Connettiti per uscire; fino ad allora tutto resta su questo dispositivo.",
      "unsyncedTitle": "Modifiche non sincronizzate"
    },
    "errorBoundary": {
      "description": "Ricarica l’app per continuare.",
      "reload": "Ricarica l’app",
      "title": "Qualcosa è andato storto"
    },
    "loading": "Caricamento…",
    "mrzScanner": {
      "alreadyOnBooking": "{name} è già nella prenotazione. {outcome}",
      "confirm": "Conferma",
      "errorNoReservation": "Impossibile capire di quale prenotazione si tratta. Riapri la prenotazione e riprova.",
      "errorNotAccepted": "I dati non sono stati accettati. Confrontali con il documento e riprova.",
      "errorNotOnBooking": "Questa persona non è più nella prenotazione. Riapri la prenotazione per vedere chi c’è.",
      "errorPartyFull": "Questa prenotazione ha già tutti gli ospiti previsti. Per aggiungere qualcuno, aumenta prima il numero di Adulti, Bambini o Neonati. Per scansionare qualcuno già presente, tocca l’icona del documento nella sua riga.",
      "errorReservationNotActive": "Questa prenotazione non accetta più check-in.",
      "errorUnreachable": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
      "guestPickerLabel": "Di chi è questo documento?",
      "noGuests": "Questa prenotazione non ha ancora ospiti: la prima scansione li aggiungerà.",
      "outcomeActionNeeded": "Salvato, ma la registrazione richiede ancora un intervento: i dettagli sono nella sezione Registrazione dell’ospite.",
      "outcomeFiled": "Salvato e inviato. L’autorità ha confermato.",
      "outcomeNone": "Documento salvato nell’ospite.",
      "outcomeSubmitted": "Salvato e inviato. In attesa di conferma.",
      "scanner": {
        "back": "Indietro",
        "cameraFailed": "Impossibile avviare la fotocamera. Controlla i permessi e riprova.",
        "cancelScan": "Annulla scansione",
        "checkingRequirements": "Verifica dei dati richiesti per registrare questo soggiorno…",
        "chooseOneOf": "Scegli {choices}.",
        "chooseWho": "Scegli chi sta facendo il check-in.",
        "close": "Chiudi",
        "countryClear": "Cancella",
        "documentNumber": "N. documento",
        "documentNumberPlaceholder": "Numero del documento",
        "doubleCheck": "Ricontrolla: {fields}",
        "expiryDate": "Data di scadenza",
        "failedBody": "Capita spesso. Scegli l’opzione più comoda:",
        "failedTitle": "Impossibile leggere il documento",
        "guestFallback": "Ospite {id}",
        "manualBody": "Copiali dal documento: devono corrispondere esattamente.",
        "manualSubmit": "Salva dati",
        "manualTitle": "Inserisci i dati del documento",
        "missingLicense": "La scansione dei documenti non è disponibile al momento. Contatta la struttura.",
        "noCamera": "Niente fotocamera? Inserisci i dati a mano",
        "openingCamera": "Apertura della fotocamera…",
        "optional": "Facoltativo",
        "personalNumber": "Numero di identificazione nazionale",
        "personalNumberPlaceholder": "Come sul documento",
        "pickGuest": "Scegli a chi si riferiscono questi dati.",
        "regimeFieldsIntro": "Necessari per registrare qui il soggiorno e non riportati sul documento.",
        "required": "Obbligatorio",
        "retake": "Ripeti scansione",
        "reviewBody": "Letti dal documento, sul tuo telefono. Correggi ciò che non torna: deve corrispondere esattamente.",
        "reviewTitle": "Verifica che corrisponda al documento",
        "scanBody": "Tieni la pagina con la foto dentro la cornice. La lettura è automatica, non devi premere nulla.",
        "scanButton": "Scansiona passaporto o documento",
        "scanEyebrow": "Scansiona un documento",
        "scanTarget": "Per",
        "scanTitle": "Scansiona il passaporto o la carta d’identità dell’ospite",
        "scanned": "✓ Scansionato",
        "select": "Seleziona",
        "selectSex": "Seleziona sesso",
        "submitFailed": "Impossibile inviare il check-in.",
        "submitting": "Invio in corso…",
        "tryAgainSub": "Più luce, meno riflessi, tienilo in piano",
        "tryAgainTitle": "Riprova",
        "typeInsteadSub": "Inserisci ciò che è stampato sul documento",
        "typeInsteadTitle": "Inserisci i dati a mano",
        "view": {
          "bothSidesScanned": "Entrambi i lati scansionati ✓",
          "cameraAccessDenied": "Accesso alla fotocamera negato",
          "closeScanner": "Chiudi scanner",
          "flipDocument": "Ora scansiona il lato con la foto",
          "flipDocumentCountdown": "Gira il documento e scansiona l’altro lato ({seconds} s)",
          "holdSteady": "Tieni fermo…",
          "loadImageFailed": "Impossibile caricare l’immagine",
          "portraitScanned": "Foto scansionata ✓",
          "positionMRZ": "Inquadra la zona MRZ nella cornice",
          "positionPortrait": "Inquadra la foto nella cornice",
          "rotateDevice": "Ruota il dispositivo in verticale",
          "scanMRZFirst": "Scansiona prima il lato con la zona MRZ",
          "scanSuccess": "MRZ scansionata ✓",
          "scanningPortrait": "Scansione della foto…",
          "skipPortraitLabel": "Salta la scansione della foto",
          "switchCamera": "Cambia fotocamera",
          "toggleFlash": "Attiva/disattiva flash"
        }
      }
    },
    "notFound": {
      "description": "Questo link non porta a nessuna pagina di Vidimo. Forse non è più valido o contiene un errore.",
      "goToToday": "Vai a Oggi",
      "title": "Pagina non trovata"
    },
    "osHelpers": {
      "cancel": "Annulla",
      "settings": "Impostazioni"
    },
    "pageHeader": {
      "back": "Indietro"
    },
    "parkedDrawerBar": {
      "close": "Chiudi dettagli",
      "reopen": "Riapri {name}"
    },
    "paywallGate": {
      "errorOwnerOnly": "Solo il titolare della struttura può configurare la fatturazione.",
      "lapsedNativeDescription": "Questa struttura è in pausa. Non è stato eliminato nulla e l’accesso torna appena l’abbonamento è di nuovo attivo.",
      "lapsedNotice": "L’abbonamento di questa struttura è scaduto. Chiedi al titolare di rinnovarlo.",
      "lapsedTitle": "Il tuo abbonamento è terminato",
      "noSubscriptionDescription": "Serve un abbonamento attivo. Fino ad allora i tuoi dati restano al sicuro.",
      "noSubscriptionTitle": "Questa struttura non è ancora attiva",
      "pastDueNative": "Pagamento non riuscito. L’accesso potrebbe terminare a breve.",
      "propertySettings": "Impostazioni della struttura",
      "signOut": "Esci",
      "trialActive": "Prova gratuita attiva.",
      "trialDaysLeft": "Prova gratuita: {days, plural, one {manca # giorno} other {mancano # giorni}}."
    },
    "persisted": {
      "lateRollback": "Una modifica salvata poco fa non è stata mantenuta. Controllala e riprova."
    },
    "placePicker": {
      "errorDetails": "Impossibile caricare quell’indirizzo. Prova un altro risultato.",
      "errorLookup": "Ricerca dell’indirizzo non riuscita. Controlla la connessione.",
      "poweredByGoogle": "Con tecnologia Google",
      "searching": "Ricerca…",
      "unavailable": "Ricerca indirizzi non disponibile"
    },
    "powersyncUploadFeedback": {
      "breakfastAlreadySetUp": "La colazione è già stata configurata su un altro dispositivo, quindi la modifica non è stata salvata.",
      "discarded": "Alcune modifiche non sono state salvate e sono state annullate.",
      "discardedEntity": "Alcune modifiche a {label} non sono state salvate e sono state annullate.",
      "labels": {
        "availability": "disponibilità",
        "breakfast": "impostazioni della colazione",
        "charge": "addebito",
        "conversation": "conversazione",
        "guest": "ospite",
        "message": "messaggio",
        "payment": "pagamento",
        "pricing": "prezzi",
        "property": "struttura",
        "reaction": "reazione",
        "reservation": "prenotazione",
        "suggestion": "suggerimento",
        "task": "attività",
        "timeOff": "assenza",
        "unit": "unità"
      }
    },
    "prerenderRoutes": {
      "signupMetaDescription": "Crea un account Vidimo per gestire strutture, prenotazioni, messaggi agli ospiti e check-in da un unico posto.",
      "signupTitle": "Crea un account · Vidimo"
    },
    "primaryTabs": {
      "calendar": "Calendario",
      "chats": "Chat",
      "guests": "Ospiti",
      "tasks": "Attività",
      "today": "Oggi"
    },
    "propertyFacet": {
      "addProperty": "Aggiungi struttura",
      "allProperties": "Tutte le strutture",
      "colorLabel": "Colore della struttura {name}",
      "empty": "Nessuna struttura disponibile.",
      "only": "Solo",
      "onlyLabel": "Mostra solo {name}",
      "settingsLabel": "Impostazioni di {name}",
      "title": "Le tue strutture"
    },
    "rowPending": {
      "syncing": "{kind, select, guest {Sincronizzazione ospite…} member {Sincronizzazione membro…} parking {Sincronizzazione parcheggio…} reservation {Sincronizzazione prenotazione…} staffMember {Sincronizzazione membro del team…} task {Sincronizzazione attività…} unit {Sincronizzazione unità…} other {Sincronizzazione…}}"
    },
    "scopeChip": {
      "allProperties": "Tutte le strutture",
      "clearFilters": "Azzera<suffix> {count, plural, one {# filtro} other {# filtri}}</suffix>",
      "clearFiltersLabel": "Azzera {count, plural, one {# filtro} other {# filtri}}",
      "noProperties": "Nessuna struttura",
      "propertyCount": "{count, plural, one {# struttura} other {# strutture}}",
      "scopeLabel": "Ambito: {label}",
      "scopeLabelFiltered": "Ambito: {label} ({count, plural, one {# filtro attivo} other {# filtri attivi}})"
    },
    "scopeDrawer": {
      "title": "Ambito"
    },
    "searchOverlay": {
      "close": "Chiudi ricerca",
      "emptyDescription": "Cerca ospiti, personale, prenotazioni e attività",
      "guestFallback": "Ospite",
      "noResultsDescription": "Prova con un altro termine",
      "noResultsTitle": "Nessun risultato",
      "placeholder": "Cerca ospiti, personale, prenotazioni, attività…",
      "reservationFallback": "Prenotazione",
      "taskSubtitle": "Attività",
      "taskSubtitleAssigned": "Attività • {assignee}",
      "title": "Cerca"
    },
    "staffFacet": {
      "allStaff": "Tutto il personale",
      "empty": "Nessun membro del personale disponibile.",
      "meSuffix": "(io)",
      "only": "Solo",
      "onlyLabel": "Mostra solo {name}",
      "title": "Personale"
    },
    "stillLooking": {
      "description": "Potrebbe essere ancora in sincronizzazione. Se non compare, potrebbe essere stato rimosso o appartenere a una struttura a cui non hai accesso.",
      "title": "{kind, select, guest {Stiamo ancora cercando questo ospite} member {Stiamo ancora cercando questo membro} parking {Stiamo ancora cercando questo parcheggio} reservation {Stiamo ancora cercando questa prenotazione} staffMember {Stiamo ancora cercando questo membro del team} task {Stiamo ancora cercando questa attività} unit {Stiamo ancora cercando questa unità} other {Stiamo ancora cercando}}"
    },
    "supportSession": {
      "ended": {
        "description": "I dati del cliente sono stati rimossi da questa scheda. Puoi chiuderla.",
        "title": "Sessione di assistenza terminata"
      },
      "failed": {
        "description": "Controlla la connessione, poi aprine una nuova dal CRM.",
        "title": "Impossibile aprire la sessione"
      },
      "invalid": {
        "description": "Ogni link apre una sola sessione e vale per un minuto. Aprine una nuova dal CRM.",
        "title": "Questo link è scaduto o è già stato usato"
      },
      "opening": "Apertura dell’app del cliente…"
    },
    "supportSessionBanner": {
      "exit": "Esci",
      "viewingAs": "Assistenza Vidimo: stai vedendo l’app come {name}"
    },
    "syncingState": {
      "defaultLabel": "Sincronizzazione delle conversazioni…",
      "retry": "Riprova",
      "retrying": "Nuovo tentativo…",
      "slow": "La sincronizzazione richiede più tempo del solito…",
      "unreachableDescription": "I tuoi dati verranno caricati appena la connessione sarà ripristinata. Controlla la connessione a internet o riprova tra poco.",
      "unreachableTitle": "Server di sincronizzazione non raggiungibile"
    },
    "useAcceptInvitation": {
      "errorInvitationNotFound": "Questo codice di invito non è più valido: potrebbe essere scaduto o revocato. Chiedine uno nuovo.",
      "errorNotJoined": "Impossibile unirsi alla struttura. Controlla il codice di invito e riprova.",
      "errorSupportSession": "Durante una sessione di assistenza non è possibile unirsi a una struttura.",
      "errorWrongRecipient": "Questo invito è stato inviato a un altro indirizzo email. Accedi con quell’indirizzo per accettarlo.",
      "joined": "Ora fai parte della struttura"
    },
    "useDirtyGuard": {
      "discardPrompt": "Hai modifiche non salvate. Vuoi scartarle?"
    },
    "userDrawer": {
      "account": "Account",
      "accountDescription": "Profilo, aspetto e calendario attività",
      "accountSection": "Account",
      "contactSupport": "Contatta l’assistenza",
      "contactSupportDescription": "Scrivi al team Vidimo",
      "help": "Aiuto",
      "helpDescription": "Guide all’uso di Vidimo",
      "joinProperty": "Unisciti a una struttura",
      "joinPropertyDescription": "Usa un codice di invito di un collega",
      "legalSection": "Note legali",
      "notifications": "Impostazioni notifiche",
      "notificationsDescription": "Messaggi, gruppi e suoni delle chiamate",
      "privacy": "Informativa sulla privacy",
      "privacyDescription": "Come Vidimo tratta i tuoi dati",
      "signOut": "Esci",
      "signedIn": "Accesso effettuato",
      "supportSection": "Assistenza",
      "terms": "Termini di servizio",
      "termsDescription": "Il contratto che regola l’uso di Vidimo",
      "trigger": "Menu utente",
      "triggerWithNews": "Menu utente, con una novità in Novità",
      "whatsNew": "Novità",
      "whatsNewDescription": "Cosa è cambiato in Vidimo, versione per versione",
      "whatsNewUnseen": "Nuova voce"
    }
  },

  "stayPreview": {
    "stayPreviewFrame": {
      "frameTitle": "Anteprima della pagina del soggiorno",
      "loadFailed": "L’anteprima non si è caricata.",
      "tryAgain": "Riprova"
    },
    "stayPreviewHost": {
      "preview": "Anteprima",
      "title": "Vedi come ospite"
    },
    "stayPreviewPanel": {
      "copyLink": "Copia link",
      "errorCopyFailed": "Impossibile copiare il link",
      "linkCopied": "Link dell’anteprima copiato",
      "phaseAfter": "Dopo il check-out",
      "phaseArrivalDay": "Giorno dell’arrivo",
      "phaseBefore": "Prima dell’arrivo",
      "phaseGroupLabel": "Fase del soggiorno",
      "phaseInStay": "Durante il soggiorno",
      "qrCodeLabel": "Codice QR per aprire questa anteprima sul telefono",
      "sampleNotice": "Un soggiorno di esempio: date, ospiti e codice della porta sono fittizi.",
      "scanHint": "Inquadra per aprire questa anteprima sul telefono. Mostra ciò che hai salvato."
    }
  },

  "tasks": {
    "completed": {
      "completeFailed": "Impossibile completare l’attività. Riprova.",
      "title": "Attività completata",
      "undo": "Annulla",
      "undoFailed": "Impossibile annullare. L’attività risulta ancora completata."
    },
    "completionNote": {
      "dictate": "Detta una nota",
      "hint": "Annota ciò che richiede un seguito.",
      "optional": "Facoltativa",
      "placeholder": "Scrivi una nota…",
      "save": "Salva nota",
      "saveFailed": "Impossibile salvare la nota. Riprova.",
      "saved": "Salvata",
      "stopRecording": "Interrompi registrazione",
      "title": "Aggiungi una nota all’attività",
      "transcribeFailed": "Impossibile trascrivere la registrazione. Riprova.",
      "transcribing": "Trascrizione…"
    },
    "editTaskForm": {
      "assignedTo": "Assegnata a",
      "back": "Indietro",
      "backToTasks": "Torna alle attività",
      "cancel": "Annulla",
      "create": "Crea",
      "created": "Attività creata.",
      "dateLabel": "Data <hint>(facoltativa: lasciala vuota per un’attività senza data)</hint>",
      "delete": "Elimina",
      "deleteDescription": "Sparisce per tutti. Di solito è meglio completare un’attività per chiudere il lavoro: eliminala solo se non avrebbe mai dovuto esistere.",
      "deleteTask": "Elimina attività",
      "deleteTitle": "Eliminare questa attività?",
      "deleted": "Attività eliminata",
      "deleting": "Eliminazione…",
      "descriptionLabel": "Descrizione",
      "descriptionPlaceholder": "Descrizione dell’attività (facoltativa)",
      "endTimeLabel": "Ora di fine",
      "errorNotDeleted": "Impossibile eliminare questa attività. Riprova.",
      "errorNotSaved": "Impossibile salvare l’attività. Riprova.",
      "notFound": "Attività non trovata",
      "priorityHigh": "Alta",
      "priorityLabel": "Priorità",
      "priorityLow": "Bassa",
      "priorityMedium": "Media",
      "propertyLabel": "Struttura",
      "propertyPlaceholder": "Seleziona una struttura",
      "save": "Salva",
      "startTimeLabel": "Ora di inizio",
      "statusLabel": "Stato",
      "titleEdit": "Modifica attività",
      "titleLabel": "Titolo",
      "titleNew": "Nuova attività",
      "titlePlaceholder": "Titolo dell’attività",
      "typeCleaning": "Pulizie",
      "typeLabel": "Tipo",
      "typeMaintenance": "Manutenzione",
      "unitLabel": "Unità",
      "unitNeedsProperty": "Seleziona prima una struttura",
      "updated": "Attività aggiornata."
    },
    "staffAssigneeSelect": {
      "assigned": "Assegnata",
      "cancel": "Annulla",
      "confirm": "Assegna comunque",
      "confirmDescription": "Risulta non disponibile in questa fascia. Se è urgente puoi comunque assegnare l’attività.",
      "confirmDescriptionReason": "Risulta non disponibile in questa fascia: {reason}. Se è urgente puoi comunque assegnare l’attività.",
      "confirmTitle": "Assegnare comunque a {name}?",
      "filteringNote": "{taskFunction, select, check_in {Mostra il personale abilitato ai check-in.} check_out {Mostra il personale abilitato ai check-out.} cleaning {Mostra il personale abilitato alle pulizie.} concierge {Mostra il personale abilitato al concierge.} maintenance {Mostra il personale abilitato alla manutenzione.} other {Mostra il personale abilitato a: {taskFunction}.}}",
      "noFunction": "{taskFunction, select, check_in {Non abilitato ai check-in} check_out {Non abilitato ai check-out} cleaning {Non abilitato alle pulizie} concierge {Non abilitato al concierge} maintenance {Non abilitato alla manutenzione} other {Non abilitato a: {taskFunction}}}",
      "showEveryone": "Mostra tutti",
      "showQualified": "Mostra solo il personale abilitato",
      "unassigned": "Non assegnata"
    },
    "taskCues": {
      "label": {
        "infant": "Prepara la culla: neonato",
        "pet": "Viaggia con un animale",
        "petWithNotes": "Animale: {notes}"
      },
      "short": {
        "accessibility": "Accessibilità",
        "dietary": "Alimentazione",
        "infant": "Culla",
        "pet": "Animale"
      }
    },
    "taskDetails": {
      "accessibility": "Accessibilità",
      "afterCheckout": "Dopo il check-out delle {checkOut}",
      "afterCheckoutBeforeCheckIn": "Dopo il check-out delle {checkOut} · Prima del check-in delle {checkIn}",
      "assignedTo": "Assegnata a",
      "assignment": "Assegnazione",
      "beforeCheckIn": "Prima del check-in delle {checkIn}",
      "checkIn": "Check-in",
      "cleaningUpAfter": "Pulizia dopo <guest>{name}</guest>",
      "completionNote": "Nota di completamento",
      "description": "Descrizione",
      "dietary": "Esigenze alimentari",
      "eta": "· arrivo previsto ~{eta}",
      "markDone": "Segna come fatta",
      "notScheduled": "Non pianificata",
      "openLiveView": "Apri vista operativa",
      "pets": "Animali",
      "prepFor": "Preparazione per",
      "specialRequests": "Richieste speciali",
      "startTask": "Inizia attività",
      "travellingWithPet": "Viaggia con un animale",
      "unassigned": "Non assegnata",
      "unitCode": "Unità {code}",
      "unitCodeAndName": "Unità {code} · {name}",
      "unknownUnit": "Unità sconosciuta",
      "via": "tramite",
      "viewFullReservation": "Vedi la prenotazione completa",
      "viewSummary": "Vedi riepilogo",
      "when": "Quando",
      "where": "Dove"
    },
    "taskLiveView": {
      "allStepsDone": "{total, plural, one {{total} passaggio completato} other {Tutti i {total} passaggi completati}}",
      "assignment": "Assegnazione",
      "back": "Indietro",
      "backToTasks": "Torna alle attività",
      "checkInFrom": "Check-in dell’ospite dalle {time}",
      "checkInFromWithEta": "Check-in dell’ospite dalle {time} · arrivo previsto {eta}",
      "checklistTitle": "Pulizia a regola d’arte",
      "compactCheckIn": "Check-in {time}",
      "compactEta": "Arrivo previsto {time}",
      "edit": "Modifica",
      "errorComplete": "Impossibile completare l’attività. Riprova.",
      "errorStart": "Impossibile avviare l’attività. Riprova.",
      "errorStepUpdate": "Impossibile aggiornare quel passaggio. Riprova.",
      "errorUpdate": "Impossibile aggiornare l’attività. Riprova.",
      "finishAnyway": "Termina comunque",
      "finishHintTask": "Termina l’attività quando la camera è pronta, con calma.",
      "finishHintTurnover": "Termina il cambio quando la camera è pronta, con calma.",
      "missedHint": "L’ospite è arrivato prima che venisse svolta. Se invece è stata svolta, imposta lo stato dell’attività su Completata, poi la camera su Pulita.",
      "missedHintAskManager": "L’ospite è arrivato prima che venisse svolta. Se invece è stata svolta, imposta lo stato dell’attività su Completata, poi chiedi a un titolare o a un manager di impostare la camera su Pulita.",
      "finishPostCheckout": "Termina pulizia post check-out",
      "finishPreCheckinRefresh": "Termina ripasso pre-arrivo",
      "finishTurnover": "Termina cambio ospite",
      "finished": "Terminata",
      "guestNames": "· {names}",
      "headerTitle": "Attività",
      "headingKindUnit": "{kind} · {unit}",
      "keepGoing": "Continua",
      "kindCleaning": "Pulizia",
      "kindComplete": "{kind} completata",
      "kindMaintenance": "Manutenzione",
      "markComplete": "Segna come completata",
      "markedComplete": "Segnata come completata",
      "missing": "Questa attività non è disponibile.",
      "notScheduled": "Non pianificata",
      "notesQuote": "«{notes}»",
      "pause": "Pausa",
      "prepFor": "Preparazione per · prossimi ospiti",
      "resume": "Riprendi",
      "someStepsDone": "{total, plural, one {{done}/{total} passaggio completato} other {{done}/{total} passaggi completati}}",
      "startTask": "Inizia attività",
      "started": "Iniziata",
      "startedAt": "Iniziata alle {time}",
      "stepsLeftDescription": "Non ancora spuntati:",
      "stepsLeftTitle": "{left, plural, one {Terminare con {left} passaggio mancante?} other {Terminare con {left} passaggi mancanti?}}",
      "task": "Attività",
      "taskComplete": "Attività completata",
      "todayBefore": "Oggi, entro le {time}",
      "upNext": "Prossima",
      "upNextFor": "Prossima · {name}",
      "when": "Quando",
      "where": "Dove"
    },
    "taskPrep": {
      "adults": "{count, plural, one {# adulto} other {# adulti}}",
      "children": "{count, plural, one {# bambino} other {# bambini}}",
      "guests": "{count, plural, one {# ospite} other {# ospiti}}",
      "infants": "{count, plural, one {# neonato} other {# neonati}}"
    },
    "tasksView": {
      "completeTask": "Completa {title}",
      "createTask": "Crea nuova attività",
      "dateAt": "{date} • {time}",
      "emptyDescription": "Crea un’attività per iniziare",
      "emptyTitle": "Nessuna attività trovata",
      "hideCompleted": "Nascondi attività completate",
      "needsOwner": "da assegnare",
      "openTask": "Apri {title}",
      "sectionCompleted": "Completate",
      "sectionMissed": "Non svolte",
      "sectionOverdue": "In ritardo",
      "sectionToday": "Oggi",
      "sectionUnscheduled": "Senza data",
      "sectionUpcoming": "Prossime",
      "showCompleted": "Mostra attività completate",
      "switchToColumns": "Passa alla vista a colonne",
      "switchToList": "Passa alla vista a elenco",
      "syncing": "Sincronizzazione delle attività…",
      "taskCount": "{count, plural, one {{count} attività} other {{count} attività}}",
      "taskCountNeedsOwner": "{count, plural, one {{count} attività • da assegnare} other {{count} attività • da assegnare}}",
      "title": "Attività",
      "unassigned": "Non assegnate",
      "unavailableDescription": "Vidimo non riesce a caricare le attività su questo dispositivo. Tocca Riprova per ricaricare l’app.",
      "unavailableTitle": "Al momento non è possibile mostrare le attività"
    },
    "waitsForClean": {
      "detail": "La camera è ancora da pulire. Inizia il ripasso quando è stata pulita.",
      "title": "In attesa della pulizia"
    }
  }
}
